import React, { useEffect, useState, useRef } from 'react'
import RightBarDataForOtherPages from '../Components/RightBarDataForOtherPages';
import { Grid, makeStyles } from "@material-ui/core";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import { ArrowBack, Delete, DetailsSharp } from '@mui/icons-material';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import useStyle from '../Css/MainCss';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import { CONFIG } from '../config'
import axios from 'axios';  
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ClockLoader } from 'react-spinners';
import EvaluateComponent1 from '../Components/EvaluateComponent1';
import EvaluateComponent from '../Components/EvaluateComponent';
import SavePageAs from '../Components/SavePageAs';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Close } from '@mui/icons-material';
import Draggable from 'react-draggable';
import RiskRegisterComponent from '../Components/RiskRegisterComponent';
import { green, red } from '@mui/material/colors';
import RiskHierarchyNew from '../Components/RiskHierarchyNew';
import AddQuestionComponent from '../Components/AddQuestionComponent';
import { DataGrid } from '@mui/x-data-grid';
import DMGRiskGptComponent3 from '../Components/DMGRiskGptComponentd3';
import "../Css/DmgRiskGpt.css";
import { Chip, Divider } from '@mui/material';
import parseHtml from 'html-react-parser';
import FinaliseRegisterComponent from '../Components/FinaliseRegisterComponent';
import Slide from '@mui/material/Slide';
import CircularWithValueLabel from '../Components/ProgressTimer';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { ArrowUpward } from '@mui/icons-material';
import RiskRegisterForMoreInfo from '../Components/RiskRegisterForMoreInfo';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VerifiedIcon from '@mui/icons-material/Verified';


const useStyles = makeStyles((theme) => ({
  right: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  pageTop: {
    marginTop: '115px',
  },
  pageBodyStyle: {

    paddingTop: '12px',
  },

}));

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: '13px'
  },
}));


function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const DmgRiskGpt3 = () => {

  const classes = useStyles();
  const classe = useStyle();
  const navigate = useNavigate();

  const [divHeight, setDivHeight] = React.useState('120');
  const [tableDivHeight, setTableDivHeight] = React.useState('190');
  const [tableHeight, setTableHeight] = React.useState(165);

  const wordstyle = 'wordStyle'

  const [ipAddress, setIpAddress] = React.useState('');

  React.useEffect(() => {
    console.log("+++++++++++window.screen.width+++++++++++++++")
    console.log(window.screen.width)
    console.log(window.screen.height)
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIpAddress(data.ip); 
        const myIp = data.ip;
        getSessionData(myIp);
        console.log('IP address:', myIp);
      })
      .catch(error => {
        console.log('Error fetching IP:', error)
        const myIp = "";
        getSessionData(myIp);
      });

    if (window.screen.height <= 800) {
      setDivHeight('240')
      setTableDivHeight('190')
      setTableHeight(165)
    } else {
      if (window.screen.height > 801 && window.screen.height <= 900) {
        setDivHeight('290')
        setTableDivHeight('240')
        setTableHeight(215)
      } else {
        setDivHeight('340')
        setTableDivHeight('290')
        setTableHeight(265)
      }
    }

    getAllRiskSchemas();
    
    getColors();
    blinkTextInit();

  }, [])

  function compareRegister(a, b) {
    var nameA = new Date(a.createdDate); // ignore upper and lowercase
    var nameB = new Date(b.createdDate); // ignore upper and lowercase
    if (nameA > nameB) {
      return -1;
    }
    if (nameA < nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  }



  function blinkTextInit() {
    setSecondStyle('typed');
    setTimeout(function () {
      setSecondStyle('blink-bg');
      /*
      setTimeout(function () {
        setSecondStyle('not-blink-bg');
      }, 5000);
      */
    }, 2000);

  }




  const [globalCentreId, setGlobalCentreId] = React.useState('');
  const [globalUserId, setGlobalUserId] = React.useState('');
  const [globalUserRoleId, setGlobalUserRoleId] = React.useState('');

  const [createUser, setCreateUser] = React.useState('');
  function getSessionData(ipAdd) {
    let data = sessionStorage.getItem('sessionstorage');
    data = JSON.parse(data);
    console.log("++++++++++++++++++++++11111data1111111");
    console.log(data)
    setGlobalUserId(data.userId);
    setGlobalUserRoleId(data.userRoleId);
    setCreateUser(data.name)
    setGlobalCentreId(data.centreId);
    getAllRegister(data.centreId, data.userId, data.userRoleId, ipAdd)
    getStandards(data.centreId);
    findTrialCentre(data.centreId);
    console.log(data)

  }

  const [isTrialCentre, setIsTrialCentre] = React.useState(false);

  function findTrialCentre(cId) {
    axios(CONFIG.MAIN_URL + `/trialCentreSetup/filter?centreId=` + cId, {
      method: 'get',
    })
      .then(function (res) {
        console.log("++++Trial Centre setup Details +++++++++++++++++");
        console.log(res.data);
        setLoading1(false);

        if (res.data.length > 0) {
          setIsTrialCentre(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading1(false);
      });
  }




  const [allRegister, setAllRegister] = useState([])
  const [canCreateRegister, setCanCreateRegister] = useState(false);
  const [canCreateRegisterFromRedo, setCanCreateRegisterFromRedo] = useState(false);
  const [redoCount, setRedoCount] = useState(0);

  const [trialDays, setTrialDays] = useState(0);
  const [trialNoOfRegistersCanCreate, setTrialNoOfRegistersCanCreate] = useState(0);
  const [trialEditRegisters, setTrialEditRegisters] = useState(false);
  const [trialFinaliseRegisters, setTrialFinaliseRegisters] = useState(false);
  const [trialDeleteRegisters, setTrialDeleteRegisters] = useState(false);
  const [trialRedoRegisters, setTrialRedoRegisters] = useState(false);
  const [trialNoOfCollectionCanCreate, setTrialCollectionCanCreate] = useState(0);
  const [trialEditQuestions, setTrialEditQuestions] = useState(false);



  function getAllRegister(centrId, loggedUserId, loggedUserRoleId, ipAdd, fromCreateRegiste) {
    if (fromCreateRegiste != undefined && fromCreateRegiste != null && fromCreateRegiste === "fromCreateRegiste") {
    } else {
      setLoading1(true)
    }
    if (loggedUserRoleId === "staff") {
      setCanCreateRegister(true);
      setCanCreateRegisterFromRedo(true);
    }
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        var regRtnData = response.data;
        //if (XXXXX === centrId) {
        axios(CONFIG.MAIN_URL + `/trialCentreSetup/filter?centreId=` + centrId, {
          method: 'get',
        })
          .then(function (res) {
            console.log("++++Trial Centre setup Details +++++++++++++++++");
            console.log(res.data);
            setLoading1(false);

            if (res.data.length > 0) {
              var tEditRegisters = false;
              var tFinaliseRegisters = false;
              var tDeleteRegisters = false;
              var tRedoRegisters = false;
              var tNoOfRegistersCanCreate = 0;
              res.data.forEach((item, index) => {
                if (index === 0) {
                  if (item.noOfTrialDays != undefined && item.noOfTrialDays != null && item.noOfTrialDays > 0) {
                    setTrialDays(item.noOfTrialDays);
                  }
                  if (item.noOfRegistersCanCreate != undefined && item.noOfRegistersCanCreate != null && item.noOfRegistersCanCreate > 0) {
                    setTrialNoOfRegistersCanCreate(item.noOfRegistersCanCreate);
                    tNoOfRegistersCanCreate = item.noOfRegistersCanCreate;
                  }
                  if (item.editRegisters != undefined && item.editRegisters != null && item.editRegisters === "yes") {
                    setTrialEditRegisters(true);
                    tEditRegisters = true;

                  }
                  if (item.finaliseRegisters != undefined && item.finaliseRegisters != null && item.finaliseRegisters === "yes") {
                    setTrialFinaliseRegisters(true);
                    tFinaliseRegisters = true;
                  }
                  if (item.deleteRegisters != undefined && item.deleteRegisters != null && item.deleteRegisters === "yes") {
                    setTrialDeleteRegisters(true);
                    tDeleteRegisters = true;
                  }
                  if (item.redoRegisters != undefined && item.redoRegisters != null && item.redoRegisters === "yes") {
                    setTrialRedoRegisters(true);
                    tRedoRegisters = true;
                  }
                  if (item.noOfCollectionCanCreate != undefined && item.noOfCollectionCanCreate != null && item.noOfCollectionCanCreate > 0) {
                    setTrialCollectionCanCreate(item.noOfCollectionCanCreate);
                  }
                }
              })
              var realRegCount = 0;
              var realRedoRegCount = 0;
              console.log("+++++++++++++++regRtnData+++++++++++++++++++++++");
              console.log(regRtnData);
              
              regRtnData.forEach((item) => {
                
                
                if (item.centreId === centrId) {
                  if (loggedUserRoleId === "staff") {
                    item["canFinalise"] = true;
                    item["canCreateCollections"] = true;
                    item["canEdit"] = true;
                    item["canDelete"] = true;
                    arr.push(item)
                  } else {
                    if (loggedUserId === item.createdUserId) {
                      if (loggedUserId === "guest1"){
                        if (item.createdUserIpAddress === ipAdd){
                          if (item.status === "Draft") {
                            if (item.parentRegisterid != undefined && item.parentRegisterid != null) {
                              realRedoRegCount++;
                            } else {
                              realRegCount++;
                            }
                          }
                          item["canFinalise"] = tFinaliseRegisters;
                          item["canCreateCollections"] = true;
                          item["canEdit"] = tEditRegisters;
                          item["canDelete"] = tDeleteRegisters;
                          arr.push(item)
                        }

                      }else{
                      
                        if (item.status === "Draft") {
                          if (item.parentRegisterid != undefined && item.parentRegisterid != null) {
                            realRedoRegCount++;
                          } else {
                            realRegCount++;
                          }
                        }
                        item["canFinalise"] = tFinaliseRegisters;
                        item["canCreateCollections"] = true;
                        item["canEdit"] = tEditRegisters;
                        item["canDelete"] = tDeleteRegisters;
                        arr.push(item)
                      }
                    }
                  }
                }
              })

              if (loggedUserRoleId != "staff") {
                console.log("+++++++++++++++++XXXXX++++++++++++++++++++");
                console.log(tNoOfRegistersCanCreate);
                console.log(realRegCount);
                console.log("+++++++++++++++++YYYYYYY++++++++++++++++++++");
                if (tNoOfRegistersCanCreate > 0 && realRegCount < (parseInt(tNoOfRegistersCanCreate) - 1)) {
                  if (loggedUserId === "guest1"){
                    if (realRegCount < 1){
                      setCanCreateRegister(true);
                    }else{
                      setCanCreateRegister(false);
                    }
                  }else{  
                    setCanCreateRegister(true);
                  }
                } else {
                  setCanCreateRegister(false);
                }
                if (tNoOfRegistersCanCreate > 0 && realRedoRegCount < (parseInt(tNoOfRegistersCanCreate) - 1)) {
                  setCanCreateRegisterFromRedo(true);
                  setRedoCount(realRedoRegCount);
                } else {
                  setRedoCount(realRedoRegCount);
                  setCanCreateRegisterFromRedo(false);
                }
              }

              arr = arr.sort(compareRegister);
              console.log("++++++++++++++++++++Trial 222222arr222222 Trial++++++++++++++++")
              console.log(arr)
              setAllRegister(arr);
            } else {
              regRtnData.forEach((item) => {
                if (item.centreId === centrId) {
                  if (loggedUserRoleId === "staff") {
                    item["canFinalise"] = true;
                    item["canCreateCollections"] = true;
                    item["canEdit"] = true;
                    item["canDelete"] = true;
                    arr.push(item)
                  } else {
                    if (loggedUserId === item.createdUserId) {
                      item["canFinalise"] = true;
                      item["canCreateCollections"] = true;
                      item["canEdit"] = true;
                      item["canDelete"] = true;
                      arr.push(item)
                    } else {
                      item["canFinalise"] = false;
                      item["canCreateCollections"] = false;
                      item["canEdit"] = false;
                      item["canDelete"] = false;
                      arr.push(item)
                    }
                  }
                }
              })
              console.log(arr)

              axios(CONFIG.MAIN_URL + `/userRights/filter?centreId=` + centrId, {
                method: 'get',
              })
                .then(function (res) {
                  setLoading1(false);
                  console.log("Return All Rights Assigned Users");
                  console.log(res.data);
                  var rtnData = res.data
                  var canFinalise = true;
                  var canCreateCollections = true;
                  var canDelete = true;

                  rtnData.forEach((tData) => {
                    if (tData.userCode === loggedUserId) {
                      if (tData.createNewRegister === "Yes") {
                        setCanCreateRegister(true);
                        setCanCreateRegisterFromRedo(true);
                      }
                    }
                  })
                  arr.forEach((item) => {
                    var found = false;
                    rtnData.forEach((tData) => {
                      if (tData.userCode === loggedUserId) {
                        found = true;
                        tData.registersAllowedToAmend.forEach((item2) => {
                          if (item2.regsiterId === item.id) {
                            item["canEdit"] = true;
                            if (item2.allowFinaliseRegisters === "Yes") {
                              item["canFinalise"] = true;
                            }
                            if (item2.allowCreateCollections === "Yes") {
                              item["canCreateCollections"] = true;
                            }
                            if (item2.allowDeleteRegisters === "Yes") {
                              item["canDelete"] = true;
                            }


                          }
                        })
                      }
                    })
                  })
                  arr = arr.sort(compareRegister);

                  console.log("++++++++++++++++++++222222arr222222++++++++++++++++")
                  console.log(arr)
                  setAllRegister(arr);
                })
                .catch(function (error) {
                  setLoading1(false);
                  console.log(error);
                });

            }














          })
          .catch(function (error) {
            console.log(error);
            setLoading1(false);
          });
        /*    
        } else {
          regRtnData.forEach((item) => {
            if (item.centreId === centrId) {
              if (loggedUserRoleId === "staff") {
                item["canFinalise"] = true;
                item["canCreateCollections"] = true;
                item["canEdit"] = true;
                item["canDelete"] = true;
                arr.push(item)
              } else {
                if (loggedUserId === item.createdUserId) {
                  item["canFinalise"] = true;
                  item["canCreateCollections"] = true;
                  item["canEdit"] = true;
                  item["canDelete"] = true;
                  arr.push(item)
                } else {
                  item["canFinalise"] = false;
                  item["canCreateCollections"] = false;
                  item["canEdit"] = false;
                  item["canDelete"] = false;
                  arr.push(item)
                }
              }
            }
          })
          console.log(arr)

          axios(CONFIG.MAIN_URL + `/userRights/filter?centreId=` + centrId, {
            method: 'get',
          })
            .then(function (res) {
              setLoading1(false);
              console.log("Return All Rights Assigned Users");
              console.log(res.data);
              var rtnData = res.data
              var canFinalise = true;
              var canCreateCollections = true;
              var canDelete = true;

              rtnData.forEach((tData) => {
                if (tData.userCode === loggedUserId) {
                  if (tData.createNewRegister === "Yes") {
                    setCanCreateRegister(true);
                    setCanCreateRegisterFromRedo(true);
                  }
                }
              })
              arr.forEach((item) => {
                var found = false;
                rtnData.forEach((tData) => {
                  if (tData.userCode === loggedUserId) {
                    found = true;
                    tData.registersAllowedToAmend.forEach((item2) => {
                      if (item2.regsiterId === item.id) {
                        item["canEdit"] = true;
                        if (item2.allowFinaliseRegisters === "Yes") {
                          item["canFinalise"] = true;
                        }
                        if (item2.allowCreateCollections === "Yes") {
                          item["canCreateCollections"] = true;
                        }
                        if (item2.allowDeleteRegisters === "Yes") {
                          item["canDelete"] = true;
                        }


                      }
                    })
                  }
                })
              })
              arr = arr.sort(compareRegister);

              console.log("++++++++++++++++++++222222arr222222++++++++++++++++")
              console.log(arr)
              setAllRegister(arr);
            })
            .catch(function (error) {
              setLoading1(false);
              console.log(error);
            });

        }
        */



      })
      .catch(function (error) {
        setLoading1(false)
        console.log(error);
      });
  }



  const [colorPatterns, setColorPatterns] = React.useState([])

  function getColors() {
    axios(CONFIG.MAIN_URL + CONFIG.CONTROLLER_NAME_FOR_SLIDER_COLOR + "/all", {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("+++++++++++++++++All colors++++++++++++++++++");
        console.log(response.data);
        setColorPatterns(response.data);

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [PageName, setPageName] = useState('DMG Risk Gpt')

  const [headerInfoMessage, setheaderInfoMessage] = useState("Create Templates For Schemas");

  const [selectedSchemaId, setSelectedSchemaId] = React.useState('');
  const [selectedSchemaName, setSelectedSchemaName] = React.useState('');

  const [allAvailableRiskSchemas, setAllAvailableRiskSchemas] = React.useState([]);

  function getAllRiskSchemas() {
    axios(CONFIG.MAIN_URL + `/schemaformat/all`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("All Risk Schemas Returns");
        console.log(response.data);
        setAllAvailableRiskSchemas(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleChangeSelectedSchema = (event) => {
    setSelectedSchemaId(event.target.value);
    allAvailableRiskSchemas.forEach((data, index) => {
      if (data.id === event.target.value) {
        setSelectedSchemaName(data.name);
      }
    })
  }

  const [step1, setStep1] = React.useState(false);
  const [step2, setStep2] = React.useState(false);
  const [step3, setStep3] = React.useState(false);
  const [step4, setStep4] = React.useState(false);
  const [step5, setStep5] = React.useState(false);
  const [step51, setStep51] = React.useState(false);
  const [step6, setStep6] = React.useState(false);
  const [step7, setStep7] = React.useState(false);

  const [sendMessageField, setSendMessageField] = React.useState();

  const handleSendMessage = (event) => {
    setSendMessageField(event.target.value);
  };

  const [headerMessage, setHeaderMessage] = React.useState('');


  const [qaArray, setQaArray] = React.useState([]);

  const scrollRef = useRef(null);
  const scrollRef1 = useRef(null);

  const [firstStyle, setFirstStyle] = React.useState('');
  const [secondStyle, setSecondStyle] = React.useState('');
  const [initStyle, setInitStyle] = React.useState('blink-bg');

  function blinkText() {
    setFirstStyle('typed');
    setSecondStyle('fontColorWhite');
    setTimeout(function () {
      setSecondStyle('typed');
      setTimeout(function () {
        setSecondStyle('blink-bg');
        setFirstStyle('');
      }, 3000);
    }, 2000);

  }
  function textFieldClickBlinkStop() {
    setSecondStyle('not-blink-bg');


  }




  const registerArrayQa = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div ref={scrollRef} style={{ overflowY: 'scroll', overflowX: 'hidden', height: `${divHeight}px`, width: '100%' }}>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table" style={{ border: '1px solid #ddd' }}>
              <TableBody>
                {qaArray.map((data, index) => (
                  <>

                    <StyledTableRow key={0} className={classes.tableTrStyle}>
                      <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%' }}>
                        <div style={{ whiteSpace: 'normal' }}>
                          <BootstrapTooltip title='Risk GPT'>
                            <Avatar sx={{ bgcolor: red[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                              <span className={wordstyle}>RG</span>
                            </Avatar>
                          </BootstrapTooltip>
                        </div>
                      </StyledTableCell>
                      {qaArray.length - 1 === index || qaArray.length === 1 ?
                        <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                          <p className={`${secondStyle} ${wordstyle}`} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{parseHtml(data.q)}</span></p>
                        </StyledTableCell>
                        :
                        <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                          <p className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle}>{parseHtml(data.q)}</span></p>
                        </StyledTableCell>
                      }
                      <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%' }}>
                        <div style={{ whiteSpace: 'normal' }}>
                          <BootstrapTooltip title={createUser}>
                            <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                              <span className={wordstyle}>{createUser.substr(0, 2)}</span>
                            </Avatar>
                          </BootstrapTooltip>
                        </div>
                      </StyledTableCell>
                      {qaArray.length - 2 === index || qaArray.length === 1 ?
                        <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                          {data.a != undefined && data.a != null ?
                            <p className={`${firstStyle} ${wordstyle}`}>
                              {data.a.map((item) => (
                                <>
                                  {item.label != undefined && item.label != null ?
                                    <span className='wordstyle' style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle} >{parseHtml(item.label)}</span></span>
                                    :
                                    ''
                                  }
                                  {item.var != undefined && item.var != null ?
                                    <i className='wordstyle' ><span className='wordstyle' style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle} >{parseHtml(item.var)}</span></span></i>
                                    :
                                    ''
                                  }
                                </>
                              ))}

                            </p>
                            :
                            ''
                          }

                        </StyledTableCell>
                        :
                        <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                          {data.a != undefined && data.a != null ?
                            <p>
                              {data.a.map((item) => (
                                <>
                                  {item.label != undefined && item.label != null ?
                                    <span className={wordstyle} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle} >{parseHtml(item.label)} </span></span>
                                    :
                                    ''
                                  }
                                  {item.var != undefined && item.var != null ?
                                    <i><span style={{ fontWeight: 600, lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}><span className={wordstyle} >{parseHtml(item.var)}</span> </span></i>
                                    :
                                    ''
                                  }
                                </>
                              ))}
                            </p>
                            :
                            ''
                          }


                        </StyledTableCell>
                      }

                    </StyledTableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </Grid>
  )




  const registerArrayAa = (
    <>
      {/** 
    <div ref={scrollRef1} style={{ overflowY: 'scroll', overflowX: 'hidden', height: `${divHeight}px`, width: '100%' }}>
      <Grid container spacing={2}>
        {qaArray.map((data, index) => (
          <>
            {data.a != undefined && data.a != null ?
              <>
                <Grid item xs={1} style={{ background: '#f7f7f8', borderTop: '1px solid #e5e5e5', borderBottom: '1px solid #dededf ' }}>
                  <BootstrapTooltip title={createUser}>
                    <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                      {createUser.substr(0, 2)}
                    </Avatar>
                  </BootstrapTooltip>
                </Grid>
                {index === qaArray.length - 1 ?
                  <Grid item xs={11} style={{ background: '#f7f7f8', borderTop: '1px solid #e5e5e5', borderBottom: '1px solid #dededf' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <p className={firstStyle} style={{ fontWeight: 600, fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}> {data.a}</p>
                      </Grid>
                    </Grid>
                  </Grid>
                  :
                  <Grid item xs={11} style={{ background: '#f7f7f8', borderTop: '1px solid #e5e5e5', borderBottom: '1px solid #dededf' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <p className={firstStyle}>

                          {data.a.map((item, index) => (
                            <>
                              {item.label != undefined && item.label != null ?
                                <span style={{ fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{item.label}</span>
                                :
                                ''
                              }
                              {item.var != undefined && item.var != null ?
                                <i><span style={{ fontWeight: 600, fontSize: '1.0rem', lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>{item.var}</span></i>
                                :
                                ''
                              }
                            </>
                          ))}
                        </p>
                      </Grid>
                    </Grid>
                  </Grid>
                }
              </>
              :
              ''}
          </>
        ))}
      </Grid>
    </div>
    */}
    </>

  )







  const handleButtonStep1Click = () => {
    blinkText();

    var messageField = "";
    var ele = document.getElementById("txtSendMessageField");

    if (ele != undefined && ele != null) {
      if (isNaN(ele.value)) {
        alert("Please enter 1 OR 2");
        return
      }
      messageField = ele.value;
      setSendMessageField(ele.value)
    } else {
      messageField = sendMessageField;
    }

    if (messageField === '1') {
      if (startAgain) {
        if (!canCreateRegisterFromRedo) {
          if (isTrialCentre) {
            alert("Sorry!. You have already created " + redoCount + " re-do register(s) and you are not allowed to re-do any more new Registers")
            return;
          }
        }
      } else {
        if (!canCreateRegister) {
          if (isTrialCentre) {
            alert("Sorry!. You have already created " + "1" + " register and you are not allowed to create any more new Registers")
            return;
          } else {
            alert("Sorry!. You Are not allowed to create a new Register")
            return;
          }
        }
      }

      setStep1(true);
      setHeaderMessage('You are creating a risk Register. ')
      var objQa = {}
      var arrQa = qaArray;
      if (startAgain) {
        arrQa.forEach((data, itemIndex) => {
          if (itemIndex + 1 === 2) {
            var arrX = [];
            var objX = {}
            objX["label"] = "You have selected ";
            arrX.push(objX);
            objX = {}
            objX["var"] = "1";
            arrX.push(objX);
            objX = {}
            objX["label"] = " to re-create a risk register";
            arrX.push(objX);
            data["a"] = arrX;
          }
        })
        objQa = {}
        objQa["id"] = 2;
        objQa["q"] = "Register Name.?"
        arrQa.push(objQa)
        setQaArray(arrQa)

        console.log(startAgainRegisterObj);

        if (startAgainRegisterObj != null && startAgainRegisterObj.name != undefined && startAgainRegisterObj.name != null){
          setRegisterName(startAgainRegisterObj.name);
        }else{
          setRegisterName(reGenerateRegisterName);
        }
        setDisplayStartAgainTextBox(true);

      } else {
        if (!startAgain) {
          objQa["id"] = 1;
          objQa["q"] = `<p className="${wordstyle}">Create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?.</p>`
        }
        var arrX = [];
        var objX = {}
        objX["label"] = "You have selected "
        arrX.push(objX);
        objX = {}
        objX["var"] = "1";
        arrX.push(objX);
        objX = {}
        objX["label"] = " to create risk register";
        arrX.push(objX);
        objQa["a"] = arrX;
        arrQa.push(objQa)
        objQa = {}
        objQa["id"] = 2;
        objQa["q"] = " Register Name.? "
        arrQa.push(objQa)
        setQaArray(arrQa)
      }
    } else {
      if (messageField === '2') {
        if (startAgain) {

          //console.log(startAgainRegisterObj);
          //console.log(startAgainRegisterId);

          setSelectedRegisterDataObj(startAgainRegisterObj);
          setSelectedRegisteredId(startAgainRegisterId);
          setOpenRiskHierarchyComponent(true)
          setOpenRiskHierarchyComponentScroll('paper')


        } else {
          setStep1(true);
          var objQa = {}
          var arrQa = qaArray;
          objQa["id"] = 1;
          objQa["q"] = `<p className="${wordstyle}">Create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?.</p>`
          var arrX = [];
          var objX = {}
          objX["label"] = "You have selected ";
          arrX.push(objX);
          objX = {}
          objX["var"] = "2";
          arrX.push(objX);
          objX = {}
          objX["label"] = " to create risk Hierarchy";
          arrX.push(objX);
          objQa["a"] = arrX;
          arrQa.push(objQa)
          objQa = {}
          objQa["id"] = 2;
          objQa["q"] = "Enter your Hierarchy Key."
          arrQa.push(objQa)
          setQaArray(arrQa)
        }
      } else {
        alert("Invalid Number. Please select 1 OR 2")
      }
    }

  };

  const [registerName, setRegisterName] = React.useState('');
  const handleChangeRegisterName = (event) => {
    setRegisterName(event.target.value);
  };

  const handleButtonStep2ClickPre = () => {
    setSendMessageField('')
    setStep1(false);
    setStep2(false);
    setHideSeletion(false);
    console.log(qaArray);
    if (startAgain) {
      setDisplayStartAgainTextBox(false)
      qaArray.pop();
      var tArr = [];
      qaArray.forEach((item, index) => {
        var obj = {};
        if (index === 0){
          obj["id"] = item.id;
          obj["q"] = item.q;
          obj["a"] = item.a;
          tArr.push(obj);
        }else{
          obj["id"] = item.id;
          obj["q"] = item.q;
          tArr.push(obj);
        }
      })
      setQaArray(tArr);
    } else {
      qaArray.pop();
      qaArray.pop();
      setQaArray(qaArray);
    }
    setSendMessageField("1")
  };

  const handleButtonStep2Click = () => {
    blinkText();

    var ele = document.getElementById("txtRegisterName");
    if (ele != undefined && ele != null) {
      if (ele.value === '') {
        alert("Please assign a Register Name");
        return;
      }
      setRegisterName(ele.value)
    }

    setStep2(true);
    var str = headerMessage;
    if (ele != undefined && ele != null) {
      str = str + "Name " + ele.value;
    } else {
      str = str + "Name " + registerName;
    }
    setHeaderMessage(str);

    var objQa = {}
    var arrQa = qaArray;
    var checkNo = 2;
    if (startAgain) {
      checkNo = 3;
    }
    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === checkNo) {
        var arrX = [];
        var objX = {};
        objX["label"] = "";
        arrX.push(objX);
        objX = {};
        if (ele != undefined && ele != null) {
          objX["var"] = ele.value;
        } else {
          objX["var"] = registerName;
        }
        arrX.push(objX);
        data["a"] = arrX;
      }
    })

    objQa = {}
    objQa["id"] = 3;
    objQa["q"] = "Register Description.?"
    arrQa.push(objQa)
    setQaArray(arrQa)
    if (startAgain) {
      if (startAgainRegisterObj != null && startAgainRegisterObj.description != undefined && startAgainRegisterObj.description != null){
        setRegisterDescription(startAgainRegisterObj.description);
      }else{
        setRegisterDescription(reGenerateRegisterDescription);
      }
    }

    //setDivHeight('150');
  };

  const [registerDescription, setRegisterDescription] = React.useState('');
  const handleChangeRegisterDescription = (event) => {
    setRegisterDescription(event.target.value);
  };

  const handleButtonStep3ClickPre = () => {
    setStep2(false);
    console.log(qaArray);
    qaArray.pop();
      var tArr = [];
      qaArray.forEach((item, index) => {
        var obj = {};
        if (qaArray.length === (index + 1)){
          obj["id"] = item.id;
          obj["q"] = item.q;
          tArr.push(obj);
        }else{
          obj["id"] = item.id;
          obj["q"] = item.q;
          obj["a"] = item.a;
          tArr.push(obj);
        }
      })
      setQaArray(tArr);
    
    setRegisterName(registerName)
  };

  const handleButtonStep3Click = () => {

    blinkText();

    var ele = document.getElementById("txtRegisterDescription");
    if (ele != undefined && ele != null) {
      if (ele.value === '') {
        alert("Please assign a Register Description");
        return;
      }
      setRegisterDescription(ele.value);
    }
    setStep3(true);
    var str = headerMessage;
    if (ele != undefined && ele != null) {
      str = str + " and Description " + ele.value + '.';
    } else {
      str = str + " and Description " + registerDescription + '.';
    }
    setHeaderMessage(str);

    var objQa = {}
    var arrQa = qaArray;
    var checkNo = 3;
    if (startAgain) {
      checkNo = 4;
    }
    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === checkNo) {
        var arrX = [];
        var objX = {};
        objX["label"] = "";
        arrX.push(objX);
        objX = {};
        if (ele != undefined && ele != null) {
          objX["var"] = ele.value;
        } else {
          objX["var"] = registerDescription;
        }
        arrX.push(objX);
        data["a"] = arrX;
      }
    })

    objQa = {};
    objQa["id"] = 4;
    objQa["q"] = "Register Sections (Separate With ;)"
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('200');

    if (startAgain) {
      if (startAgainRegisterObj != null && startAgainRegisterObj.riskRegister != undefined && startAgainRegisterObj.riskRegister != null){
        var sectionStr = "";
        startAgainRegisterObj.riskRegister.forEach((data, index) => {
          if (data.section != undefined && data.section != null && data.section != '') {
            if (index === 0) {
              sectionStr += data.section.trim();
            } else {
              sectionStr += "; " + data.section.trim();
            }
          }
        })
        setSectionHeadingName(sectionStr);
        }else{
          setSectionHeadingName(reGenerateSectionNames);
        }
    }

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };


  //SECTION SECTION
  const [sectionHeadingName, setSectionHeadingName] = React.useState('');
  const [registerSectionsNames, setRegisterSectionsNames] = React.useState('')
  const onChangeSectionHeadingName = (event) => {
    //alert("setRegisterSectionsNames(str)")
    setSectionHeadingName(event.target.value);
  };
  const [registerArray, setRegisterArray] = useState([]);
  function clearSection() {
    setSectionHeadingName('')

  }
  function clickSectionMore() {
    blinkText();

    if (sectionHeadingName === '') {
      alert('please enter section name')
      return
    }

    buildRegisterArray();
    clearSection()
    setSectionHeadingMessage('Enter your Next Register heading section')

    var str = headerMessage
    var tmpStr = ''
    if (registerArray.length === 1) {
      tmpStr += " The register section is " + registerArray[0].section
      if (registerArray[0].risks != undefined && registerArray[0].risks != null && registerArray[0].risks.length > 0) {
        registerArray[0].risks.forEach((data, index) => {
          if (index === 0) {
            tmpStr += " with risk type " + data.description
          } else {
            tmpStr += " ," + data.description
          }
        })
      } else {
        tmpStr += ".";
      }

    } else {
      tmpStr += " The register sections are "
      registerArray.forEach((data, index) => {
        if (index === 0) {
          tmpStr += data.section
        } else {
          tmpStr += ", " + data.section
        }
        if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
          data.risks.forEach((data1, index1) => {
            if (index1 === 0) {
              tmpStr += " with risk type " + data1.description
            } else {
              tmpStr += " ," + data1.description
            }
          })
        }

      })
    }

    var objQa = {}
    var arrQa = qaArray;


    var arrX = [];
    var objX = {};
    objX["label"] = "Section heading is ";
    arrX.push(objX);
    objX = {};
    objX["var"] = sectionHeadingName;
    arrX.push(objX);
    objQa["a"] = arrX;


    //objQa["a"] = "Your have entered \"" + sectionHeadingName + "\" as the section heading";
    arrQa.push(objQa)
    objQa = {}
    objQa["q"] = "Next Section OR Press \"NEXT\" to Enter Risks"
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  }

  function buildRegisterArray(names) {
    var arr = registerArray
    var tmpArr = names.split(";");
    tmpArr.forEach((data, index) => {
      var obj = {};
      obj["section"] = data.trim();;
      arr.push(obj)
    })
    setRegisterArray(arr)

   
    console.log(registerArray)
  }


  const [sectionCount, setSectionCount] = useState(5);

  function addingSectionFinishButtonPre() {
    setStep3(false);
    console.log(qaArray);
    qaArray.pop();
      var tArr = [];
      qaArray.forEach((item, index) => {
        var obj = {};
        if (qaArray.length === (index + 1)){
          obj["id"] = item.id;
          obj["q"] = item.q;
          tArr.push(obj);
        }else{
          obj["id"] = item.id;
          obj["q"] = item.q;
          obj["a"] = item.a;
          tArr.push(obj);
        }
      })
      setQaArray(tArr);
    setRegisterDescription(registerDescription)
  };
  function addingSectionFinishButton() {
    blinkText();

    var ele = document.getElementById("txtSectionHeadingName")

    if (ele != undefined && ele != null) {
      if (ele.value === '') {
        alert('please enter at least one section name')
        return;
      }
      var tmpArr = ele.value.split(";");
      if (tmpArr.length > 10) {
        alert('The maximum number of sections you can enter is 10. Please limit it to 10 sections.')
        return;
      }

      setSectionHeadingName(ele.value)

      setRegisterSectionsNames(ele.value);
      //alert(ele.value)
      
      buildRegisterArray(ele.value);
    } else {
      buildRegisterArray(sectionHeadingName);
    }

    var objQa = {}
    var arrQa = qaArray;
    var checkNo = 4;
    if (startAgain) {
      checkNo = 5;
    }

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === checkNo) {
        var arrX = [];
        var objX = {};
        objX["label"] = "";
        arrX.push(objX);
        objX = {};
        if (ele != undefined && ele != null) {
          objX["var"] = ele.value;
        } else {
          objX["var"] = sectionHeadingName;
        }
        arrX.push(objX);
        data["a"] = arrX;
      }
    });

    setRiskSectionName("Enter risk type for " + registerArray[0].section)
    setRiskSectionId(registerArray[0].section)
    objQa = {}
    objQa["id"] = sectionCount;
    objQa["q"] = `Enter further Risks for <i><span className="${wordstyle}" style='font-weight: 600;line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>${registerArray[0].section}</span></i><span className="${wordstyle}" style='line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'> (Separate with ;) OR "FINISH" to auto Generate Register</span>`;

    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('240');

    if (startAgain) {
      if (startAgainRegisterObj != null && startAgainRegisterObj.riskRegister != undefined && startAgainRegisterObj.riskRegister != null){
      startAgainRegisterObj.riskRegister.forEach((data) => {
        if (data.section.trim() === registerArray[0].section.trim()) {
          var riskStr = "";
          if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
            var countNo = 0
            data.risks.forEach((item, index) => {
              if (item.name != undefined && item.name != null) {
                if (countNo === 0) {
                  riskStr += item.name.trim();
                } else {
                  riskStr += "; " + item.name.trim();
                }
                countNo++;
              }
            })
          }
          setRiskDescription(riskStr);

        }
      })
      }

    }


    setStep4(true);

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  }


  //risk SECTION

  const [riskSectionId, setRiskSectionId] = React.useState('');
  const [riskSectionName, setRiskSectionName] = React.useState('');
  const [riskDescription, setRiskDescription] = React.useState('');

  const onChangeRiskDescription = (event) => {
    setRiskDescription(event.target.value);
  };

  function riskClear() {
    setRiskDescription('')
  }

  function riskFinishPre() {
    setStep4(false);
    console.log(qaArray);
    qaArray.pop();
      var tArr = [];
      qaArray.forEach((item, index) => {
        var obj = {};
        if (qaArray.length === (index + 1)){
          obj["id"] = item.id;
          obj["q"] = item.q;
          tArr.push(obj);
        }else{
          obj["id"] = item.id;
          obj["q"] = item.q;
          obj["a"] = item.a;
          tArr.push(obj);
        }
      })
      setQaArray(tArr);
      var mStr = "";
      registerArray.forEach((item, index) => {
        if (index === 0 ){
          mStr += item.section;
        }else{
          mStr += "; " + item.section;
        }
      })
      setRegisterSectionsNames(mStr)
      setRegisterArray([]);
    
  }
  function riskFinish() {

    blinkText();
    var foundRiskHierarchy = false
    if (riskDescription != '') {
      buildRiskArrayWithSection()
      riskClear()
      var objQa = {}
      var arrQa = qaArray;

      var checkNo = sectionCount;
      if (startAgain) {
        checkNo = sectionCount + 1;
      }

      arrQa.forEach((data, itemIndex) => {
        if (itemIndex + 1 === checkNo) {
          var arrX = [];
          var objX = {};
          objX["label"] = "";
          arrX.push(objX);
          objX = {};
          objX["var"] = riskDescription;
          arrX.push(objX);
          objX = {};
          objX["label"] = "";
          arrX.push(objX);
          data["a"] = arrX;
        }
      })

      setQaArray(arrQa)
      //setDivHeight('240');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

    }

    registerArray.forEach((data, index) => {
      if (data.section === riskSectionId) {
        if (index + 1 >= registerArray.length) {
          finalizeReg()
        } else {
          // setHeaderMessage('You are creating a risk for ' + registerArray[index + 1].section)
          setRiskSectionName("Enter risk type for " + registerArray[index + 1].section)
          setRiskSectionId(registerArray[index + 1].section)
          var objQa = {}
          var arrQa = qaArray;
          objQa = {}
          objQa["id"] = sectionCount;
          objQa["q"] = "Enter further Risks for <i><span style='font-weight: 600;font-size: 1rem; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'>" + registerArray[index + 1].section + "</span></i><span style='font-size: 1rem; line-height: 1.2rem; font-family: Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular;'> (Separate with ;) OR \"FINISH\" to auto Generate Register</span>"
          arrQa.push(objQa)
          setQaArray(arrQa)

          if (startAgain) {
            if (startAgainRegisterObj != null && startAgainRegisterObj.riskRegister != undefined && startAgainRegisterObj.riskRegister != null){
            startAgainRegisterObj.riskRegister.forEach((data1) => {
              if (data1.section.trim() === registerArray[index + 1].section.trim()) {
                var riskStr = "";
                if (data1.risks != undefined && data1.risks != null && data1.risks.length > 0) {
                  var countNo = 0
                  data1.risks.forEach((item) => {
                    if (item.name != undefined && item.name != null) {
                      if (countNo === 0) {
                        riskStr += item.name.trim();
                      } else {
                        riskStr += "; " + item.name.trim();
                      }
                      countNo++;
                    }
                  })
                }
                setRiskDescription(riskStr);

              }
            })
            }

          }


          //setDivHeight('240');
        }
      }
    })

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);


  }

  function buildRiskArrayWithSection() {

    var tmpArr = riskDescription.split(";");
    tmpArr.forEach((item) => {
      var obj = {};
      obj["description"] = item.trim();
      obj["name"] = item.trim();
      registerArray.forEach((data, index) => {
        if (data.section === riskSectionId) {
          if (registerArray[index + 1] != undefined && registerArray[index + 1] != null) {
            setNextRiskSectionId(registerArray[index + 1].section)
          } else {
            setNextRiskSectionId('')
          }
          var risksArr = []
          if (data.risks != undefined && data.risks != null) {
            risksArr = data.risks
            risksArr.push(obj)
          } else {
            risksArr.push(obj)
          }
          data["risks"] = risksArr
        }
      })

    })


  }


  const [nextRiskSectionId, setNextRiskSectionId] = React.useState('');


  function riskMore() {
    blinkText();
    if (riskDescription === '') {
      alert('please enter description')
      return
    }
    buildRiskArrayWithSection()
    riskClear()





    var str = headerMessage
    var tmpStr = ''
    if (registerArray.length === 1) {
      tmpStr += " The register section is " + registerArray[0].section
      if (registerArray[0].risks != undefined && registerArray[0].risks != null && registerArray[0].risks.length > 0) {
        registerArray[0].risks.forEach((data, index) => {
          if (index === 0) {
            tmpStr += " with risk type " + data.description
          } else {
            tmpStr += " ," + data.description
          }
        })
      } else {
        tmpStr += ".";
      }

    } else {
      tmpStr += " The register sections are "
      registerArray.forEach((data, index) => {
        if (index === 0) {
          tmpStr += data.section
        } else {
          tmpStr += ", " + data.section
        }
        if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
          data.risks.forEach((data1, index1) => {
            if (index1 === 0) {
              tmpStr += " with risk type " + data1.description
            } else {
              tmpStr += " ," + data1.description
            }
          })
        }

      })
    }



    var nextSectionId = "";
    registerArray.forEach((data, index) => {
      if (data.section === riskSectionId) {
        if (registerArray[index + 1] != undefined && registerArray[index + 1] != null) {
          nextSectionId = registerArray[index + 1].section;
        }
      }
    })




    var objQa = {}
    var arrQa = qaArray;

    var arrX = [];
    var objX = {};
    objX["label"] = "Your have entered ";
    arrX.push(objX);
    objX = {};
    objX["var"] = riskDescription;
    arrX.push(objX);
    objX = {};
    objX["label"] = " as a Risk for ";
    arrX.push(objX);
    objX = {};
    objX["var"] = riskSectionId;
    arrX.push(objX);
    objQa["a"] = arrX;


    //objQa["a"] = "Your have entered \"" + riskDescription + "\" as a Risk for \"" + riskSectionId + "\"";
    arrQa.push(objQa)
    objQa = {}
    //Enter the Next Risk for "Procument" OR Press "DONE" for Next Section "Show variable" or "FINISH" to create the register
    if (nextSectionId != '') {
      objQa["q"] = "Enter the Risk for \"" + riskSectionId + "\" OR Press \"NEXT\" for Next Section \"" + nextSectionId + "\".\nOR Press \"FINISH\" to create the register."
    } else {
      objQa["q"] = "Enter the Risk for \"" + riskSectionId + "\" OR Press \"NEXT\" Or \"FINISH\" to create the risk register "
    }

    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);


  }

  const [finalJson, setFinalJson] = React.useState('')

  const [sectionHeadingMessage, setSectionHeadingMessage] = React.useState('Enter your Register sections')


  const [noOfRiskHierarchies, setNoOfRiskHierarchies] = React.useState(3)
  

  const [fromNoOfRiskHierarchiesState, setFromNoOfRiskHierarchiesState] = React.useState(false)
  function onClickNoOfRiskHierarchies() {
    blinkText();

    var ele = document.getElementById("txtNoOfRiskHierarchies");
    if (isNaN(ele.value) || ele.value === "") {
      alert("Invalid number. Please enter no of Risk Hierarchies per a Section")
      return;
    }
    if (parseInt(ele.value) > 8) {
      alert("The maximum number of risk hierarchies you can enter is 8. Please limit it to 8 risk hierarchies.")
      return;
    }
    var msg = "";
    var canContinue = true;
    var secCount = registerArray.length;
    var riCount = parseInt(ele.value);
    if (secCount === 10) {
      if (riCount > 2) {
        var tCount = 2;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 9) {
      if (riCount > 3) {
        var tCount = 3;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 8) {
      if (riCount > 4) {
        var tCount = 4;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 7) {
      if (riCount > 5) {
        var tCount = 5;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 6) {
      if (riCount > 6) {
        var tCount = 6;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 5) {
      if (riCount > 7) {
        var tCount = 7;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 4) {
      if (riCount > 8) {
        var tCount = 8;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (!canContinue) {
      alert(msg);
      return;
    }

    setNoOfRiskHierarchies(parseInt(ele.value));

    setStep51(false);
    var fromNoOfRiskHierarchies = true;
    setFromNoOfRiskHierarchiesState(true);
    finalizeReg(fromNoOfRiskHierarchies, ele.value);
  }


  const [showSubmit, setShowSubmit] = React.useState(false)

  function finalizeReg(fromNoOfRiskHierarchies, noOfRiskCount) {
    blinkText();

    var foundRiskHierarchy = false;
    registerArray.forEach((data, index) => {
      if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
        foundRiskHierarchy = true;
      }
    })
    if (fromNoOfRiskHierarchies != undefined && fromNoOfRiskHierarchies != null && fromNoOfRiskHierarchies) {
      foundRiskHierarchy = true;
    }

    if (!foundRiskHierarchy) {
      setStep5(true)
      setStep51(true);
      var objQa = {}
      var arrQa = qaArray;
      objQa = {}
      objQa["id"] = sectionCount + 1;
      setSectionCount(sectionCount + 1);
      objQa["q"] = "How many risk hierarchies do you want per a section"
      arrQa.push(objQa)
      setQaArray(arrQa)

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

    } else {
      setShowSubmit(true)
      setStep5(true);
      setStep51(false);
      //setShowTable(true)
      console.log(registerArray)

      var objQa = {}
      var arrQa = qaArray;

      if (fromNoOfRiskHierarchies != undefined && fromNoOfRiskHierarchies != null && fromNoOfRiskHierarchies) {
        if (noOfRiskCount != undefined && noOfRiskCount != null && noOfRiskCount != '') {
          console.log(arrQa)
          if (startAgain) {
            arrQa.forEach((data, itemIndex) => {
              if (itemIndex === sectionCount) {
                var arrX = [];
                var objX = {};
                objX["label"] = "";
                arrX.push(objX);
                objX = {};
                objX["var"] = noOfRiskCount;
                arrX.push(objX);
                objX = {};
                objX["label"] = "";
                arrX.push(objX);
                data["a"] = arrX;
              }
            })
          } else {
            arrQa.forEach((data, itemIndex) => {
              if (itemIndex + 1 === sectionCount) {
                var arrX = [];
                var objX = {};
                objX["label"] = "";
                arrX.push(objX);
                objX = {};
                objX["var"] = noOfRiskCount;
                arrX.push(objX);
                objX = {};
                objX["label"] = "";
                arrX.push(objX);
                data["a"] = arrX;
              }
            })

          }
        }
      }


      objQa = {}
      objQa["id"] = sectionCount + 1;
      setSectionCount(sectionCount + 1);
      objQa["q"] = "Enter a reference number for this GPT Session and Press \"Create Register\".";
      arrQa.push(objQa)
      setQaArray(arrQa)
      //setDivHeight('240');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);
      var jsonStr = JSON.stringify(registerArray)
      setFinalJson(jsonStr)
    }
  }

  const [loading, setLoading] = React.useState(false);
  const [loading1, setLoading1] = React.useState(false);

  const [questionId, setQuestionId] = useState('');
  const handlequestionId = (event) => {
    setQuestionId(event.target.value);
  };

  const [questiomRes, setQuestiomRes] = useState('');

  const [selectedRegisteredArray, setSelectedRegisteredArray] = React.useState([]);
  const [selectedRegisteredId, setSelectedRegisteredId] = React.useState('');
  const [selectedRegisteredName, setSelectedRegisteredName] = React.useState('');
  const [selectedRegisteredDescription, setSelectedRegisteredDescription] = React.useState('');
  const [selectedRiskGPTSessionId, setSelectedRiskGPTSessionId] = React.useState('');
  const [showEvaluateAndEditBtn, setShowEvaluateAndEditBtn] = React.useState(false);

  const [createdRegister, setCreatedRegister] = React.useState(false);

  const [createdHierachy, setCreatedHierachy] = React.useState(false);

  const [hideSeletion, setHideSeletion] = React.useState(false);



  const [openAllSchemadiaplay, setOpenAllSchemadiaplay] = React.useState(false);
  const handleCloseAllSchemadiaplay = () => {
    setOpenAllSchemadiaplay(false);
  };

  const [schemaName, setSchemaName] = useState('');
  const handleChangeSchemaName = (event) => {
    setSchemaName(event.target.value);
  };

    //Set state for re-do when "The result is too large. Amend sections or No of hierarchies" message diaplay
    const [reGenerateRegisterName, setReGenerateRegisterName] = useState('');
    const [reGenerateRegisterDescription, setReGenerateRegisterDescription] = useState('');
    const [reGenerateSectionNames, setReGenerateSectionNames] = useState('');
    const [reGenerateRiskCount, setReGenerateRiskCount] = useState('');
  
  function validateSchemaAndCreateRegister(type, sectionArray, noOfRisk) {
    var sendJson = "";
    if (type != 3){
    if (schemaName === '') {
      alert("Please select a schema");
      return;
    }
    setOpenAllSchemadiaplay(false);
    setLoading(true);
    
    var newSectionArr = [];
    var newRiskCount = 1;
    var newSectionNames = "";
    if (type === 1){
      newSectionArr = registerArray;
      newRiskCount = noOfRiskHierarchies;
      registerArray.forEach((item) => {
        if (newSectionNames === "") {
          newSectionNames += item.section
        } else {
          newSectionNames += "; " + item.section
        }
      })
    }else{
      newSectionArr = sectionArray;
      newRiskCount = noOfRisk;
      sectionArray.forEach((item) => {
        if (newSectionNames === "") {
          newSectionNames += item.section
        } else {
          newSectionNames += "; " + item.section
        }
      })
    }

    setReGenerateRegisterName(registerName);
    setReGenerateRegisterDescription(registerDescription)
    setReGenerateSectionNames(newSectionNames);
    setReGenerateRiskCount(newRiskCount);
    
    var obj = {}
    obj["userId"] = globalCentreId
    obj["createdBy"] = createUser


    var questionStr = "";
    //questionStr += "Using the results received above create a risk register for a ";
    if (redoUsingResearch) {
      questionStr += "Using the results received above return a json object based on the following json  schema so that I can recreate a risk register for a ";
    } else {
      questionStr += "Using the results received above return a json object based on the following json  schema so that I can create a risk register for a ";
    }
    //questionStr += "Using the results received above return a json object based on the following json  schema so that I can create a risk register for a ";
    questionStr += registerDescription + " ";
    var objArr = [];
    var riskStr = "";
    var tmpCount = 1;

    newSectionArr.forEach((item) => {
      if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
        item.risks.forEach((item1, index1) => {
          if (riskStr === "") {
            riskStr += tmpCount + ")" + item1.description;
            tmpCount++;
          } else {
            riskStr += ", " + tmpCount + ")" + item1.description;
            tmpCount++;
          }
        })
      }
    })

    if (riskStr != "") {
      questionStr += "for the risks " + riskStr + " and incorporate risks";
      //and incorporate 1 and 2 into sections 1 and Risks 3 and 4 into sections 2
      tmpCount = 1;
      var subStr = ""
      var emptyRiskSectionArr = [];
      newSectionArr.forEach((item) => {
        var str = "";

        if (item.risks != undefined && item.risks != null && item.risks.length > 0) {
          var noFound = false;
          item.risks.forEach((item1, index1) => {
            noFound = true;
            if (str === "") {
              str += tmpCount + ")";
              tmpCount++;
            } else {
              str += " and " + tmpCount + ")";
              tmpCount++;
            }
          })
          if (!noFound) {
            var xObj = {};
            xObj["section"] = item.section;
            emptyRiskSectionArr.push(xObj);
          }
          if (str === "") {

            /*
            if (subStr === "") {
              subStr += " nothing" + "" + " into the section " + item.section
            } else {
              subStr += " and nothing" + "" + " into the section " + item.section
            }
            */
          } else {
            if (subStr === "") {
              subStr += " " + str + " into  the section " + item.section
            } else {
              subStr += " and risks " + str + " into  the section " + item.section
            }
          }
        } else {
          var xObj = {};
          xObj["section"] = item.section;
          emptyRiskSectionArr.push(xObj);
        }
      })

      questionStr += subStr;
      if (emptyRiskSectionArr.length > 0) {
        var xxStr = "";
        var xCount = 0
        emptyRiskSectionArr.forEach((item2, index2) => {
          xCount++;
          if (index2 === 0) {
            xxStr += item2.section;
          } else {
            xxStr += ", " + item2.section;
          }
        })
        if (xCount > 1) {
          questionStr += ", add further sections " + xxStr + " with at least 3 risks of your choice ";
        } else {
          questionStr += ", add further section " + xxStr + " with at least 3 risks of your choice ";
        }

      }

      //

    } else {
      questionStr += "to cover the sections: ";
      var str = "";
      newSectionArr.forEach((item) => {
        if (str === "") {
          str += item.section
        } else {
          str += "; " + item.section
        }
      })
      questionStr += str;
    }



    questionStr += ", and add at least " + newRiskCount + " risks for each section and do not return the json schema.: ";



    //questionStr = "using the following json schema create a risk register for the risks 1)RiskVar1, 2)RiskVar2, 3)RiskVar3, 4)RiskVar4 and incorporate 1 and 2 into sections 1 and Risks 3 and 4 into sections 2. Show the results as a json object only : ";

    var selectedJson = "";
    allAvailableRiskSchemas.forEach((xx1, indexXX) => {
      if (xx1.id === schemaName) {
        var tSchema = xx1.schemaFormat;
        tSchema = tSchema.replaceAll('\t', " ");
        selectedJson = tSchema;
      }
    })
    console.log(selectedJson)


    questionStr += selectedJson;

    /*
    //questionStr += "{   '$schema': 'http://json-schema.org/draft-07/schema#',   'type': 'object',   'properties': {     'riskRegister': {       'type': 'array',       'items': {         'type': 'object',         'properties': {           'section': {             'type': 'string'           },           'role': {             'type': 'string'           },           'likelihood': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'impact': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'riskLevel': {             'type': 'integer',             'minimum': 1,             'maximum': 25           },           'riskAppetite': {             'type': 'integer',             'minimum': 1,             'maximum': 10           },           'risks': {             'type': 'array',             'items': {               'type': 'object',               'properties': {                 'description': {                   'type': 'string'                 },                 'likelihood': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'impact': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'riskLevel': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 25                 },                 'riskAppetite': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 10                 },                 'riskHierarchy': {                   'type': 'object',                   'properties': {                     'key': {                       'type': 'string'                     },                     'description': {                       'type': 'string'                     }                   },                   'required': [                     'key',                     'description'                   ]                 }               },               'required': [                 'description',                 'likelihood',                 'impact',                 'riskLevel',                 'riskAppetite',                 'riskHierarchy'               ]             }           }         },         'required': [           'section',           'role',           'likelihood',           'impact',           'riskLevel',           'riskAppetite',           'risks'         ]       }     }   } }";
    */

    var obj1 = {}
    obj1["messageId"] = questionId;
    obj1["message"] = questionStr;
    objArr.push(obj1);
    obj["chats"] = objArr
    sendJson = JSON.stringify(obj)

    console.log(sendJson);
     }else{

    const riskRegisterData = {
      userId: globalCentreId,
      createdBy: createUser,
      messageId: questionId,
      registerName: registerName,
      description: registerDescription,
      sections: registerArray.map(section => ({
        section: section.section,
        // Only include risks if they exist and are not null/undefined
        ...(section.risks && { 
          risks: section.risks
            .filter(risk => risk != null) // Remove any null risks
            .map(risk => ({
              name: risk?.name || "",
              description: risk?.description || ""
            }))
        })
      })),
      risksPerSection: noOfRiskHierarchies
    };

    console.log('Risk Register JSON:', JSON.stringify(riskRegisterData));
    sendJson = JSON.stringify(riskRegisterData);
    setOpenAllSchemadiaplay(false);
    setLoading(true);
  }

  var urlStr = "/openai/chat";
  if (type === 3 ){
    urlStr = "/openai/register/strict";
  }




    axios(CONFIG.MAIN_URL + urlStr, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        console.log(response.data);

        console.log(JSON.stringify(response.data));
        var schemaStr = JSON.stringify(response.data)
        var schemaObj = JSON.parse(schemaStr);

        setQuestiomRes(JSON.stringify(schemaObj, null, "\t"));
        console.log(response.data)

        var dataStr = "";
        schemaObj.messages.map((item, index) => {
          if (index === schemaObj.messages.length - 1) {
            item.answers.map((data, index) => {
              if (data.messageId === questionId) {
                dataStr = data.answer;
                dataStr = dataStr.replaceAll("\n", "");
                dataStr = dataStr.replaceAll("```json", "");
                dataStr = dataStr.replaceAll("```", "");
              }
            })
          }
        })

        try {
          var jObj = JSON.parse(dataStr);
          setOpenAllSchemadiaplay(false)
          console.log(jObj);
          var riskRegisterValidate = true
          if (riskRegisterValidate) {
            //setWaitingOpen(true);
            var riskObj = {};
            riskObj["documentCreator"] = "expert";
            riskObj["name"] = registerName;
            riskObj["description"] = registerDescription;
            riskObj["centreId"] = globalCentreId;
            riskObj["gptSessionId"] = questionId;
            riskObj["status"] = "Draft";
            if (jObj.riskRegister != undefined && jObj.riskRegister != null && jObj.riskRegister.length > 0) {
              var mainArr = [];
              jObj.riskRegister.forEach((data) => {
                var tmpObj1 = {};
                tmpObj1["section"] = data.section;
                tmpObj1["role"] = data.role;
                tmpObj1["likelihood"] = data.likelihood;
                tmpObj1["impact"] = data.impact;
                tmpObj1["riskLevel"] = data.riskLevel;
                tmpObj1["riskAppetite"] = data.riskAppetite;
                var subArr = [];
                if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
                  data.risks.forEach((data1) => {
                    var tmpObj2 = {};
                    //tmpObj2["name"] = data1.riskHierarchy.description;
                    tmpObj2["name"] = data1.description;
                    tmpObj2["description"] = data1.description;
                    tmpObj2["likelihood"] = data1.likelihood;
                    tmpObj2["impact"] = data1.impact;
                    tmpObj2["riskLevel"] = data1.riskLevel;
                    tmpObj2["riskAppetite"] = data1.riskAppetite;
                    var tmpObj3 = {};
                    var riskId = ""; //getRiskId(data1.riskHierarchy.key);
                    tmpObj3["riskId"] = riskId;

                    tmpObj3["key"] = data1.riskHierarchy.key;
                    tmpObj3["name"] = data1.riskHierarchy.description;
                    //tmpObj3["name"] = data1.description;
                    tmpObj2["riskHierarchy"] = tmpObj3;

                    const valueRis = data1.RiskDescription ?? data1.riskDescription;
                    if (valueRis != null) {
                      tmpObj2["riskDescription"] = valueRis;
                    }

                    const valueImp = data1.ImpactDescription ?? data1.impactDescription;
                    if (valueImp != null) {
                      tmpObj2["impactDescription"] = valueImp;
                    }
                    
                    const valueMit = data1.Mitigation ?? data1.mitigation;
                    if (valueMit != null) {
                      tmpObj2["mitigation"] = valueMit;
                    }

                    subArr.push(tmpObj2);
                  })
                  tmpObj1["risks"] = subArr;
                }
                mainArr.push(tmpObj1);
              })
              riskObj["riskRegister"] = mainArr;
            }
            console.log(riskObj);

            var sendingData = "mutation{createRegisterData(registerName:\"" + registerName + "\",status:\"" + 'draft' + "\",centreId:\"" + globalCentreId + "\"){registerId,registerName,status,centreId }}"

            axios(CONFIG.MAIN_URL + '/graphql', {
              method: 'post',
              headers: {
                'Content-Type': 'text/plain'
              },
              data: sendingData
            })
              .then(function (response) {
                console.log(JSON.stringify(response.data));
                let rtnData = response.data;
                console.log("++++++++++ register Data save in PG");
                console.log(rtnData);
                console.log("++++++++++ register Data save in PG");
                riskObj["registerUniqueName"] = globalCentreId + "_register_" + rtnData.data.createRegisterData.registerId;
                riskObj["createdUserId"] = globalUserId;
                riskObj["createdUserIpAddress"] = ipAddress;
                if (startAgain) {
                  if (startAgainRegisterObj != null) {
                    if (startAgainRegisterObj.id != undefined && startAgainRegisterObj.id != null) {
                      riskObj["parentRegisterid"] = startAgainRegisterObj.id;
                    }
                    if (startAgainRegisterObj.registerUniqueName != undefined && startAgainRegisterObj.registerUniqueName != null) {
                      riskObj["parentRegisterUniqueName"] = startAgainRegisterObj.registerUniqueName;
                    }
                  }
                }
                console.log(riskObj);
                console.log(JSON.stringify(riskObj));
                let sendJson = JSON.stringify(riskObj);
                axios(CONFIG.MAIN_URL + '/register/save', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  data: sendJson,
                })
                  .then(function (response) {
                    setLoading(false);
                    console.log(JSON.stringify(response.data));
                    console.log(response.data);
                    let rtnData = response.data;
                    setTimeout(() => {
                      alert("Register Created successfully.");
                    }, 500);

                    var registerId = response.data.id;
                    var name = response.data.name;
                    var description = response.data.description;


                    setSelectedRegisteredArray(response.data);
                    setSelectedRegisteredId(registerId);
                    setSelectedRegisteredName(name);
                    setSelectedRegisteredDescription(description);
                    setSelectedRiskGPTSessionId(questionId);

                    setStep1(false);
                    setStep2(false);
                    setStep3(false);
                    setStep4(false);
                    setStep5(false);
                    setStep51(false);
                    setRegisterArray([]);
                    setCreatedRegister(true)
                    setHideSeletion(true);

                    getAllRegister(globalCentreId, globalUserId, globalUserRoleId, ipAddress, "fromCreateRegiste");

                  })
                  .catch(function (error) {
                    setLoading(false);
                    console.log(error);
                    alert("Error saving Register-:" + error);
                  });
              })
              .catch(function (error) {
                setLoading(false);
                console.log(error);
                alert("Error saving register Data to Database Server -:" + error);
              });
          }

        } catch (error) {
          setLoading(false);
          setLoading(false);
          let text = "The result is too large. Amend sections or No of hierarchies.";
          if (window.confirm(text) == true) {
            setRedoSectionHeadingName(newSectionNames)
            setRedoRiskHierarchies(parseInt(newRiskCount))
            setOpenRegisterForRedo(true);
          }else{
            setOpenAllSchemadiaplay(false)
              clearButton();
              setStartAgain(true);
              setSendMessageField('1')
              setDisplayStartAgainTextBox(false);
              var objQa = {}
              var arrQa = [];
              objQa["id"] = 0;
              objQa["q"] = " "
              var arrX = [];
              var objX = {}
              objX["label"] = "You are Re-creating the ";
              arrX.push(objX);
              objX = {}
              objX["var"] = registerName;
              arrX.push(objX);
              objQa["a"] = arrX;
              arrQa.push(objQa)
              objQa = {}
              objQa["id"] = 1;
              objQa["q"] = `<p className="${wordstyle}">Create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?.</p>`
              arrQa.push(objQa)
              setQaArray(arrQa)

          }
        }

      })
      .catch(function (error) {
        //setWaitingOpen(false);
        setLoading(false);
        console.log(error);
        if (error.response?.data?.message){
          setOpenAllSchemadiaplay(false)
          let text = error.response?.data?.message + "\n";
          if (error.response?.data?.suggestion){
            text += error.response?.data?.suggestion
          }
          setOpenAllSchemadiaplay(false)
          if (window.confirm(text) == true) {
            validateSchemaAndCreateRegister(type, sectionArray, noOfRisk)
          }
          return;
        }
        setOpenAllSchemadiaplay(false)
        let text = "Something went wrong (" + error + "). Send again.";
        setOpenAllSchemadiaplay(false)
        if (window.confirm(text) == true) {
          validateSchemaAndCreateRegister(type, sectionArray, noOfRisk)
        }

      });



  }

  function sendToDataBase() {
    if (registerName === '') {
      alert("Please Register Name")
      return;
    }
    if (registerDescription === '') {
      alert("Please enter Register Description")
      return;
    }
    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (registerArray.length === 0) {
      alert("Please enter Key words to create Register")
      return;
    }

    setOpenAllSchemadiaplay(true)
    return;



  }



  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    try {
      var jObj = JSON.parse(questiomRes);
      var dataStr = "";
      jObj.messages.map((item, index) => {
        item.questions.map((data, index) => {
          dataStr = data.question;
          dataStr = dataStr.replaceAll("\n", "");
          dataStr = dataStr.replaceAll("\t", " ");
          dataStr = dataStr.replaceAll("\"", "\'");
          data["question"] = dataStr;
        })
        item.answers.map((data, index) => {
          dataStr = data.answer;
          dataStr = dataStr.replaceAll("\n", "");
          dataStr = dataStr.replaceAll("\t", " ");
          dataStr = dataStr.replaceAll("\"", "\'");
          data["answer"] = dataStr;
        })
      })
      setQuestiomRes(JSON.stringify(jObj, null, "\t"));
      setOpen(true);
    } catch (error) {
      alert("Invalid Json created. Please do this again")
      return;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  function clearButton() {
    setStartAgain(false);
    setStartAgainRegisterId('');
    setStartAgainRegisterObj({});
    setPreviousRegisterObj({})

    //setCanCreateRegister(false)
    //setCanCreateRegisterFromRedo(false)

    setQuestiomRes('');
    setCreatedRegister(false);
    setQuestionId('');
    setRegisterArray([]);
    setShowEvaluateAndEditBtn(false);
    setRegisterName('');
    setSelectedRegisteredId('');
    setRegisterDescription('');
    setStep1(false);
    setStep2(false);
    setStep3(false);
    setStep4(false);
    setStep5(false);
    setStep51(false);
    setStep6(false);
    setStep7(false);
    setHeaderMessage("")
    setSectionHeadingMessage("");
    setSendMessageField();
    setRegisterName('');
    setRegisterDescription('')
    setQuestionId('')
    setRegisterArray([]);
    setHierarchyArray([]);
    setQaArray([]);

    setCreatedHierachy(false)
    setHierarchyKey('')
    setHierarchyName('')
    setRiskTypeDataForEval({})
    setSavedQuestionArray([])
    setCreatedRiskId('')
    setOpenShowQuestions(false)

    setSelectedQuesData([])
    setQuesDataCount(0)
    setFromPreviousRegister(false);
    setHideSeletion(false);

    setSelectedRegisterDataObj({})
  }

  const [registerTypeDataForEval, setRegisterTypeDataForEval] = React.useState({});
  const [editRiskHirachy, setEditRiskHirachy] = React.useState(false);
  const [selectedRegisterEvaluateTitle, setSelectedRegisterEvaluateTitle] = React.useState('');

  const [showEditMoreInfo, setShowEditMoreInfo] = useState(false)
    const [showEditMoreInfoScroll, setShowEditMoreInfoScroll] = React.useState('paper');
  
    const showEditMoreInfoClose = () => {
      setShowEditMoreInfo(false)
    }

  function createJsonObject(obj) {
    console.log("+++++++++++++++++++obj+++++++++++++++++++++");
    console.log(obj);
    var regTmpId = 100000;
    obj.riskRegister.forEach((data) => {
      data["riskTypeId"] = regTmpId
      regTmpId++;
      if (data.risks != undefined && data.risks != null) {
        data.risks.forEach((risk) => {
          risk["riskTypeId"] = regTmpId
          regTmpId++;
          if (risk.riskHierarchy != undefined && risk.riskHierarchy != null) {
            if (risk.riskHierarchy.riskHierarchyData != undefined && risk.riskHierarchy.riskHierarchyData != null) {
              var riskHierarchyObj = risk.riskHierarchy.riskHierarchyData;
              if (riskHierarchyObj.riskTypes != undefined && riskHierarchyObj.riskTypes != null && riskHierarchyObj.riskTypes.length > 0) {
                risk["subRisks"] = riskHierarchyObj.riskTypes;
              }
            }

          }

        })
      }

    })

    var dataStr = JSON.stringify(obj);
    dataStr = dataStr.replaceAll("\"riskRegister\"", "\"riskTypes\"");
    dataStr = dataStr.replaceAll("\"section\"", "\"name\"");
    dataStr = dataStr.replaceAll("\"risks\"", "\"subRisks\"");
    dataStr = dataStr.replaceAll("\"likelihood\"", "\"riskLikelihood\"");
    dataStr = dataStr.replaceAll("\"impact\"", "\"riskImpact\"");
    var jsonObj = JSON.parse(dataStr)

    return jsonObj;


  }

  var globalIdCount = 1;

  function assignExtraAttributes(data, tmpIdCount) {
    data.forEach((item) => {
      item["riskTypeTmpId"] = globalIdCount
      console.log(globalIdCount)
      globalIdCount++;
      if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
        assignExtraAttributes(item.subRisks, tmpIdCount);
      }
    })
    return tmpIdCount;
  }


  function handleButtonShowQuestion() {
    setLoading1(true);
    var gObj = registerObjFromTable;
    setSelectedRiskEvaluateTitle(gObj.name)
    axios(CONFIG.MAIN_URL + "/question/getquestiononly?centreId=" + globalCentreId, {
      method: 'get',
    })
      .then(function (response) {
        var tArr = [];
        gObj.riskRegister.map((data) => {
          if (data.risks != undefined && data.risks != null) {
            data.risks.map((data1) => {
              if (
                data1.riskHierarchy != undefined &&
                data1.riskHierarchy != null &&
                data1.riskHierarchy.riskHierarchyData != undefined &&
                data1.riskHierarchy.riskHierarchyData != null
              ) {
                response.data.forEach((itemX, index) => {
                  if (itemX.riskTypes != undefined && itemX.riskTypes != null) {
                    if (parseInt(itemX.riskTypes.collectionRiskId) === parseInt(data1.riskHierarchy.riskHierarchyData.riskId)) {
                      tArr.push(itemX);
                    }
                  }
                })
              }
            })
          }
        })
        setLoading1(false)
        var count = 1;
        var tmpArray = [];
        setRows([]);
        tArr.forEach((item) => {
          console.log(item);
          var tmpObj = {};
          tmpObj["questionId"] = item.questionId;
          tmpObj["id"] = count;
          tmpObj["riskName"] = item.riskTypes.name;
          if (item.entity != undefined && item.entity != null) {
            tmpObj["entityName"] = item.entity.name;
          } else {
            tmpObj["entityName"] = "";
          }

          var priNumber = ""
          if (item.principle.principleNumber != undefined && item.principle.principleNumber != null) {
            priNumber = item.principle.principleNumber;
          }
          if (priNumber != '') {
            tmpObj["principalName"] = "Principle " + priNumber + ": " + item.principle.name;
          } else {
            tmpObj["principalName"] = item.principle.name;
          }
          if (item.objective != undefined && item.objective != null) {
            if (item.objective.name != undefined && item.objective.name != null) {
              tmpObj["objectiveName"] = item.objective.name;
            }
          } else {
            tmpObj["objectiveName"] = "";
          }
          if (item.component != undefined && item.component != null) {
            if (item.component.name != undefined && item.component.name != null) {
              tmpObj["componentName"] = item.component.name;
            }
          } else {
            tmpObj["componentName"] = "";
          }

          //tmpObj["objectiveName"] = item.objective.name;
          //tmpObj["componentName"] = item.component.name;


          //tmpObj["principalName"] = item.principle.name;
          tmpObj["question"] = item.question;
          tmpObj["questionType"] = item.questionType;
          tmpObj["questionData"] = item;
          tmpArray.push(tmpObj);
          setRows(tmpArray);
          count++;
        })
        setOpenShowQuestions(true);
        setOpenShowQuestionsScroll('paper');
        //setSavedQuestionArray(tArr);
        //showQuestionFuction()
      })
      .catch(function (error) {
        setLoading1(false);
        console.log(error);
      });


  }

  const [multipleRoles, setMultipleRoles] = React.useState(false);


  function evaluateRiskFuction() {
    setRegisterTypeDataForEval({});

    setEditRiskHirachy(false)

    setOpenDisplayChoice(true)

    //getAllRegisterEval(globalCentreId, selectedRegisteredId);
    //setRegisterEvaluate(true)
    //setOpenRegisterDataForEval(true)
    //setOpenRegisterDataForEvalScroll('paper');

  }


  function byRoleFuction() {
    getAllRegisterEval(globalCentreId, selectedRegisteredId, 'Role');
    setRegisterEvaluate(true)
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');
    setOpenDisplayChoice(false);
  }
  function byRiskNameFuction() {
    getAllRegisterEval(globalCentreId, selectedRegisteredId, 'RiskName');
    setRegisterEvaluate(true)
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');
    setOpenDisplayChoice(false);
  }



  function getAllRegisterEval(centrId, regId, type) {
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        //var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === centrId && item.id === regId) {
            var tmpIdCount = 1;
            var tmpIdCount1 = 1;
            var jsonObj = createJsonObject(item);
            setSelectedRegisterEvaluateTitle(item.name)


            globalIdCount = 1;
            jsonObj.riskTypes.forEach((item, index) => {
              item["riskTypeTmpId"] = globalIdCount;
              console.log(globalIdCount)
              globalIdCount++
              if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
                tmpIdCount = assignExtraAttributes(item.subRisks, tmpIdCount);
                tmpIdCount++;
              }

            })


            setRegisterTypeDataForEval(jsonObj);

            setMultipleRoles(false)

            var mainArr = []
            jsonObj.riskTypes.forEach((data) => {
              var secName = data.role;
              var obj = {};
              var arr = [];
              var canTake = true;

              mainArr.forEach((arrData) => {
                if (arrData.role === secName) {
                  canTake = false;
                }
              })

              if (canTake) {
                jsonObj.riskTypes.forEach((item) => {
                  if (secName === item.role) {
                    arr.push(item);
                  }
                })

                obj["role"] = data.role

                mainArr.push(obj);
              }
            })

            if (mainArr.length > 1) {
              setMultipleRoles(true)
            }

            if (type === "RiskName") {
              setMultipleRoles(false)
            }




          }

        })

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [openRegisterDataForEval, setOpenRegisterDataForEval] = React.useState(false);
  const [openRegisterDataForEvalScroll, setOpenRegisterDataForEvalScroll] = React.useState('paper');
  const [registerEvaluate, setRegisterEvaluate] = React.useState(false);

  const [fullScreenState, setFullScreenState] = React.useState(false);
  const [fullScreenStateRegister, setFullScreenStateRegister] = React.useState(false);
  const [fullScreenStateMsg, setFullScreenStateMsg] = React.useState('Full Screen');
  const [maxWidthState, setMaxWidthState] = React.useState('lg');

  function PaperComponentCollectionDataRegister(props) {
    return (
      <Draggable
        handle="#register-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const [openDisplayChoice, setOpenDisplayChoice] = React.useState(false);
  const handleCloseDisplayChoice = () => {
    setOpenDisplayChoice(false);
  };



  function RegisterDataForEvalfunctionClose() {
    setOpenRegisterDataForEval(false)
  }



  const [openRegisterEdit, setOpenRegisterEdit] = React.useState(false);
  const [openRegisterEditScroll, setOpenRegisterEditScroll] = React.useState('paper');


  function editRiskFuction() {
    setOpenRegisterEdit(true)
    setOpenRegisterEditScroll('paper');
  }


  const [openRiskHierarchyComponent, setOpenRiskHierarchyComponent] = React.useState(false);
  const [openRiskHierarchyComponentScroll, setOpenRiskHierarchyComponentScroll] = React.useState('paper');
  const [selectedRegisterDataObj, setSelectedRegisterDataObj] = useState({})


  function handleOpenRiskHierarchyComponentClose() {
    getAllRegister(globalCentreId, globalUserId, globalUserRoleId, ipAddress);
    setOpenRiskHierarchyComponent(false)

  }


  function addRiskFuction() {

    /*
    setSelectedRegisterDataObj(previousRegisterObj)
    setOpenRiskHierarchyComponent(true)
    setOpenRiskHierarchyComponentScroll('paper')
    */


    setLoading1(true)
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === globalCentreId) {
            arr.push(item);
            console.log(arr);
          }
        })
        arr.forEach((data) => {
          if (data.id === selectedRegisteredId) {
            setSelectedRegisterDataObj(data);
          }
        })
        setLoading1(false)
        setOpenRiskHierarchyComponent(true)
        setOpenRiskHierarchyComponentScroll('paper')

      })
      .catch(function (error) {
        console.log(error);
        setLoading1(false)
      });


  }


  const [startAgain, setStartAgain] = React.useState(false);
  const [displayStartAgainTextBox, setDisplayStartAgainTextBox] = React.useState(false);
  const [startAgainRegisterId, setStartAgainRegisterId] = React.useState('');
  const [startAgainRegisterObj, setStartAgainRegisterObj] = React.useState({});

  function startAgainFuction() {
    setOpenRiskGpt(false)
    setOpenDisplayResearchChoice(false);

    setLoading1(true)
    var tmpSselectedRegisteredId = selectedRegisteredId
    var gObj = previousRegisterObj;
    clearButton();
    setStartAgain(true);
    setStartAgainRegisterId(tmpSselectedRegisteredId);
    setStartAgainRegisterObj(gObj);
    setSendMessageField('1')
    setDisplayStartAgainTextBox(false)



    var objQa = {}
    var arrQa = [];
    objQa["id"] = 0;
    objQa["q"] = " "
    var arrX = [];
    var objX = {}
    objX["label"] = "You are Re-creating the ";
    arrX.push(objX);
    objX = {}
    objX["var"] = gObj.name;
    arrX.push(objX);
    objQa["a"] = arrX;
    arrQa.push(objQa)
    objQa = {}
    objQa["id"] = 1;
    objQa["q"] = `<p className="${wordstyle}">Create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?.</p>`
    arrQa.push(objQa)
    setQaArray(arrQa)


    setLoading1(false)




    /*
    setLoading1(true)
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === globalCentreId) {
            arr.push(item);
            console.log(arr);
          }
        })
        setLoading1(false)
        arr.forEach((data) => {
          if (data.id === selectedRegisteredId) {
            clearButton();
            setStartAgain(true);
            setStartAgainRegisterId(data.id);
            setStartAgainRegisterObj(data);
            setSendMessageField('1')
            setDisplayStartAgainTextBox(false)



            var objQa = {}
            var arrQa = [];
            objQa["id"] = 0;
            objQa["q"] = " "
            var arrX = [];
            var objX = {}
            objX["label"] = "You are Re-creating the ";
            arrX.push(objX);
            objX = {}
            objX["var"] = data.name;
            arrX.push(objX);
            objQa["a"] = arrX;
            arrQa.push(objQa)
            objQa = {}
            objQa["id"] = 1;
            objQa["q"] = "Create 1) A risk Register 2) A risk Hierarchy. Answer 1 or 2 ?."
            arrQa.push(objQa)
            setQaArray(arrQa)








          }
        })

      })
      .catch(function (error) {
        setLoading1(false)
        console.log(error);
      });
      */

  }




  /** Risk Hierarchy Section */

  const [hierarchyKey, setHierarchyKey] = React.useState('');
  const handleChangeHierarchyKey = (event) => {
    setHierarchyKey(event.target.value);
  };

  const handleButtonStep2HClickPre = () => {
    setSendMessageField('')
    setStep1(false);
    setStep2(false);
    qaArray.pop();
    qaArray.pop();
    setQaArray(qaArray);
    setSendMessageField("2")
  };
  
  const handleButtonStep2HClick = () => {

    blinkText();

    if (hierarchyKey === '') {
      alert("Please assign a Hierarchy Key");
      return;
    }
    setStep2(true);

    var objQa = {}
    var arrQa = qaArray;

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === 2) {
        var arrX = [];
        var objX = {};
        objX["label"] = "";
        arrX.push(objX);
        objX = {};
        objX["var"] = hierarchyKey;
        arrX.push(objX);
        data["a"] = arrX;
      }
    })
    objQa = {}
    objQa["id"] = 3;
    objQa["q"] = "Enter your Hierarchy Name."
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  };

  const [hierarchyName, setHierarchyName] = React.useState('');
  const handleChangeHierarchyName = (event) => {
    setHierarchyName(event.target.value);
  };


  const [hierarchyMainRiskMessage, setHierarchyMainRiskMessage] = React.useState('Enter your Main Risk')
  const handleButtonStep3HClickPre = () => {
    setStep2(false);
    console.log(qaArray);
    qaArray.pop();
    var tArr = [];
    qaArray.forEach((item, index) => {
      var obj = {};
      if (qaArray.length === (index + 1)) {
        obj["id"] = item.id;
        obj["q"] = item.q;
        tArr.push(obj);
      } else {
        obj["id"] = item.id;
        obj["q"] = item.q;
        obj["a"] = item.a;
        tArr.push(obj);
      }
    })
    setQaArray(tArr);
    setHierarchyKey(hierarchyKey)

  };
  
  const handleButtonStep3HClick = () => {
    blinkText();

    if (hierarchyName === '') {
      alert("Please assign a Hierarchy Name");
      return;
    }
    setStep3(true);

    var objQa = {}
    var arrQa = qaArray;

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === 3) {
        var arrX = [];
        var objX = {};
        objX["label"] = "Hierarchy Name is ";
        arrX.push(objX);
        objX = {};
        objX["var"] = hierarchyName;
        arrX.push(objX);
        data["a"] = arrX;
      }
    })

    objQa = {}
    objQa["id"] = 4;
    objQa["q"] = "Enter Main risks (Separate with ;)"
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('200');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);


  };

  const [hierarchyArray, setHierarchyArray] = React.useState([])

  function buildHierarchyArray() {
    var arr = hierarchyArray;
    var tmpArr = mainRiskName.split(";");
    tmpArr.forEach((data) => {
      var obj = {};
      obj["mainRisk"] = data;
      arr.push(obj);
    })
    setHierarchyArray(arr);
    console.log(arr);
  }

  function clearMainRisk() {
    setMainRiskName('');
  }


  const [mainRiskName, setMainRiskName] = React.useState('');
  const onChangeMainRiskName = (event) => {
    setMainRiskName(event.target.value);
  };

  function clickMainRiskMore() {
    blinkText();

    if (mainRiskName === '') {
      alert('please enter Main Risk Name')
      return;
    }

    buildHierarchyArray();
    clearMainRisk()

    setHierarchyMainRiskMessage('Enter your Next Main Risk OR Press \"NEXT\" to Enter Sub Risks for each Main Risks')

    var objQa = {}
    var arrQa = qaArray;

    var arrX = [];
    var objX = {};
    objX["label"] = "Main Risk is ";
    arrX.push(objX);
    objX = {};
    objX["var"] = mainRiskName;
    arrX.push(objX);
    objQa["a"] = arrX;

    //objQa["a"] = "Your have entered \"" + mainRiskName + "\" as the Main Risk";
    arrQa.push(objQa)
    objQa = {}
    objQa["q"] = "Next Main Risk OR Press \"NEXT\" to Enter Sub Risks."
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

  }

  const [mainRiskId, setMainRiskId] = React.useState('');
  const [riskCount, setRiskCount] = React.useState(5);

  function clickMainRiskDoneButtonPre() {
    setStep3(false);
    qaArray.pop();
    var tArr = [];
    qaArray.forEach((item, index) => {
      var obj = {};
      if (qaArray.length === (index + 1)) {
        obj["id"] = item.id;
        obj["q"] = item.q;
        tArr.push(obj);
      } else {
        obj["id"] = item.id;
        obj["q"] = item.q;
        obj["a"] = item.a;
        tArr.push(obj);
      }
    })
    setQaArray(tArr);
    setHierarchyName(hierarchyName)
  }

  function clickMainRiskDoneButton() {
    blinkText();
    if (mainRiskName === '') {
      alert('please enter at least one Main Risk')
      return;
    }

    buildHierarchyArray();
    clearMainRisk()

    var objQa = {}
    var arrQa = qaArray;

    arrQa.forEach((data, itemIndex) => {
      if (itemIndex + 1 === 4) {
        var arrX = [];
        var objX = {};
        objX["label"] = "";
        arrX.push(objX);
        objX = {};
        objX["var"] = mainRiskName;
        arrX.push(objX);
        data["a"] = arrX;
      }
    })

    objQa = {}
    objQa["id"] = riskCount;
    objQa["q"] = "Enter Sub Risks for the Main Risk \"" + hierarchyArray[0].mainRisk + "\" (Separate with ;) OR \"NEXT\" to continue OR \"FINISH\" to auto complete.";
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('240');

    setMainRiskId(hierarchyArray[0].mainRisk)
    setStep4(true);
    clearMainRisk()
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);









    /*
        
        if (mainRiskName != '') {
          buildHierarchyArray();
    
          var objQa = {}
          var arrQa = qaArray;
    
          var arrX = [];
          var objX = {};
          objX["label"] = "Main Risk is ";
          arrX.push(objX);
          objX = {};
          objX["var"] = mainRiskName;
          arrX.push(objX);
          objQa["a"] = arrX;
    
    
          //objQa["a"] = "Your have entered \"" + mainRiskName + "\" as the Main Risk";
          arrQa.push(objQa)
          objQa = {}
          objQa["q"] = "Enter Sub Risk for the Main Risk \"" + hierarchyArray[0].mainRisk + "\""
          arrQa.push(objQa)
          setQaArray(arrQa)
          //setDivHeight('150');
    
          setMainRiskId(hierarchyArray[0].mainRisk)
          setStep4(true);
          clearMainRisk()
          setTimeout(() => {
            if (scrollRef.current) {
              scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
            if (scrollRef1.current) {
              scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
            }
    
          }, 100);
    
          return
        } else {
          setMainRiskId(hierarchyArray[0].mainRisk)
          var objQa = {}
          var arrQa = qaArray;
          objQa = {}
          objQa["q"] = "Enter Sub Risks for the Main Risk \"" + hierarchyArray[0].mainRisk + "\""
          arrQa.push(objQa)
          setQaArray(arrQa)
          //setDivHeight('150');
          setStep4(true);
          setTimeout(() => {
            if (scrollRef.current) {
              scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
            if (scrollRef1.current) {
              scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
            }
    
          }, 100);
    
        }
        */
  }


  const [subRiskName, setSubRiskName] = React.useState('');
  const onChangeSubRiskName = (event) => {
    setSubRiskName(event.target.value);
  };

  const [nextMainRiskId, setNextMainRiskId] = React.useState('');

  function buildSubRiskArrayWithMainRisk() {

    var tmpArr = subRiskName.split(";")
    tmpArr.forEach((item) => {
      var obj = {};
      obj["subRisk"] = item;
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === mainRiskId) {
          if (hierarchyArray[index + 1] != undefined && hierarchyArray[index + 1] != null) {
            setNextMainRiskId(hierarchyArray[index + 1].mainRisk)
          } else {
            setNextMainRiskId('')
          }
          var subRisksArr = []
          if (data.components != undefined && data.components != null) {
            subRisksArr = data.components
            subRisksArr.push(obj)
          } else {
            subRisksArr.push(obj)
          }
          data["components"] = subRisksArr
        }
      })
    })
  }

  function subRiskClear() {
    setSubRiskName('');
  }


  function subRiskMore() {
    blinkText();
    if (subRiskName === '') {
      alert('please enter Sub Risk')
      return
    }
    buildSubRiskArrayWithMainRisk()


    var nextMainRiskName = "";
    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === mainRiskId) {
        if (hierarchyArray[index + 1] != undefined && hierarchyArray[index + 1] != null) {
          nextMainRiskName = hierarchyArray[index + 1].mainRisk;
        }
      }
    })

    var objQa = {}
    var arrQa = qaArray;

    var arrX = [];
    var objX = {};
    objX["label"] = "Your have entered ";
    arrX.push(objX);
    objX = {};
    objX["var"] = subRiskName;
    arrX.push(objX);
    objX = {};
    objX["label"] = " as a Sub Risk for ";
    arrX.push(objX);
    objX = {};
    objX["var"] = mainRiskId;
    arrX.push(objX);

    objQa["a"] = arrX;



    //objQa["a"] = "Your have entered \"" + subRiskName + "\" as a Sub Risk for \"" + mainRiskId + "\"";
    arrQa.push(objQa)
    objQa = {}
    if (nextMainRiskName != '') {
      objQa["q"] = "Next Sub Risk for \"" + mainRiskId + "\" OR Press \"NEXT\" for Next Main Risk \"" + nextMainRiskName + "\".\nOR Press \"FINISH\" to enter Sub Sub Risks for each sub risks."
    } else {
      objQa["q"] = "Next Sub Risk for \"" + mainRiskId + "\" OR Press \"NEXT\" Or \"FINISH\" to enter Sub Sub Risks  for each sub risks"
    }

    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

    subRiskClear()

  }


  function subRiskDone() {
    blinkText();
    if (subRiskName != '') {
      buildSubRiskArrayWithMainRisk()

      var objQa = {}
      var arrQa = qaArray;
      arrQa.forEach((data, itemIndex) => {
        if (itemIndex + 1 === riskCount) {
          var arrX = [];
          var objX = {};
          objX["label"] = "";
          arrX.push(objX);
          objX = {};
          objX["var"] = subRiskName;
          arrX.push(objX);
          objX = {};
          objX["label"] = "";
          arrX.push(objX);
          data["a"] = arrX;
        }
      })
      arrQa.push(objQa)
      setQaArray(arrQa)
      //setDivHeight('240');

      subRiskClear()
    }

    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === mainRiskId) {
        if (index + 1 >= hierarchyArray.length) {
          finishSubRisk();
        } else {
          setMainRiskId(hierarchyArray[index + 1].mainRisk)
          var objQa = {}
          var arrQa = qaArray;
          objQa = {}
          objQa["id"] = riskCount + 1;
          setRiskCount(riskCount + 1);
          objQa["q"] = "Enter Sub risk for \"" + hierarchyArray[index + 1].mainRisk + "\" OR OR \"NEXT\" to continue OR \"FINISH\" to auto complete";
          arrQa.push(objQa)
          setQaArray(arrQa)
          //setDivHeight('240');
          setTimeout(() => {
            if (scrollRef.current) {
              scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
            if (scrollRef1.current) {
              scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
            }

          }, 100);

        }
      }
    })
  }


  const [selectedMainRiskId, setSelectedMainRiskId] = React.useState('');
  const [selectedSubRiskId, setSelectedSubRiskId] = React.useState('');

  function finishSubRiskPre() {
    setStep4(false);
    console.log(qaArray);
    qaArray.pop();
    var tArr = [];
    qaArray.forEach((item, index) => {
      var obj = {};
      if (qaArray.length === (index + 1)) {
        obj["id"] = item.id;
        obj["q"] = item.q;
        tArr.push(obj);
      } else {
        obj["id"] = item.id;
        obj["q"] = item.q;
        obj["a"] = item.a;
        tArr.push(obj);
      }
    })
    setQaArray(tArr);
    var mStr = "";
    hierarchyArray.forEach((item, index) => {
      if (index === 0 ){
        mStr += item.mainRisk;
      }else{
        mStr += "; " + item.mainRisk;
      }
    })
    setMainRiskName(mStr)
    setHierarchyArray([])

  }
  function finishSubRisk() {
    blinkText();
    var foundSub = false;
    var mainName = '';
    var subName = '';
    hierarchyArray.forEach((data, index) => {
      if (!foundSub) {
        if (data.components != undefined && data.components != null) {
          data.components.forEach((item, index) => {
            if (!foundSub) {
              if (item.subRisk != undefined && item.subRisk != null && item.subRisk != '') {
                foundSub = true;
                setSelectedMainRiskId(data.mainRisk);
                setSelectedSubRiskId(item.subRisk);
                mainName = data.mainRisk;
                subName = item.subRisk;
              }
            }
          })
        }
      }
    })
    if (subName === "" && mainName === "") {
      setStep4(true);
      setStep5(true);
      finishSubSubRisk();
    } else {
      setStep5(true);
      var objQa = {}
      var arrQa = qaArray;
      objQa["id"] = riskCount + 1;
      setRiskCount(riskCount + 1);
      objQa["q"] = "Enter Sub Sub Risk for \"" + subName + "\" in \"" + mainName + "\" (Separate with ;)";
      arrQa.push(objQa)
      setQaArray(arrQa)
      //setDivHeight('150');

      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);
    }


  }

  const [subSubRiskName, setSubSubRiskName] = React.useState('');
  const onChangeSubSubRiskName = (event) => {
    setSubSubRiskName(event.target.value);
  };

  function buildSubSubRiskArrayWithMainRisk() {

    var tmpArr = subSubRiskName.split(";")
    tmpArr.forEach((item) => {
      var obj = {};
      obj["subSubRiskName"] = item;
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === selectedMainRiskId) {
          if (data.components != undefined && data.components != null) {
            data.components.forEach((item, index) => {
              if (item.subRisk === selectedSubRiskId) {
                var subSubRisksArr = [];
                if (item.subSubRisks != undefined && item.subSubRisks != null) {
                  subSubRisksArr = item.subSubRisks;
                }
                subSubRisksArr.push(obj);
                item["subSubRisks"] = subSubRisksArr;
              }
            })
          }
        }
      })
    })
  }

  function subSubRiskClear() {
    setSubSubRiskName('');
  }

  function subSubRiskMore() {
    blinkText();
    if (subSubRiskName === '') {
      alert('please enter Sub Sub Risk')
      return
    }
    buildSubSubRiskArrayWithMainRisk();


    var nextSubRiskName = "";
    var nextMainRiskName = "";
    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === selectedMainRiskId) {
        if (data.components != undefined && data.components != null) {
          data.components.forEach((item, index1) => {
            if (item.subRisk === selectedSubRiskId) {
              if (data.components[index1 + 1] != undefined && data.components[index1 + 1] != null) {
                nextMainRiskName = data.mainRisk;
                nextSubRiskName = data.components[index1 + 1].subRisk;
              }
            }
          })
        }
      }
    })
    if (nextSubRiskName === "") {
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === selectedMainRiskId) {
          var calTake = false;
          for (let i = index + 1; i < hierarchyArray.length; i++) {
            if (!calTake && hierarchyArray[i] != undefined && hierarchyArray[i] != null) {
              if (hierarchyArray[i].components != undefined && hierarchyArray[i].components != null) {
                hierarchyArray[i].components.forEach((item, index1) => {
                  if (!calTake && item.subRisk != undefined && item.subRisk != null && item.subRisk != "") {
                    nextMainRiskName = hierarchyArray[i].mainRisk;
                    nextSubRiskName = item.subRisk;
                    calTake = true;
                  }
                })
              }
            }
          }
        }
      })
    }

    var objQa = {}
    var arrQa = qaArray;

    var arrX = [];
    var objX = {};
    objX["label"] = "Your have entered ";
    arrX.push(objX);
    objX = {};
    objX["var"] = subSubRiskName;
    arrX.push(objX);
    objX = {};
    objX["label"] = " as a Sub Sub Risk for ";
    arrX.push(objX);
    objX = {};
    objX["var"] = selectedMainRiskId;
    arrX.push(objX);

    objQa["a"] = arrX;


    //objQa["a"] = "Your have entered \"" + subSubRiskName + "\" as a Sub Sub Risk for \"" + selectedSubRiskId + "\" in \"" + selectedMainRiskId + "\"";
    arrQa.push(objQa)
    objQa = {}
    if (nextSubRiskName != '') {
      objQa["q"] = "Next Sub Sub Risk for \"" + selectedSubRiskId + "\  in \"" + selectedMainRiskId + "\" OR Press \"NEXT\" for Next sub Risk \"" + nextSubRiskName + "\" in \"" + nextMainRiskName + "\".\nOR Press \"FINISH\" to create Risk Hierarchy"
    } else {
      objQa["q"] = "Next Sub Sub Risk for \"" + selectedSubRiskId + "\  in \"" + selectedMainRiskId + "\" OR Press \"NEXT\" Or \"FINISH\" to create Risk Hierarchy"
    }

    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

    subSubRiskClear();

  }


  function subSubRiskDone() {
    blinkText();
    if (subSubRiskName != '') {
      buildSubSubRiskArrayWithMainRisk();

      var objQa = {}
      var arrQa = qaArray;

      arrQa.forEach((data, itemIndex) => {
        if (itemIndex + 1 === riskCount) {
          var arrX = [];
          var objX = {};
          objX["label"] = "Your have entered ";
          arrX.push(objX);
          objX = {};
          objX["var"] = subSubRiskName;
          arrX.push(objX);
          objX = {};
          objX["label"] = " as a Sub Sub Risk for ";
          arrX.push(objX);
          objX = {};
          objX["var"] = selectedSubRiskId;
          arrX.push(objX);
          objX = {};
          objX["label"] = " in ";
          arrX.push(objX);
          objX = {};
          objX["var"] = selectedMainRiskId;
          arrX.push(objX);
          data["a"] = arrX;
        }
      })


      //objQa["a"] = "Your have entered \"" + subSubRiskName + "\" as a Sub Sub Risk for \"" + selectedSubRiskId + "\" in \"" + selectedMainRiskId + "\"";
      arrQa.push(objQa)
      setQaArray(arrQa)
      //setDivHeight('240');

      subRiskClear()
    }

    var nextSelectedSubRiskId = ""
    var nextSelectedMainRiskId = ""
    hierarchyArray.forEach((data, index) => {
      if (data.mainRisk === selectedMainRiskId) {
        if (data.components != undefined && data.components != null) {
          data.components.forEach((item, index1) => {
            if (item.subRisk === selectedSubRiskId) {
              if (data.components[index1 + 1] != undefined && data.components[index1 + 1] != null) {
                nextSelectedSubRiskId = data.components[index1 + 1].subRisk;
                nextSelectedMainRiskId = selectedMainRiskId;
                setSelectedSubRiskId(data.components[index1 + 1].subRisk);
              }
            }
          })
        }
      }
    })
    if (nextSelectedSubRiskId === "") {
      hierarchyArray.forEach((data, index) => {
        if (data.mainRisk === selectedMainRiskId) {
          var calTake = false;
          for (let i = index + 1; i < hierarchyArray.length; i++) {
            if (!calTake && hierarchyArray[i] != undefined && hierarchyArray[i] != null) {
              if (hierarchyArray[i].components != undefined && hierarchyArray[i].components != null) {
                hierarchyArray[i].components.forEach((item, index1) => {
                  if (!calTake && item.subRisk != undefined && item.subRisk != null && item.subRisk != "") {
                    nextSelectedMainRiskId = hierarchyArray[i].mainRisk;
                    setSelectedMainRiskId(hierarchyArray[i].mainRisk);
                    nextSelectedSubRiskId = item.subRisk;
                    setSelectedSubRiskId(item.subRisk);
                    calTake = true;
                  }
                })
              }
            }
          }
        }
      })
    }
    if (nextSelectedSubRiskId === "") {
      finishSubSubRisk();
    } else {
      var objQa = {}
      var arrQa = qaArray;
      objQa = {}
      objQa["id"] = riskCount + 1;
      setRiskCount(riskCount + 1)
      objQa["q"] = "Enter Sub Sub risk for \"" + nextSelectedSubRiskId + "\" in \"" + nextSelectedMainRiskId + "\" (Separate with ;)";
      arrQa.push(objQa)
      setQaArray(arrQa)
      //setDivHeight('150');
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
        if (scrollRef1.current) {
          scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
        }

      }, 100);

    }
    subSubRiskClear();



  }

  const [finalHJson, setFinalHJson] = React.useState('')

  function finishSubSubRisk() {
    blinkText();
    //setShowSubmit(true)
    setStep6(true);
    //setShowTable(true)
    console.log(registerArray)

    var objQa = {}
    var arrQa = qaArray;
    objQa["q"] = "Enter a reference number for this GPT Session and Press \"Create Risk Hierarchy\".";
    arrQa.push(objQa)
    setQaArray(arrQa)
    //setDivHeight('150');

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      if (scrollRef1.current) {
        scrollRef1.current.scrollTop = scrollRef1.current.scrollHeight;
      }

    }, 100);

    var hObj = {};
    hObj["objectives"] = hierarchyArray
    var jsonStr = JSON.stringify(hObj)
    setFinalHJson(jsonStr)

  }

  const [riskTypeDataForEval, setRiskTypeDataForEval] = React.useState({});
  const [createdRiskId, setCreatedRiskId] = React.useState('');
  const [selectedRiskEvaluateTitle, setSelectedRiskEvaluateTitle] = React.useState('');
  const [editRiskOrRegister, setEditRiskOrRegister] = React.useState('Edit');
  const [savedQuestionArray, setSavedQuestionArray] = React.useState([]);



  function createString(jsonObj, subRiskFound, subSubRiskFound) {
    if (!subRiskFound) {
      var str = "";
      str += "Using this json schema\n";
      str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
      str += "Can you Create a json object only to show the following.\n";
      str += "The main Risk is the ";
      str += hierarchyName + ". ";
      //str += "in an organization that conducts a ";
      //str += createdRegisterDescription + ". ";
      str += "I want to create ";
      str += getMainRiskCount(jsonObj) + " ";
      str += "mainRisks for the ";
      str += getMainRiskCount(jsonObj) + " ";
      //str += "three" + " ";
      // str += "Objectives of the Coso 2017 standard namely ";
      str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
      str += getMainRiskTopStrWithCount(jsonObj) + ". ";
      //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
      str += "I then want to Create 1 subRisk for each " + globalStandardDataForComponent + " Component ";
      str += "that is relevant for each " + globalStandardDataForObjective + " Objective and create subSubRisks ";
      str += "for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component. ";
      str += "When listing Please name the " + globalStandardDataForObjective + " objective and " + globalStandardDataForComponent + " component against the mainRisks only ";
      str += "and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
      str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
      str += "The mainRisks are ";
      str += getMainRiskTopStrWithCount(jsonObj) + ". ";
      str += "Use Realistic examples for subRisks . ";
      str += "Use Realistic examples for subSubRisks. ";
      str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter. \n";
      str += "Please return only the JSON object and do not return Json schema or any other wordings."
      return str;
    } else {
      if (!subSubRiskFound) {
        var str = "";
        str += "Using this json schema\n";
        str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
        str += "Can you Create a json object only to show the following.\n";
        str += "The main Risk is the ";
        str += hierarchyName + ". ";
        //str += "in an organization that conducts a ";
        //str += createdRegisterDescription + ". ";
        str += "I want to create ";
        str += getMainRiskCount(jsonObj) + " ";
        str += "mainRisks for the ";
        str += getMainRiskCount(jsonObj) + " ";
        //str += "three" + " ";
        // str += "Objectives of the Coso 2017 standard namely ";
        str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
        str += "I then want to Create subRisks for each " + globalStandardDataForComponent + " Component that is relevant for each " + globalStandardDataForObjective + " Objective as ";
        str += getSubRiskMainStrWithCount(jsonObj) + " ";
        str += "and create subSubRisks for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component. ";
        str += "When listing Please name the " + globalStandardDataForObjective + " Objects and " + globalStandardDataForComponent + " Components against the mainRisks only and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
        str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
        str += "The mainRisks are ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        str += "Use Realistic examples for subRisks. ";
        str += "Use Realistic examples for subSubRisks. ";
        str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter.\n";
        str += "Please return only the JSON object and do not return Json schema or any other wordings."
        return str;
      } else {
        var str = "";
        str += "Using this json schema\n";
        str += "{\n     '$schema':'http://json-schema.org/draft-07/schema#',\n     'type':'object',\n     'properties':{\n        'objectives':{\n           'type':'array',\n           'items':{\n              'type':'object',\n              'properties':{\n                 'objectiveName':{\n                    'type':'string'\n                 },\n                 'mainRisk':{\n                    'type':'string'\n                 },\n                 'components':{\n                    'type':'array',\n                    'items':{\n                       'type':'object',\n                       'properties':{\n                          'componentName':{\n                             'type':'string'\n                          },\n                          'subRisk':{\n                             'type':'string'\n                          },\n                          'subSubRisks':{\n                             'type':'array',\n                             'items':{\n                                'type':'object',\n                                'properties':{\n                                   'principleName':{\n                                      'type':'string'\n                                   },\n                                   'principleNumber':{\n                                      'type':'integer'\n                                   },\n                                   'subSubRiskName':{\n                                      'type':'string'\n                                   },\n                                   'likelihood':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'impact':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'question':{\n                                      'type':'string'\n                                   },\n                                   'yesScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   },\n                                   'noScore':{\n                                      'type':'integer',\n                                      'minimum':1,\n                                      'maximum':5\n                                   }\n                                },\n                                'required':[\n                                   'principleName',\n                                   'principleNumber',\n                                   'subSubRiskName',\n                                   'likelihood',\n                                   'impact',\n                                   'question',\n                                   'yesScore',\n                                   'noScore'\n                                ]\n                             }\n                          }\n                       },\n                       'required':[\n                          'componentName',\n                          'subRisk',\n                          'subSubRisks'\n                       ]\n                    }\n                 }\n              },\n              'required':[\n                 'objectiveName',\n                 'mainRisk',\n                 'components'\n              ]\n           }\n        }\n     },\n     'required':[\n        'objectives'\n     ]\n  }\n";
        str += "Can you Create a json object only to show the following.\n";
        str += "The main Risk is the ";
        str += hierarchyName + ". ";
        //str += "in an organization that conducts a ";
        //str += createdRegisterDescription + ". ";
        str += "I want to create ";
        str += getMainRiskCount(jsonObj) + " ";
        str += "mainRisks for the ";
        str += getMainRiskCount(jsonObj) + " ";
        //str += "three" + " ";
        str += "Objectives of the " + globalStandardDataForObjective + " standard namely ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        //str += "1) Operations 2) Reporting 3) Compliance" + ". ";
        str += "I then want to Create subRisks for each " + globalStandardDataForComponent + " Component that is relevant for each " + globalStandardDataForObjective + " Objective as ";
        str += getSubRiskMainStrWithCount(jsonObj) + " ";
        str += "and create subSubRisks for the exact " + globalStandardDataForPrinciple + " Principle that is relevant to each " + globalStandardDataForComponent + " Component as ";
        str += getSubSubRiskMainStrWithCount(jsonObj) + ". ";
        str += "When listing Please name the " + globalStandardDataForObjective + " Objects and " + globalStandardDataForComponent + " Components against the mainRisks only and name the " + globalStandardDataForPrinciple + " Principle and the actual Principle number against each subSubRisk. ";
        str += "You must adhere to the rule that one or many of the 16 principles are directly related to one component. ";
        str += "The mainRisks are ";
        str += getMainRiskTopStrWithCount(jsonObj) + ". ";
        str += "Use Realistic examples for subRisks. ";
        str += "Use Realistic examples for subSubRisks. ";
        str += "Any examples provided should be realistic representations of potential risks that an organization conducting logistics services might encounter.\n";
        str += "Please return only the JSON object and do not return Json schema or any other wordings."
        return str;
      }
    }

    /*
    str = "";
    str += "Using the following schema create a json Object to show the risks for a ";
    str += createdRegisterName;
    str += " associated with mainRisk ";
    str += getMainRiskTopStr(jsonObj) + " ";
    str += "within this risk hierarchy. ";
    str += "So can you list " + getMainRiskCount(jsonObj) + " mainRisk namely " + getMainRiskStr(jsonObj) + " against  the objectives of COSO 2017";
    if (subRiskFound) {
      str += "and subRisk against each components namely ";
      str += getSubRiskMainStr(jsonObj);
      if (subSubRiskFound) {
        str += ", a subSubRiskName, the coso principleName and principleNumber each subSubRisks namely ";
        str += getSubSubRiskMainStr(jsonObj);
      }
    }
    str += ". Dont forget to state the objectiveName against COSO 2017 objectives and the componentName against the COSO 2017 components and principleName against subSubRisks ";
    str += "and organize the output  in the order of mainRisk, subRisk, subSubRisk. ";
    str += "I also want to frame a question against each subSubRisks with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
    str += "and return only the JSON object and do not return Json schema : "

    str += "{     '$schema':'http://json-schema.org/draft-07/schema#',     'type':'object',     'properties':{        'objectives':{           'type':'array',           'items':{              'type':'object',              'properties':{                 'objectiveName':{                    'type':'string'                 },                 'mainRisk':{                    'type':'string'                 },                 'components':{                    'type':'array',                    'items':{                       'type':'object',                       'properties':{                          'componentName':{                             'type':'string'                          },                          'subRisk':{                             'type':'string'                          },                          'subSubRisks':{                             'type':'array',                             'items':{                                'type':'object',                                'properties':{                                   'principleName':{                                      'type':'string'                                   },                                   'principleNumber':{                                      'type':'integer'                                   },                                   'subSubRiskName':{                                      'type':'string'                                   },                                   'likelihood':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'impact':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'question':{                                      'type':'string'                                   },                                   'yesScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'noScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   }                                },                                'required':[                                   'principleName',                                   'principleNumber',                                   'subSubRiskName',                                   'likelihood',                                   'impact',                                   'question',                                   'yesScore',                                   'noScore'                                ]                             }                          }                       },                       'required':[                          'componentName',                          'subRisk',                          'subSubRisks'                       ]                    }                 }              },              'required':[                 'objectiveName',                 'mainRisk',                 'components'              ]           }        }     },     'required':[        'objectives'     ]  }";
    */


  }


  function getMainRiskCount(jsonObj) {
    var mainRiskCount = 0;
    jsonObj.objectives.forEach((item, index) => {
      mainRiskCount++;
    });
    return mainRiskCount;
  }

  function getMainRiskTopStrWithCount(jsonObj) {
    var mainRiskTopStr = "";
    var count = 1;
    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (index === 0) {
        mainRiskTopStr += count + ") " + mainRiskName + "";
        count++;
      } else {
        mainRiskTopStr += ", " + count + ") " + mainRiskName + "";
        count++;
      }
    });
    return mainRiskTopStr;
  }

  function getSubRiskMainStrWithCount(jsonObj) {
    var subRiskMainStr = "";
    var firstTime = true;
    jsonObj.objectives.forEach((item, index) => {
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (firstTime) {
            firstTime = false;
            subRiskMainStr += (index + 1) + "." + (index1 + 1) + ") " + subRiskName + "";
          } else {
            subRiskMainStr += ", " + (index + 1) + "." + (index1 + 1) + ") " + subRiskName + "";
          }
        })
      }
    });
    return subRiskMainStr;
  }


  function getSubSubRiskMainStrWithCount(jsonObj) {
    var subSubRiskMainStr = "";
    var firstTime = true
    jsonObj.objectives.forEach((item, index) => {
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        item.components.forEach((item1, index1) => {
          if (item1.subSubRisks != undefined && item1.subSubRisks != null && item1.subSubRisks.length > 0) {
            item1.subSubRisks.forEach((item2, index2) => {
              var subSubRiskName = item2.subSubRiskName.trim();
              if (firstTime) {
                firstTime = false;
                subSubRiskMainStr += (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName + "";
              } else {
                subSubRiskMainStr += ", " + (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName + "";
              }
            })
          }
        })
      }
    });
    return subSubRiskMainStr;

  }










  function sendToDataBaseH() {

    /*


    if (hierarchyKey === '') {
      alert("Please Assign Risk Hierarchy Key")
      return;
    }
    if (hierarchyName === '') {
      alert("Please Assign Risk Hierarchy Name")
      return;
    }

    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (finalHJson === '') {
      alert("Please enter Key words to create Risk Hierarchy")
      return;
    }
    */

    if (globalStandardDataForObjective === '') {
      alert("please select standard for objective")
      return;
    }
    if (globalStandardDataForComponent === '') {
      alert("please select standard for component")
      return;
    }
    if (globalStandardDataForPrinciple === '') {
      alert("please select standard for principle")
      return;
    }
    setRiskStandardOpen(false)

    var obj = {}
    obj["userId"] = globalCentreId
    obj["createdBy"] = createUser

    var questionStr = "";
    var objArr = [];
    var riskStr = "";

    var jsonObj = JSON.parse(finalHJson);

    var mainRiskStr = "";
    var mainRiskTopStr = "";
    var mainRiskCount = 0;
    var subRiskFound = false;
    var subSubRiskFound = false;
    var subRiskMainStr = "";
    var subSubRiskMainStr = "";

    var mainRiskStrWithCount = "";
    var subRiskMainStrWithCount = "";
    var subSubRiskMainStrWithCount = "";

    jsonObj.objectives.forEach((item, index) => {
      var mainRiskName = item.mainRisk.trim();
      if (index === 0) {
        mainRiskTopStr += "'" + mainRiskName + "'";
        mainRiskStr += "'" + mainRiskName + "'";
        mainRiskStrWithCount += (index + 1) + ") " + mainRiskName;
      } else {
        mainRiskStrWithCount += ", " + (index + 1) + ") " + mainRiskName;
        if (jsonObj.objectives.length - 1 === index) {
          mainRiskTopStr += " and '" + mainRiskName + "'";
          mainRiskStr += " and '" + mainRiskName + "'";
        } else {
          mainRiskTopStr += " ,'" + mainRiskName + "'";
          mainRiskStr += " ,'" + mainRiskName + "'";
        }
      }
      mainRiskCount++;
      if (item.components != undefined && item.components != null && item.components.length > 0) {
        subRiskFound = true;
        var subRiskStr = "";
        item.components.forEach((item1, index1) => {
          var subRiskName = item1.subRisk.trim();
          if (index1 === 0) {
            subRiskStr += "'" + subRiskName + "'";
            subRiskMainStrWithCount += (index + 1) + "." + (index1 + 1) + ") " + subRiskName;
          } else {
            subRiskStr += ", '" + subRiskName + "'";
            subRiskMainStrWithCount += ", " + (index + 1) + "." + (index1 + 1) + ") " + subRiskName;
          }
          if (item1.subSubRisks != undefined && item1.subSubRisks != null && item1.subSubRisks.length > 0) {
            subSubRiskFound = true;
            var subSubRiskStr = "";
            item1.subSubRisks.forEach((item2, index2) => {
              var subSubRiskName = item2.subSubRiskName.trim();
              if (index2 === 0) {
                subSubRiskStr += "'" + subSubRiskName + "'";
                subSubRiskMainStrWithCount += (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName;
              } else {
                subSubRiskStr += ", '" + subSubRiskName + "'";
                subSubRiskMainStrWithCount += ", " + (index + 1) + "." + (index1 + 1) + "." + (index2 + 1) + ") " + subSubRiskName;
              }
            })
            if (subSubRiskStr != "") {
              subSubRiskStr += " in to " + "'" + subRiskName + "'";
              if (subSubRiskMainStr === '') {
                subSubRiskMainStr += subSubRiskStr;
              } else {
                subSubRiskMainStr += " and " + subSubRiskStr;
              }
            }
            if (subSubRiskMainStrWithCount != "") {
              subSubRiskMainStrWithCount += " in to " + "'" + subRiskName + "' ";
            }
          }
        })
        if (subRiskStr != "") {
          subRiskStr += " in to " + "'" + mainRiskName + "'";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        } else {
          subRiskStr += "'" + mainRiskName + "'" + " has no subRisk ";
          if (subRiskMainStr === '') {
            subRiskMainStr += subRiskStr;
          } else {
            subRiskMainStr += " and " + subRiskStr;
          }
        }
        if (subRiskMainStrWithCount != "") {
          subRiskMainStrWithCount += " in to " + "'" + mainRiskName + "' ";
        }
      }
    });
    /*
     questionStr += "Using the following schema create a json Object to show the risks associated with ";
     questionStr += mainRiskTopStr + " ";
     questionStr += "process of a ";
     questionStr += hierarchyName + " ";
     questionStr += "so can you list " + mainRiskCount + " mainRisk namely " + mainRiskStr + " against  the objectives of COSO2017 ";
     if (subRiskFound) {
       questionStr += "and subRisk against each components namely ";
       questionStr += subRiskMainStr;
       if (subSubRiskFound) {
         questionStr += ", a subSubRiskName, the coso principleName and principleNumber each subSubRisks namely ";
         questionStr += subSubRiskMainStr
       }
       //questionStr += "'S1M1', 'S2M1' in to 'M1' and ";
       //questionStr += "'S1M2' in to 'M2' and ";
       //questionStr += "'M3' has no subRisk ";
       //questionStr += ", a subSubRiskName, the coso principleName and principleNumber each subSubRisks namely ";
       //questionStr += "'S1S1M1' in to 'S1M1' and 'S1S1M2' in to 'S1M2'. ";
     }
 
     questionStr += ". Dont forget to state the objectiveName against objectives and the componentName against the components and principleName against subSubRisks ";
     questionStr += "and organize the output  in the order of mainRisk, subRisk, subSubRisk. ";
     questionStr += "I also want to frame a question against each subSubRisks with a dichotomous ratio scale answer showing scoring numbers Yes = 5 and No = 1 ";
     questionStr += "and return only the JSON object and do not return Json schema : "
 
     //alert(questionStr);
 
     questionStr += "{     '$schema':'http://json-schema.org/draft-07/schema#',     'type':'object',     'properties':{        'objectives':{           'type':'array',           'items':{              'type':'object',              'properties':{                 'objectiveName':{                    'type':'string'                 },                 'mainRisk':{                    'type':'string'                 },                 'components':{                    'type':'array',                    'items':{                       'type':'object',                       'properties':{                          'componentName':{                             'type':'string'                          },                          'subRisk':{                             'type':'string'                          },                          'subSubRisks':{                             'type':'array',                             'items':{                                'type':'object',                                'properties':{                                   'principleName':{                                      'type':'string'                                   },                                   'principleNumber':{                                      'type':'integer'                                   },                                   'subSubRiskName':{                                      'type':'string'                                   },                                   'likelihood':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'impact':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'question':{                                      'type':'string'                                   },                                   'yesScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   },                                   'noScore':{                                      'type':'integer',                                      'minimum':1,                                      'maximum':5                                   }                                },                                'required':[                                   'principleName',                                   'principleNumber',                                   'subSubRiskName',                                   'likelihood',                                   'impact',                                   'question',                                   'yesScore',                                   'noScore'                                ]                             }                          }                       },                       'required':[                          'componentName',                          'subRisk',                          'subSubRisks'                       ]                    }                 }              },              'required':[                 'objectiveName',                 'mainRisk',                 'components'              ]           }        }     },     'required':[        'objectives'     ]  }";
 
   */


    questionStr += createString(jsonObj, subRiskFound, subSubRiskFound);



    var obj1 = {}
    obj1["messageId"] = questionId;
    obj1["message"] = questionStr;
    objArr.push(obj1);
    obj["chats"] = objArr
    var sendJson = JSON.stringify(obj)
    //alert(sendJson);




    setLoading(true);

    axios(CONFIG.MAIN_URL + '/openai/chat', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        console.log("+++++++++++++JSON.stringify(response.data)+++++++++++++");
        console.log(JSON.stringify(response.data));
        var schemaStr = JSON.stringify(response.data)
        var schemaObj = JSON.parse(schemaStr);

        setQuestiomRes(JSON.stringify(schemaObj, null, "\t"));
        console.log(response.data)

        var dataStr = "";
        schemaObj.messages.map((item, index) => {
          if (index === schemaObj.messages.length - 1) {
            item.answers.map((data, index) => {
              if (data.messageId === questionId) {
                dataStr = data.answer;
                dataStr = dataStr.replaceAll("\n", "");
                dataStr = dataStr.replaceAll("```json", "");
                dataStr = dataStr.replaceAll("```", "");
              }
            })
          }
        })

        try {
          var jObj = JSON.parse(dataStr);
          console.log(jObj);

          var tmpName = hierarchyName;
          var riskLikelihood = "1";
          var riskImpact = "1";
          var riskLevel = 1;
          var riskAppetite = "1";
          var riskObj = {};
          var today = new Date();
          var curDateTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

          riskObj["name"] = tmpName;
          riskObj["key"] = hierarchyKey;
          riskObj["centreId"] = globalCentreId;
          riskObj["riskLikelihood"] = riskLikelihood;
          riskObj["riskImpact"] = riskImpact;
          riskObj["riskLevel"] = riskLevel;
          riskObj["riskAppetite"] = riskAppetite;
          var riskCount = 1;

          if (jObj.objectives != undefined && jObj.objectives != null && jObj.objectives.length > 0) {
            var mainArr = [];
            jObj.objectives.forEach((data) => {
              var tmpObj1 = {};
              tmpObj1["riskTypeTmpId"] = riskCount;
              riskCount++;
              tmpObj1["name"] = data.mainRisk;
              tmpObj1["riskLikelihood"] = riskLikelihood;
              tmpObj1["riskImpact"] = riskImpact;
              tmpObj1["riskLevel"] = riskLevel;
              tmpObj1["riskAppetite"] = riskAppetite;
              var tmpObj2 = {};
              tmpObj2["riskLikelihood"] = riskLikelihood;
              tmpObj2["riskImpact"] = riskImpact;
              tmpObj2["riskLevel"] = riskLevel;
              tmpObj1["riskLevelData"] = tmpObj2;
              tmpObj1["riskAppetite"] = riskAppetite;
              var tmpObj3 = {};
              tmpObj3["riskAppetite"] = riskAppetite;
              tmpObj3["secondaryColor"] = "#ffffff";
              tmpObj1["riskAppetiteData"] = tmpObj3;

              var tmpObjObjectiveData = {};
              if (data.objectiveName != undefined && data.objectiveName != null) {
                tmpObjObjectiveData["objectiveName"] = data.objectiveName;
              } else {
                tmpObjObjectiveData["objectiveName"] = '';
              }
              var tmpObjObjectiveDataObj = {};
              tmpObjObjectiveDataObj["objectiveData"] = tmpObjObjectiveData;
              tmpObj1["riskStandardData"] = tmpObjObjectiveDataObj;

              var subArr = [];
              if (data.components != undefined && data.components != null && data.components.length > 0) {
                data.components.forEach((data1) => {
                  var tmpObj4 = {};
                  tmpObj4["riskTypeTmpId"] = riskCount;
                  riskCount++;
                  tmpObj4["name"] = data1.subRisk;
                  tmpObj4["riskLikelihood"] = riskLikelihood;
                  tmpObj4["riskImpact"] = riskImpact;
                  tmpObj4["riskLevel"] = riskLevel;
                  tmpObj4["riskAppetite"] = riskAppetite;
                  var tmpObj5 = {};
                  tmpObj5["riskLikelihood"] = riskLikelihood;
                  tmpObj5["riskImpact"] = riskImpact;
                  tmpObj5["riskLevel"] = riskLevel;
                  tmpObj4["riskLevelData"] = tmpObj5;
                  tmpObj4["riskAppetite"] = riskAppetite;
                  var tmpObj6 = {};
                  tmpObj6["riskAppetite"] = riskAppetite;
                  tmpObj6["secondaryColor"] = "#ffffff";
                  tmpObj4["riskAppetiteData"] = tmpObj6;
                  var tmpComponentData = {};
                  if (data1.componentName != undefined && data1.componentName != null) {
                    tmpComponentData["componentName"] = data1.componentName;
                  } else {
                    tmpComponentData["componentName"] = "";
                  }
                  var tmpComponentDataObj = {};
                  tmpComponentDataObj["componentData"] = tmpComponentData;
                  tmpObj4["riskStandardData"] = tmpComponentDataObj;

                  if (data1.subSubRisks != undefined && data1.subSubRisks != null && data1.subSubRisks.length > 0) {
                    var subSubArr = [];
                    data1.subSubRisks.forEach((data2) => {
                      var tmpObj7 = {};
                      tmpObj7["riskTypeTmpId"] = riskCount;
                      riskCount++;
                      tmpObj7["name"] = data2.subSubRiskName;
                      var riskLikelihoodStr = ""
                      var riskLevelAmt = 1;
                      if (data2.likelihood != undefined && data2.likelihood != null) {
                        riskLikelihoodStr = data2.likelihood.toString();
                        riskLevelAmt = parseInt(data2.likelihood);
                      } else {
                        riskLikelihoodStr = riskLikelihood;
                      }
                      var riskImpactStr = ""
                      if (data2.impact != undefined && data2.impact != null) {
                        riskImpactStr = data2.impact.toString();
                        riskLevelAmt = riskLevelAmt * (parseInt(data2.impact));
                      } else {
                        riskImpactStr = riskImpact;
                      }

                      tmpObj7["riskLikelihood"] = riskLikelihoodStr;
                      tmpObj7["riskImpact"] = riskImpactStr;
                      tmpObj7["riskLevel"] = riskLevelAmt;
                      tmpObj7["riskAppetite"] = riskAppetite;
                      var tmpObj8 = {};
                      tmpObj8["riskLikelihood"] = riskLikelihoodStr;
                      tmpObj8["riskImpact"] = riskImpactStr;
                      tmpObj8["riskLevel"] = riskLevelAmt;
                      tmpObj7["riskLevelData"] = tmpObj8;
                      tmpObj7["riskAppetite"] = riskAppetite;
                      var tmpObj9 = {};
                      tmpObj9["riskAppetite"] = riskAppetite;
                      tmpObj9["secondaryColor"] = "#ffffff";
                      tmpObj7["riskAppetiteData"] = tmpObj9;

                      var tmpPrincipleData = {};
                      if (data2.principleName != undefined && data2.principleName != null) {
                        tmpPrincipleData["principleName"] = data2.principleName;
                      } else {
                        tmpPrincipleData["principleName"] = "";
                      }
                      var tmpPrincipleDataObj = {};
                      tmpPrincipleDataObj["principleData"] = tmpPrincipleData;
                      tmpObj7["riskStandardData"] = tmpPrincipleDataObj;

                      subSubArr.push(tmpObj7);
                    })
                    tmpObj4["subRisks"] = subSubArr;
                  }
                  subArr.push(tmpObj4);
                })
                tmpObj1["subRisks"] = subArr;
              }
              mainArr.push(tmpObj1);
            })
            riskObj["riskTypes"] = mainArr;

            console.log(riskObj);

            var data = JSON.stringify(riskObj);
            console.log(data);

            axios(CONFIG.MAIN_URL + '/risk/save', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
              },
              data: data,
            })
              .then(function (response) {
                setLoading(false);

                setTimeout(() => {
                  alert("Risk Hierarchy Created successfully");
                }, 500);

                console.log(response.data);
                setRiskTypeDataForEval(response.data);
                setCreatedRiskId(response.data.riskId);
                getAllRisks(globalCentreId);
                setSelectedRiskEvaluateTitle(response.data.name);
                setEditRiskOrRegister('Edit Risk');

                setCreatedHierachy(true)

                setHideSeletion(true);

                updateQuestionTemplate(jObj, response.data, response.data.riskId)
                console.log(questionArray);
                if (questionArray != undefined && questionArray != null && questionArray.length > 0) {
                  var sendArr = [];
                  questionArray.forEach((arrayData) => {
                    sendArr.push(arrayData);
                  })
                  var myJSON = JSON.stringify(sendArr);
                  console.log(myJSON);
                  var saveUrl = CONFIG.MAIN_URL + '/question/savequestionlist';
                  axios(saveUrl, {
                    method: 'post',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    data: myJSON,
                  })
                    .then(function (resp) {
                      console.log("++++++++++++++Question Save Return++++++++++");
                      console.log(resp.data);
                      console.log(JSON.stringify(resp.data));
                      setSavedQuestionArray(resp.data)
                    })
                    .catch(function (error) {
                      setLoading(false);
                      console.log(error);
                    });

                } else {
                  setLoading(false);
                }


              })
              .catch(function (error) {
                setLoading(false);
                console.log(error);
                alert("Error saving Risk Type -:" + error);
              });













          } else {
            setLoading(false);
            alert("Invalid Json created. Please do this again")
          }


        } catch (error) {
          setLoading(false);
          alert("Invalid Json created. Please do this again")
        }

      })
      .catch(function (error) {
        //setWaitingOpen(false);
        setLoading(false);
        console.log(error);
        alert("Error saving Question -:" + error);
      });



  }

  const [allAvailableRisk, setAllAvailableRisk] = React.useState([]);
  function getAllRisks(centId) {
    axios(CONFIG.MAIN_URL + `/risk/all`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("All Risk Returns");
        console.log(response.data);
        var arr = [];
        response.data.forEach((item) => {
          if (centId === item.centreId) {
            arr.push(item);
          }
        })
        setAllAvailableRisk(arr);
        if (createdRiskId != undefined && createdRiskId != null && createdRiskId != '') {
          arr.forEach((item) => {
            if (createdRiskId === item.riskId) {
              setRiskTypeDataForEval(item);
              setSelectedRiskEvaluateTitle(item.name);
            }
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  var questionArray = [];
  function updateQuestionTemplate(sndJson, resJson, riskId) {
    if (sndJson.objectives != undefined && sndJson.objectives != null && sndJson.objectives.length > 0) {
      sndJson.objectives.forEach((data) => {
        if (data.components != undefined && data.components != null && data.components.length > 0) {
          data.components.forEach((data1) => {
            if (data1.subSubRisks != undefined && data1.subSubRisks != null && data1.subSubRisks.length > 0) {
              data1.subSubRisks.forEach((data2) => {
                var riskName = data2.subSubRiskName;
                var principleName = data2.principleName;
                var question = data2.question;
                var yesScore = data2.yesScore;
                var noScore = data2.noScore;
                resJson.riskTypes.forEach((item) => {
                  if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
                    item.subRisks.forEach((item1) => {
                      if (item1.subRisks != undefined && item1.subRisks != null && item1.subRisks.length > 0) {
                        item1.subRisks.forEach((item2) => {
                          if (item2.name === riskName && item2.riskStandardData.principleData.principleName === principleName) {
                            //console.log(item2);
                            var obj = {};

                            /** Create Question Object */
                            obj["collectionUniqueName"] = "";
                            obj["centreId"] = globalCentreId;

                            obj["question"] = question;
                            obj["questionType"] = "Closeended";
                            obj["questionTypeName"] = "Nominal";
                            var objSub = {};
                            objSub["status"] = "draft";
                            obj["metaInfo"] = objSub;
                            objSub = {};
                            objSub["collectionRiskTypeId"] = item2.riskTypeId + "";
                            objSub["collectionRiskId"] = riskId + "";
                            objSub["name"] = item2.name;
                            objSub["riskLikelihood"] = item2.riskLikelihood;
                            objSub["riskImpact"] = item2.riskImpact;
                            objSub["riskLevel"] = item2.riskLevel;
                            objSub["riskAppetite"] = item2.riskAppetite;
                            obj["riskTypes"] = objSub;
                            objSub = {};
                            objSub["id"] = "";
                            objSub["name"] = principleName;
                            objSub["principleScore"] = 0;
                            obj["principle"] = objSub;

                            objSub = {};
                            var objSubSub = {};
                            objSubSub["name"] = "radioButtonType";
                            objSubSub["minValue"] = "0";
                            objSubSub["maxValue"] = "0";
                            objSub["answerMethod"] = objSubSub;

                            var arryTmp = [];

                            var tmpObjX1 = {};
                            tmpObjX1["riskLevel"] = yesScore;
                            tmpObjX1["riskCategoryId"] = "";
                            tmpObjX1["riskMethodId"] = "";

                            var tmpObjX0 = {};
                            tmpObjX0["answerName"] = "Yes";
                            tmpObjX0["answerType"] = "radioButtonType";
                            tmpObjX0["riskLevel"] = yesScore;
                            tmpObjX0["expectedAnswerName"] = "";
                            tmpObjX0["riskLevelData"] = tmpObjX1;

                            arryTmp.push(tmpObjX0);

                            tmpObjX1 = {};
                            tmpObjX1["riskLevel"] = noScore;
                            tmpObjX1["riskCategoryId"] = "";
                            tmpObjX1["riskMethodId"] = "";

                            tmpObjX0 = {};
                            tmpObjX0["answerName"] = "No";
                            tmpObjX0["answerType"] = "radioButtonType";
                            tmpObjX0["riskLevel"] = noScore;
                            tmpObjX0["expectedAnswerName"] = "";
                            tmpObjX0["riskLevelData"] = tmpObjX1;

                            arryTmp.push(tmpObjX0);

                            objSub["answerList"] = arryTmp;
                            obj["answers"] = objSub;

                            questionArray.push(obj);
                          }
                        })
                      }
                    })
                  }
                })
              })
            }
          })
        }
      })
    }
  }



  function evaluateRiskHFuction() {
    if (createdRiskId === '') {
      alert("No created Risk for evaluation")
      return;
    }
    setRegisterEvaluate(false)
    setRegisterTypeDataForEval(riskTypeDataForEval);
    setSelectedRegisterEvaluateTitle(selectedRiskEvaluateTitle);
    setOpenRegisterDataForEval(true)
    setOpenRegisterDataForEvalScroll('paper');

  }


  const [openRiskDataEdit, setOpenRiskDataEdit] = React.useState(false);
  const [openRiskDataEditScroll, setOpenRiskDataEditScroll] = React.useState('paper');


  function editRiskHFuction() {

    if (createdRiskId === '') {
      alert("No created Risk for Edit")
      return;
    }
    setOpenRiskDataEdit(true);
    setOpenRiskDataEditScroll('paper');

  }

  function setOpenRiskDataEditfunction() {
    setOpenRiskDataEdit(false)
    getAllRisks(globalCentreId);
  }


  /** Question Show and Edit */
  function PaperComponentAllQuestionData(props) {
    return (
      <Draggable
        handle="#collection-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }



  const [rows, setRows] = React.useState([]);
  const [openShowQuestions, setOpenShowQuestions] = React.useState(false);
  const [openShowQuestionsScroll, setOpenShowQuestionsScroll] = React.useState('paper');


  function showQuestionFuction() {
    var count = 1;
    var tmpArray = [];
    setRows([]);
    savedQuestionArray.forEach((item) => {
      console.log(item);
      var tmpObj = {};
      tmpObj["questionId"] = item.questionId;
      tmpObj["id"] = count;
      tmpObj["riskName"] = item.riskTypes.name;

      var priNumber = ""
      if (item.principle.principleNumber != undefined && item.principle.principleNumber != null) {
        priNumber = item.principle.principleNumber;
      }
      if (priNumber != '') {
        tmpObj["principalName"] = "Principle " + priNumber + ": " + item.principle.name;
      } else {
        tmpObj["principalName"] = item.principle.name;
      }
      if (item.objective != undefined && item.objective != null) {
        if (item.objective.name != undefined && item.objective.name != null) {
          tmpObj["objectiveName"] = item.objective.name;
        }
      } else {
        tmpObj["objectiveName"] = "";
      }
      if (item.component != undefined && item.component != null) {
        if (item.component.name != undefined && item.component.name != null) {
          tmpObj["componentName"] = item.component.name;
        }
      } else {
        tmpObj["componentName"] = "";
      }

      //tmpObj["principalName"] = item.principle.name;
      if (item.entity != undefined && item.entity != null) {
        tmpObj["entityName"] = item.entity.name;
      } else {
        tmpObj["entityName"] = "";
      }
      tmpObj["question"] = item.question;
      tmpObj["questionType"] = item.questionType;
      tmpObj["questionData"] = item;
      tmpArray.push(tmpObj);
      setRows(tmpArray);
      count++;
    })
    setOpenShowQuestions(true);
    setOpenShowQuestionsScroll('paper');
  }

  const [selectedQuesData, setSelectedQuesData] = React.useState([]);
  const [selectedQuestion, setSelectedQuestion] = React.useState('');
  const [quesDataCount, setQuesDataCount] = React.useState(0);
  const [questionDetailOpen, setQuestionDetailOpen] = React.useState(false);
  const [questionDetailScroll, setQuestionDetailScroll] = React.useState('paper');


  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const questionDetailHandleClickClose = () => {
    setQuestionDetailOpen(false);
  };


  function parseId(no, questionId, question) {
    var tmpArray = [];
    setQuesDataCount(no);
    setSelectedQuestion(question);
    savedQuestionArray.forEach((item) => {
      if (item.questionId === questionId) {
        tmpArray.push(item);
        setSelectedQuesData(tmpArray);
      }
    });
    setQuestionDetailOpen(true);
    setQuestionDetailScroll('paper');
  }

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            parseId(params.row.id, params.row.questionId, params.row.question)
          }}
        >
          More Info
        </Button>
      </strong>
    )
  }

  const renderTextRiskName = (params) => {
    return (
      <Tooltip title={params.row.riskName}>
        <span style={{ fontSize: '10px' }}>{params.row.riskName}</span>
      </Tooltip>
    )
  }
  const renderTextId2 = (params) => {
    return (
      <span >{params.row.id}</span>
    )
  }
  const renderTextObjectiveName = (params) => {
    return (
      <Tooltip title={params.row.objectiveName}>
        <span style={{ fontSize: '10px' }}>{params.row.objectiveName}</span>
      </Tooltip>
    )
  }
  const renderTextComponentName = (params) => {
    return (
      <Tooltip title={params.row.componentName}>
        <span style={{ fontSize: '10px' }}>{params.row.componentName}</span>
      </Tooltip>
    )
  }
  const renderTextPrincipalName = (params) => {
    return (
      <Tooltip title={params.row.principalName}>
        <span style={{ fontSize: '10px' }}>{params.row.principalName}</span>
      </Tooltip>
    )
  }

  const renderTextEntityName = (params) => {
    return (
      <Tooltip title={params.row.entityName}>
        <span style={{ fontSize: '10px' }}>{params.row.entityName}</span>
      </Tooltip>
    )
  }

  const renderTextQuestion2 = (params) => {
    return (
      <Tooltip title={params.row.question}>
        <span style={{ fontSize: '10px' }}>{params.row.question}</span>
      </Tooltip>
    )
  }

  const renderTextQuestionType2 = (params) => {
    return (
      <span style={{ fontSize: '10px' }}>{params.row.questionType}</span>
    )
  }

  const [openQuestionEdit, setOpenQuestionEdit] = React.useState(false);
  const [openQuestionEditScroll, setOpenQuestionEditScroll] = React.useState('paper');
  const [selectedQuestionName, setSelectedQuestionName] = React.useState('');
  const [selectedQuestionId, setSelectedQuestionId] = React.useState('');


  function editQuestion(questionId, question) {
    setSelectedQuestionName(question);
    setSelectedQuestionId(questionId);
    setOpenQuestionEdit(true);
    setOpenQuestionEditScroll('paper');
  }


  const renderEditButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            editQuestion(params.row.questionId, params.row.question)
          }}
        >
          Edit
        </Button>
      </strong>
    )
  }



  const columns = [
    { field: 'id', headerName: 'No', renderCell: renderTextId2, resizable: true, width: 15 },
    /*
    { field: 'questionId', headerName: 'No', width: 15, hide: true },
    { field: 'riskName', headerName: 'Risk', renderCell: renderTextRiskName, resizable: true, cellClassName: 'super-app-theme--cell', width: 240 },
    { field: 'principalName', headerName: 'Principal', renderCell: renderTextPrincipalName, resizable: true, cellClassName: 'super-app-theme--cell', width: 175 },
    { field: 'entityName', headerName: 'Entity', renderCell: renderTextEntityName, resizable: true, cellClassName: 'super-app-theme--cell', width: 100 },
    { field: 'question', headerName: 'Question', renderCell: renderTextQuestion2, cellClassName: 'super-app-theme--cell', resizable: true, width: 325 },
    { field: 'questionType', headerName: 'Type', renderCell: renderTextQuestionType2, resizable: true, width: 80 },
   */
    { field: 'questionId', headerName: 'No', width: 15, hide: true },
    { field: 'riskName', headerName: 'Risk', renderCell: renderTextRiskName, resizable: true, cellClassName: 'super-app-theme--cell', width: 130 },
    { field: 'objectiveName', headerName: 'Objective', renderCell: renderTextObjectiveName, resizable: true, cellClassName: 'super-app-theme--cell', width: 90 },
    { field: 'componentName', headerName: 'Component', renderCell: renderTextComponentName, resizable: true, cellClassName: 'super-app-theme--cell', width: 90 },
    { field: 'principalName', headerName: 'Principal', renderCell: renderTextPrincipalName, resizable: true, cellClassName: 'super-app-theme--cell', width: 180 },
    { field: 'entityName', headerName: 'Entity', renderCell: renderTextEntityName, resizable: true, cellClassName: 'super-app-theme--cell', width: 100 },
    { field: 'question', headerName: 'Question', renderCell: renderTextQuestion2, cellClassName: 'super-app-theme--cell', resizable: true, width: 250 },
    { field: 'questionType', headerName: 'Type', renderCell: renderTextQuestionType2, resizable: true, width: 80 },
    {
      field: 'action',
      headerName: 'More Info',
      sortable: false,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: true,

    },
    {
      field: 'edit',
      headerName: 'Edit',
      sortable: false,
      renderCell: renderEditButton,
      disableClickEventBubbling: true,

    }

  ];



  const [createdRiskHierarchyIdFromComp, setCreatedRiskHierarchyIdFromComp] = React.useState('');

  function addRiskHierarchyFunction() {
    setOpenRiskHierarchyComponent(false)
    if (createdRiskHierarchyIdFromComp != '') {
      var assignedRiskId = createdRiskHierarchyIdFromComp;
      setLoading(true);
      axios(CONFIG.MAIN_URL + `/risk/all`, {
        method: 'get',
        headers: {
          'Content-Type': 'text/plain',
        },
      })
        .then(function (res) {
          console.log("All Risk Returns");
          console.log(res.data);
          var arr = [];
          res.data.forEach((item) => {
            if (globalCentreId === item.centreId) {
              arr.push(item);
            }
          })


          if (assignedRiskId != undefined && assignedRiskId != null && assignedRiskId != '') {
            arr.forEach((item) => {
              if (assignedRiskId === item.riskId) {
                axios(CONFIG.MAIN_URL + `/register/all`, {
                  method: 'get',
                })
                  .then(function (response) {
                    console.log("all register");
                    console.log(response.data);
                    response.data.forEach((data) => {
                      if (data.centreId === globalCentreId && data.id === selectedRegisteredId) {
                        var regData = data;
                        regData.riskRegister.forEach((dataReg, index) => {
                          if (index === 0) {
                            dataReg.risks.forEach((dataRisks, index1) => {
                              if (index1 === 0) {
                                dataRisks.riskHierarchy["riskId"] = item.riskId;
                                dataRisks.riskHierarchy["key"] = item.key;
                                dataRisks.riskHierarchy["name"] = item.name;
                                dataRisks.riskHierarchy["riskHierarchyData"] = item;
                              }
                            })
                          }
                        })

                        console.log(regData);
                        console.log(JSON.stringify(regData));
                        let sendJson = JSON.stringify(regData);
                        axios(CONFIG.MAIN_URL + '/register/save', {
                          method: 'post',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          data: sendJson,
                        })
                          .then(function (resp) {
                            setLoading(false);
                            console.log("++++++++++++++++++Register Update Response+++++++++++++++++++");
                            console.log(resp.data);
                            let rtnData = resp.data;
                            alert("Register Updated successfully with Risk Hirarchy.");
                            setSelectedRegisteredId(rtnData.id);
                          })
                          .catch(function (error) {
                            setLoading(false);
                            console.log(error);
                            alert("Error updating Register -:" + error);
                          });

                      }
                    })

                  })
                  .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                  });








              }
            })
          }
          setCreatedRiskHierarchyIdFromComp('');
        })
        .catch(function (error) {
          console.log(error);
          setCreatedRiskHierarchyIdFromComp('');
          setLoading(false);
        });






    } else {
      alert("No Risk Hierarchy was created. \nPlease press \"Add Risk Hierarchy\" button again to add risk Hierarchy for " + selectedRegisteredName)
    }
  }


  const [collectionTitle, setCollectionTitle] = React.useState('');
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openTextFieldDialog, setOpenTextFieldDialog] = useState(false);
  const [collectionDescription, setCollectionDescription] = React.useState('');
  const [collectionRisks, setCollectionRisks] = React.useState([]);
  const [registerNameForCreateCollection, setRegisterNameForCreateCollection] = React.useState('');

  const handleCollectionTitle = (event) => {
    setCollectionTitle(event.target.value);
  };

  const handleCollectionDescription = (event) => {
    setCollectionDescription(event.target.value);
  };

  function clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  function handleConfirmationDialogOpen(row) {
    console.log(row);
    var risksList = []
    axios(CONFIG.MAIN_URL + "/question/getquestiononly?centreId=" + globalCentreId, {
      method: 'get',
    })
      .then(function (response) {
        var tArr = [];
        row.riskRegister.map((data) => {
          if (data.risks != undefined && data.risks != null) {
            data.risks.map((data1) => {
              if (
                data1.riskHierarchy != undefined &&
                data1.riskHierarchy != null &&
                data1.riskHierarchy.riskHierarchyData != undefined &&
                data1.riskHierarchy.riskHierarchyData != null
              ) {
                response.data.forEach((itemX, index) => {
                  if (itemX.riskTypes != undefined && itemX.riskTypes != null) {
                    if (parseInt(itemX.riskTypes.collectionRiskId) === parseInt(data1.riskHierarchy.riskHierarchyData.riskId)) {
                      tArr.push(itemX);
                    }
                  }
                })
              }
            })
          }
        })

        row.riskRegister.forEach((item) => {
          item.risks.forEach((item1) => {
            if (item1.riskHierarchy != undefined && item1.riskHierarchy != null) {
              if (item1.riskHierarchy.riskId != null && item1.riskHierarchy.riskId != '' && item1.riskHierarchy.riskHierarchyData != undefined && item1.riskHierarchy.riskHierarchyData != null) {

                item1.riskHierarchy.riskHierarchyData.riskTypes.forEach((item2) => {
                  var tempArr = []
                  tArr.forEach((data) => {
                    if (parseInt(item2.riskTypeId) === parseInt(data.riskTypes.collectionRiskTypeId)) {
                      tempArr.push(data)
                    }
                  })
                  if (tempArr.length > 0) {
                    item2["questions"] = tempArr;
                  }
                  clean(item2);

                  if (item2.subRisks != undefined && item2.subRisks != null) {
                    item2.subRisks.forEach((item3) => {
                      var tempArr = []
                      tArr.forEach((data) => {
                        if (parseInt(item3.riskTypeId) === parseInt(data.riskTypes.collectionRiskTypeId)) {
                          tempArr.push(data)
                        }
                      })
                      if (tempArr.length > 0) {
                        item3["questions"] = tempArr;
                      }
                      clean(item3);
                      if (item3.subRisks != undefined && item3.subRisks != null) {
                        item3.subRisks.forEach((item4) => {
                          var tempArr = []
                          tArr.forEach((data) => {
                            if (parseInt(item4.riskTypeId) === parseInt(data.riskTypes.collectionRiskTypeId)) {
                              tempArr.push(data)
                            }
                          })
                          if (tempArr.length > 0) {
                            item4["questions"] = tempArr;
                          }
                          clean(item4);

                          if (item4.subRisks != undefined && item4.subRisks != null) {
                            item4.subRisks.forEach((item5) => {
                              var tempArr = []
                              tArr.forEach((data) => {
                                if (parseInt(item5.riskTypeId) === parseInt(data.riskTypes.collectionRiskTypeId)) {
                                  tempArr.push(data)
                                }
                              })
                              if (tempArr.length > 0) {
                                item5["questions"] = tempArr;
                              }
                              clean(item5);

                            })

                          }

                        })

                      }

                    })

                  }

                })


              }
            }
          })
        })


        row.riskRegister.map((data) => {
          if (data.risks != undefined && data.risks != null) {
            data.risks.map((data1) => {
              console.log(data1)
              if (data1.riskHierarchy.riskHierarchyData != undefined && data1.riskHierarchy.riskHierarchyData != null) {
                var obj = {};
                obj["name"] = data1.riskHierarchy.name;
                obj["riskTypes"] = data1.riskHierarchy.riskHierarchyData.riskTypes;
                console.log(obj)
                risksList.push(obj);
              }
            })
          }
        })

        console.log(risksList);
        setCollectionRisks(risksList);

      })
      .catch(function (error) {
        console.log(error)
      });


    console.log(collectionRisks)



    setRegisterNameForCreateCollection(row.name);
    setOpenConfirmationDialog(true);
  };


  function saveCollection() {

    if (collectionTitle === '') {
      alert('Please enter collection title')
      return
    }
    if (collectionDescription === '') {
      alert('Please enter collection description')
      return
    }

    var title = collectionTitle
    var status = "Draft"
    var centreId = globalCentreId
    var sendStr = "mutation{createCollectionData(collectionName:\"" + title + "\",status:\"" + status + "\",centreId:\"" + centreId + "\"){collectionId,collectionName,status,centreId }}";
    axios(CONFIG.MAIN_URL + '/graphql', {
      method: 'post',
      headers: {
        'Content-Type': 'text/plain'
      },
      data: sendStr
    })
      .then(function (response) {
        console.log(response)
        console.log(JSON.stringify(response.data));
        let rtnData = response.data;
        console.log(rtnData);
        console.log("++++++++++ Collection Data save in PG");
        var obj = {}
        obj["title"] = collectionTitle;
        obj["description"] = collectionDescription;
        obj["centreId"] = globalCentreId;
        obj["status"] = "Draft"
        obj["collectionUniqueName"] = globalCentreId + "_questionnaire_" + rtnData.data.createCollectionData.collectionId;
        obj["documentCreator"] = "expert";
        obj["risks"] = collectionRisks;


        console.log("++++++++++++++++++++++++++++++22222222222222222obj###############");
        console.log(obj);
        console.log(JSON.stringify(obj));
        let sendJson = JSON.stringify(obj);


        axios(CONFIG.MAIN_URL + CONFIG.CONTROLLER_NAME + '/save', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          data: sendJson,
        })
          .then(function (response) {
            console.log("+++++++++++++++++++++++response.data++++++++++++++++++++++++++");
            console.log(response.data);
            let rtnData = response.data;
            rtnData.risks.forEach((item) => {
              var tCollectionRiskId = item.collectionRiskId;
              if (item.riskTypes != undefined && item.riskTypes != null && item.riskTypes.length > 0) {
                item.riskTypes.forEach((item1) => {
                  if (item1.subRisks != undefined && item1.subRisks != null && item1.subRisks.length > 0) {
                    item1.subRisks.forEach((item2) => {
                      var tCollectionRiskTypeId = item2.collectionRiskTypeId;
                      if (item2.questions != undefined && item2.questions != null && item2.questions.length > 0) {
                        item2.questions.forEach((ques) => {
                          if (ques.riskTypes != undefined && ques.riskTypes != null) {
                            ques.riskTypes["collectionRiskId"] = tCollectionRiskId;
                            ques.riskTypes["collectionRiskTypeId"] = tCollectionRiskTypeId;
                          }
                        })
                      }
                      if (item2.subRisks != undefined && item2.subRisks != null && item2.subRisks.length > 0) {
                        item2.subRisks.forEach((item3) => {
                          tCollectionRiskTypeId = item3.collectionRiskTypeId;
                          if (item3.questions != undefined && item3.questions != null && item3.questions.length > 0) {
                            item3.questions.forEach((ques) => {
                              if (ques.riskTypes != undefined && ques.riskTypes != null) {
                                ques.riskTypes["collectionRiskId"] = tCollectionRiskId;
                                ques.riskTypes["collectionRiskTypeId"] = tCollectionRiskTypeId;
                              }
                            })
                          }
                          if (item3.subRisks != undefined && item3.subRisks != null && item3.subRisks.length > 0) {
                            item3.subRisks.forEach((item4) => {
                              tCollectionRiskTypeId = item4.collectionRiskTypeId;
                              if (item4.questions != undefined && item4.questions != null && item4.questions.length > 0) {
                                item4.questions.forEach((ques) => {
                                  if (ques.riskTypes != undefined && ques.riskTypes != null) {
                                    ques.riskTypes["collectionRiskId"] = tCollectionRiskId;
                                    ques.riskTypes["collectionRiskTypeId"] = tCollectionRiskTypeId;
                                  }
                                })
                              }
                              if (item4.subRisks != undefined && item4.subRisks != null && item4.subRisks.length > 0) {
                                item4.subRisks.forEach((item5) => {
                                  tCollectionRiskTypeId = item5.collectionRiskTypeId;
                                  if (item5.questions != undefined && item5.questions != null && item5.questions.length > 0) {
                                    item5.questions.forEach((ques) => {
                                      if (ques.riskTypes != undefined && ques.riskTypes != null) {
                                        ques.riskTypes["collectionRiskId"] = tCollectionRiskId;
                                        ques.riskTypes["collectionRiskTypeId"] = tCollectionRiskTypeId;
                                      }
                                    })
                                  }
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
            let sendJson = JSON.stringify(rtnData);
            axios(CONFIG.MAIN_URL + CONFIG.CONTROLLER_NAME + '/save', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
              },
              data: sendJson,
            })
              .then(function (response) {
                console.log("+++++++++++++++++++++++xxxxxxxxxxxxxxxxxxresponse,DATAxxxxxxxxxxxxx++++++++++++++++++++++++++");
                console.log(response.DATA);
                alert("Questionnaire Group saved successfully.");
                setCollectionTitle('')
                setCollectionDescription('')
                setOpenTextFieldDialog(false);

              })
              .catch(function (error) {
                console.log(error);
                alert("Error saving Questionnaire Group 2-:" + error);
              });
          })
          .catch(function (error) {
            console.log(error);
            alert("Error saving Questionnaire Group 2-:" + error);
          });

      })
      .catch(function (error) {
        console.log(error);
        alert("Error saving Collection Data to Database Server -:" + error);
      });
  }
  const handleConfirmationDialogClose = () => {
    setOpenConfirmationDialog(false);
  };

  const handleYesClick = () => {
    setOpenConfirmationDialog(false);
    setOpenTextFieldDialog(true);
  };

  const handleTextFieldDialogClose = () => {
    setOpenTextFieldDialog(false);
  };










  const [selectedRegisterFinaliseTitle, setSelectedRegisterFinaliseTitle] = useState("")
  const [selectedRegisterFinaliseObj, setSelectedRegisterFinaliseObj] = useState({})
  const [selectedRegisterFinaliseObjOrg, setSelectedRegisterFinaliseObjOrg] = useState({})
  const [openRegisterFinalise, setOpenRegisterFinalise] = useState(false)
  const [openRegisterFinaliseScroll, setOpenRegisterFinaliseScroll] = useState('paper');
  const [globalRiskArray, setGlobalRiskArray] = useState([]);


  function registerFinaliseClose() {
    getAllRegister(globalCentreId, globalUserId, globalUserRoleId, ipAddress);
    setOpenRegisterFinalise(false)
  }

  function findRiskAvailability(gObj, regId) {
    var updatedWithRiskHierarchy = false;
    if (gObj.riskRegister != null) {
      gObj.riskRegister.forEach((item) => {
        item.risks.forEach((data) => {
          if (data.riskHierarchy != null) {
            if (data.riskHierarchy.riskId != null && data.riskHierarchy.riskId != '') {
              updatedWithRiskHierarchy = true;
            }
          }
        })
      })
      if (!updatedWithRiskHierarchy) {
        return 'Not Available';
      } else {
        return 'Available';
      }
    } else {
      return 'Not Available';
    }
  }

  function finaliseRegisterFunction(gObj, regId) {
    var arr = [];
    var updatedWithRiskHierarchy = false;
    gObj.riskRegister.forEach((item) => {
      item.risks.forEach((data) => {
        if (data.riskHierarchy != null) {
          if (data.riskHierarchy.riskId != null && data.riskHierarchy.riskId != '') {
            updatedWithRiskHierarchy = true;
          } else {
            var obj = {}
            obj["key"] = data.riskHierarchy.key;
            obj["name"] = data.riskHierarchy.name;
            arr.push(obj);
          }
        }
      })
    })
    if (!updatedWithRiskHierarchy) {
      var answer = window.confirm("You have not completed Risk Hierarchies for any of the Sections. Please complete by adding risk hierarchies and try again.\n\n\nDo you want to add risk hierarchies now?");
      if (answer) {
        //editRegisterArrary(regId,gObj);

        setLoading1(true);
        axios(CONFIG.MAIN_URL + `/register/all`, {
          method: 'get',
        })
          .then(function (response) {
            var arr = []
            console.log("all register");
            console.log(response.data);
            response.data.forEach((item) => {
              if (item.centreId === globalCentreId) {
                arr.push(item);
                console.log(arr);
              }
            })
            arr.forEach((data) => {
              if (data.id === regId) {
                setSelectedRegisteredId(regId)
                setSelectedRegisterDataObj(data);
              }
            })
            setLoading1(false);
            setOpenRiskHierarchyComponent(true)
            setOpenRiskHierarchyComponentScroll('paper')

          })
          .catch(function (error) {
            setLoading1(false);
            console.log(error);
          });

        //addRiskFuction();
      }


      //alert("You have not completed Risk Hierarchies for any of the Sections. Please complete by adding risk hierarchies and try again");
      return;
    }

    var canFinalise = false;
    if (arr.length > 0) {
      //Should give a confirm message that some risk hierarchies are not set properly
      canFinalise = true;
    } else {
      canFinalise = true;
    }
    if (canFinalise) {
      setLoading(true);
      axios(CONFIG.MAIN_URL + `/risk/all?centreId=` + globalCentreId, {
        method: 'get',
      })
        .then(function (response) {
          console.log("Risk All Return Response");
          console.log(response.data);
          setGlobalRiskArray(response.data);

          gObj.riskRegister.forEach((item) => {
            item.risks.forEach((item1) => {
              if (item1.riskHierarchy != null) {
                if (item1.riskHierarchy.riskId != null && item1.riskHierarchy.riskId != '') {
                  let shouldContinue = true;
                  for (let i = 0; i < response.data.length && shouldContinue; i++) {
                    var riskD = response.data[i];
                    if (riskD.riskId === parseInt(item1.riskHierarchy.riskId)) {
                      shouldContinue = false;
                      item1.riskHierarchy["riskHierarchyData"] = riskD;
                    }
                  }
                }
              }
            })
          })
          var regCount = 0;
          allRegister.forEach((item) => {
            if (item.registerUniqueName === gObj.registerUniqueName) {
              regCount++;
            }
          })


          var obj = {};
          const d = new Date();
          var dateStr = d.getDate() + "/" + d.getMonth() + "/" + d.getFullYear() + "  " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
          obj["id"] = gObj.id;
          obj["name"] = gObj.name;
          obj["description"] = gObj.description;
          obj["centreId"] = globalCentreId;
          obj["status"] = 'Finalise-' + regCount;
          obj["registerUniqueName"] = gObj.registerUniqueName;
          obj["documentCreator"] = "expert";
          obj["riskRegister"] = gObj.riskRegister;

          console.log(obj);
          setLoading(false);


          var tmpIdCount = 1;
          var tmpIdCount1 = 1;
          var jsonObj = createJsonObject(obj);
          setSelectedRegisterFinaliseTitle(gObj.name)
          jsonObj.riskTypes.forEach((item1, index) => {
            item1["riskTypeTmpId"] = tmpIdCount;
            tmpIdCount++
            if (item1.subRisks != undefined && item1.subRisks != null && item1.subRisks.length > 0) {
              tmpIdCount = assignExtraAttributes(item1.subRisks, tmpIdCount);
            }
            tmpIdCount++;
          })
          setSelectedRegisterFinaliseObj(jsonObj);
          setSelectedRegisterFinaliseObjOrg(obj);
          setOpenRegisterFinalise(true);
          setOpenRegisterFinaliseScroll('paper')
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
        });
    } else {
      alert("")
    }

  }


  function formatDateXX(string) {
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(string).toLocaleString("en-GB");
  }




  const registerTableRowData = (
    <TableBody>
      {allRegister.filter(reg => reg.canEdit).map((row, index) => {
        return (
          <StyledTableRow key={index} className={classes.tableTrStyle}>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} >
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>{row.gptSessionId}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} >
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>{row.name}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} title={row.description}>
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>
              <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      className='buttonStyle'
                      //onMouseOver={row.name}
                    >
                      Show
                    </Button>
                </div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ textAlign: 'center' }}>
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>{findRiskAvailability(row, row.id)}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ textAlign: 'center' }}>
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>{formatDate(row.createdDate)}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ textAlign: 'center' }}>
              <div style={{ whiteSpace: 'normal' }} className='tableStyle'>{row.createdUserId}</div>
            </StyledTableCell>
            <StyledTableCell
              align="center"
              className={classes.tableTrStyle}
            >
              {row.status.search("Finalise") > -1 ?
                <>
                  &nbsp;
                </>
                :
                <>
                  {row.canFinalise ?
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className='buttonStyle'
                      onClick={() => {
                        finaliseRegisterFunction(row, row.id)
                      }}
                    >
                      Finalise
                    </Button>
                    :
                    <>
                      &nbsp;
                    </>
                  }
                </>
              }
            </StyledTableCell>

            <StyledTableCell
              align="center"
              className={classes.tableTrStyle}
            >
              {row.status.search("Finalise") > -1 ?
                <>
                  {row.canCreateCollections ?
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className='buttonStyle'
                      onClick={() => {
                        handleConfirmationDialogOpen(row)
                      }}
                    >
                      Create
                    </Button>
                    :
                    <>
                      &nbsp;
                    </>
                  }
                </>
                :
                <>
                  &nbsp;
                </>

              }
            </StyledTableCell>


            <StyledTableCell
              align="right"
              className={classes.tableTrStyle}
            >
              {row.status.search("Finalise") > -1 ?
                <DetailsSharp
                  className={'mousePointer'}
                  onClick={() => { showRegisterArrary(row) }}
                />
                :
                <>
                  {row.canEdit ?
                    <EditIcon
                      className={'mousePointer'}
                      onClick={() => { editRegisterArrary(row.id, row) }}
                    />
                    :
                    ''
                  }

                </>
              }
            </StyledTableCell>
            <StyledTableCell
              align="right"
              className={classes.tableTrStyle}
            >
              {row.status.search("Finalise") > -1 ?
                <>
                  {row.canDelete ?
                    <Delete
                      className={'mousePointer'}
                      onClick={() => { deleteRegister(row.id, row.registerUniqueName, row.name) }}
                    />
                    :
                    ''
                  }
                </>
                :
                ''
              }
            </StyledTableCell>
          </StyledTableRow>
        )
        //  }
      })}
    </TableBody>
  )


  const [showRegister, setShowRegister] = useState(false);
  const [registerStatus, setRegisterStatus] = useState('');
  const [registerDetailId, setRegisterDetailId] = useState('');


  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const [openHaDetails, setOpenHaDetails] = React.useState(false);
  const [rHName, setRHName] = React.useState('');
  const [rHId, setRHId] = React.useState('');

  const haDetailshandleClose = () => {
    setOpenHaDetails(false);
  };



  const [registerObjFromTable, setRegisterObjFromTable] = React.useState({});

  function showRegisterArrary(gObj) {
    setRHName(gObj.name);
    //setRHId(gObj.id);
    setSelectedRegisteredId(gObj.id);
    setRegisterObjFromTable(gObj)

    setOpenHaDetails(true);


    /*
    setSelectedRegisteredName(gObj.name);
    setSelectedRegisteredId(gObj.id);
    editRiskFuction()
    */
  }




  function deleteRegister(id, uniqueName, deletedRegisterName) {
    var obj = {};
    obj["id"] = id;
    obj["registerUniqueName"] = uniqueName;

    var answer = window.confirm("You are going to delete the finalised register \"" + deletedRegisterName + "\". \n\n Press 'OK' to confirm");
    if (answer) {
      let sendJson = JSON.stringify(obj);
      setLoading(true);
      axios(CONFIG.MAIN_URL + '/register/delete', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        data: sendJson,
      })
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          let rtnData = response.data;
          setLoading(false);
          alert("Register Deleted successfully.");
          getAllRegister(globalCentreId, globalUserId, globalUserRoleId, ipAddress);
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
          alert("Error Deleting Register-:" + error);
        });
    }

  }

  const [fromPreviousRegister, setFromPreviousRegister] = React.useState(false);
  const [previousRegisterObj, setPreviousRegisterObj] = React.useState({});

  function editRegisterArrary(id, gObj) {
    console.log(id)
    console.log(allRegister)

    setPreviousRegisterObj(gObj);
    allRegister.forEach((data) => {
      if (data.id === id) {
        var registerId = data.id;
        var name = data.name;
        var sessionId = "";
        if (data.gptSessionId != undefined && data.gptSessionId != null) {
          sessionId = data.gptSessionId;
        }


        var registerId = data.id;
        var name = data.name;
        var description = data.description;

        setSelectedRegisteredArray(allRegister);
        setSelectedRegisteredId(registerId);
        setSelectedRegisteredName(name);
        setSelectedRegisteredDescription(description);
        setSelectedRiskGPTSessionId(sessionId);

        setStep1(false);
        setStep2(false);
        setStep3(false);
        setStep4(false);
        setStep5(false);
        setStep51(false);
        setRegisterArray([]);
        setCreatedRegister(true)
        setSendMessageField("1")
        setFromPreviousRegister(true);



      }
    })
  }


  //Set Global std for Risk hierarchies
  const [riskStandardOpen, setRiskStandardOpen] = React.useState(false);
  const [globalStandardDataForObjective, setGlobalStandardDataForObjective] = useState('')
  const [globalStandardDataForComponent, setGlobalStandardDataForComponent] = useState('')
  const [globalStandardDataForPrinciple, setGlobalStandardDataForPrinciple] = useState('')
  const [globalStandardData, setGlobalStandardData] = React.useState([]);
  const [standardData, setStandardData] = React.useState([]);
  const [customStandardData, setCustomStandardData] = React.useState([]);


  function getStandards(cntre) {
    axios(CONFIG.MAIN_URL + `/standard/all??centreId=` + cntre, {
      method: 'get',
    })
      .then(function (response) {
        console.log("++++++++++++++++Return Standard Data +++++++++++++++++++");
        console.log(response.data);
        console.log(JSON.stringify(response.data));
        setStandardData(response.data);
        var arrG = [];
        var arrC = [];
        response.data.forEach((item) => {
          if (item.centreId === "globle") {
            arrG.push(item);
          }
          if (item.centreId === cntre) {
            arrC.push(item);
          }
        })
        setGlobalStandardData(arrG);
        setCustomStandardData(arrC);

      })
      .catch(function (error) {
        console.log(error);
      });
  }


  function addRiskFuctionStandard() {
    if (hierarchyKey === '') {
      alert("Please Assign Risk Hierarchy Key")
      return;
    }
    if (hierarchyName === '') {
      alert("Please Assign Risk Hierarchy Name")
      return;
    }

    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (finalHJson === '') {
      alert("Please enter Key words to create Risk Hierarchy")
      return;
    }
    setRiskStandardOpen(true)
  }

  const handleCloseStandardDialog = () => {
    setRiskStandardOpen(false);
  };

  const handleStandardDialogClear = () => {
    setGlobalStandardDataForObjective('');
    setGlobalStandardDataForComponent('')
    setGlobalStandardDataForPrinciple('')
  };


  const handleChangeGlobalStandardDataForObjective = (event) => {
    console.log(globalStandardData)
    setGlobalStandardDataForObjective(event.target.value);
    globalStandardData.filter(com => com.components.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForComponent === '') {
          setGlobalStandardDataForComponent(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.principles.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForPrinciple === '') {
          setGlobalStandardDataForPrinciple(event.target.value)
        }
      }

    })
  }

  const handleChangeGlobalStandardDataForComponent = (event) => {
    setGlobalStandardDataForComponent(event.target.value);
    globalStandardData.filter(com => com.objectives.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForObjective === '') {
          setGlobalStandardDataForObjective(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.principles.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForPrinciple === '') {
          setGlobalStandardDataForPrinciple(event.target.value)
        }
      }
    })
  }

  const handleChangeGlobalStandardDataForPrinciple = (event) => {
    setGlobalStandardDataForPrinciple(event.target.value);
    globalStandardData.filter(com => com.objectives.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForObjective === '') {
          setGlobalStandardDataForObjective(event.target.value)
        }
      }

    })
    globalStandardData.filter(com => com.components.length > 0).forEach((obj) => {
      if (obj.standardName === event.target.value) {
        if (globalStandardDataForComponent === '') {
          setGlobalStandardDataForComponent(event.target.value)
        }
      }
    })
  }




  //End of set Risk


  //Redo Risk register with hirerchies and number of riskd

  const [openRegisterForRedo, setOpenRegisterForRedo] = React.useState(false);
  const [openRegisterForRedoScroll, setOpenRegisterForRedoScroll] = React.useState('paper');
  const [redoSectionHeadingName, setRedoSectionHeadingName] = React.useState('');
  const handleChangeSectionHeadingName = (event) => {
    setRedoSectionHeadingName(event.target.value);
  }
  
  const [redoRiskHierarchies, setRedoRiskHierarchies] = React.useState('');
  const handleChangeRiskHierarchies = (event) => {
    setRedoRiskHierarchies(event.target.value);
  }

  function validateSchemaAndCreateRegisterRedo() {
    if (redoSectionHeadingName === '') {
      alert('please enter at least one section name')
      return;
    }
    var tmpArr = redoSectionHeadingName.split(";");
    if (tmpArr.length > 10) {
      alert('The maximum number of sections you can enter is 10. Please limit it to 10 sections.')
      return;
    }
    //setSectionHeadingName(redoSectionHeadingName);
    var secArr = [];
    tmpArr.forEach((data, index) => {
      var obj = {};
      obj["section"] = data.trim();
      secArr.push(obj);
    })
    setRegisterArray(secArr);
    
    
    if (isNaN(redoRiskHierarchies) || redoRiskHierarchies === "") {
      alert("Invalid number. Please enter no of Risk Hierarchies per a Section")
      return;
    }
    if (parseInt(redoRiskHierarchies) > 8) {
      alert("The maximum number of risk hierarchies you can enter is 8. Please limit it to 8 risk hierarchies.")
      return;
    }
    var msg = "";
    var canContinue = true;
    var secCount = secArr.length;
    var riCount = parseInt(redoRiskHierarchies);
    if (secCount === 10) {
      if (riCount > 2) {
        var tCount = 2;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 9) {
      if (riCount > 3) {
        var tCount = 3;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 8) {
      if (riCount > 4) {
        var tCount = 4;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 7) {
      if (riCount > 5) {
        var tCount = 5;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 6) {
      if (riCount > 6) {
        var tCount = 6;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 5) {
      if (riCount > 7) {
        var tCount = 7;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (secCount === 4) {
      if (riCount > 8) {
        var tCount = 8;
        msg = "The maximum number of risk hierarchies for the " + secCount + " sections is " + tCount + " for each section. Please enter " + tCount + " or fewer risk hierarchies."
        canContinue = false;
      }
    }
    if (!canContinue) {
      alert(msg);
      return;
    }
    setNoOfRiskHierarchies(parseInt(redoRiskHierarchies));

    console.log(secArr)
    console.log(parseInt(redoRiskHierarchies))
    
    setOpenRegisterForRedo(false);
    setOpenAllSchemadiaplay(false);
    setTimeout(() => {
      validateSchemaAndCreateRegister(2, secArr, redoRiskHierarchies);
    }, 100);


  }

   /** GPT Research Section */

   const [openDisplayResearchChoice, setOpenDisplayResearchChoice] = React.useState(false);
   const [redoUsingResearch, setRedoUsingResearch] = React.useState(false);
 
   function startAgainFuction1() {
     setOpenDisplayResearchChoice(true);
     setRedoUsingResearch(false)
   }
 
   function startAgainFuction2() {
     setRedoUsingResearch(false)
     startAgainFuction();
   }
   function startAgainFuction3() {
     setRedoUsingResearch(true)
     startAgainFuction();
   }
 
   const handleCloseDisplayResearchChoice = () => {
     setOpenDisplayResearchChoice(false);
   };
 
   const wordstyle1 = 'wordStyle'
   const [openRiskGpt, setOpenRiskGpt] = React.useState(false);
   const [openRiskGptScroll, setOpenRiskGptScroll] = React.useState('paper');
   const [gptTextArray, setGptTextArray] = React.useState([]);
 
   function openRiskGptFunction() {
     setGptTextArray([])
     setOpenRiskGpt(true)
     setGptText('');
     setOpenRiskGptScroll('paper')
     setOpenDisplayResearchChoice(false);
   }
 
   const [gptText, setGptText] = React.useState('');
   const handleChangeGptText = (e) => {
     setGptText(e.target.value);
     if (e.target.value != '') {
       document.getElementById('btnSend').style.color = 'white';
       document.getElementById('btnSend').style.backgroundColor = 'black';
     } else {
       document.getElementById('btnSend').style.color = 'black'
       document.getElementById('btnSend').style.backgroundColor = 'aliceblue'
     }
   };
 
   function formatDate(date1) {
     const date = new Date(date1)
     const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, "0");
     const day = String(date.getDate()).padStart(2, "0");
     const hours = String(date.getHours()).padStart(2, '0');     // Get current hour (00-23)
     const minutes = String(date.getMinutes()).padStart(2, '0'); // Get current minutes (00-59)
     const seconds = String(date.getSeconds()).padStart(2, '0'); // Get current seconds (00-59)
     return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
 
   }
 
   const [answerCount, setAnswerCount] = React.useState(0);
 
   const saveTheResult1 = () => {
     if (gptTextArray.length === 0) {
       alert("No answers available")
       return;
     }
     var ans = "";
     gptTextArray.forEach((item, index) => {
       if ((index + 1) === gptTextArray.length) {
         ans = item.answer;
       }
     })
 
     const lines = ans.split("\n");
 
 
     const paragraphs = [];
 
     lines.forEach((line) => {
       if (line.trim().startsWith("###")) {
         const newText = line.replace("###", "").trim();
         const newText1 = newText.replace("**", "").trim()
 
         const newText2 = newText1.replace(/\*\*$/, "").trim();
 
         console.log(newText2);
         paragraphs.push(
           new Paragraph({
             children: [
               new TextRun({
                 text: newText2,
                 bold: true,
                 size: 32,
               }),
             ],
             spacing: { after: 200 },
           })
         );
       } else if (line.trim() !== "") {
         const newText = line.replace("#", "").trim();
         const textParts = newText.split(/\*\*/);
         const textRuns = [];
 
         textParts.forEach((part, index) => {
 
           if (part.trim() !== "") {
             console.log(part)
             textRuns.push(
               new TextRun({
                 text: part.replace("**", "").trim(),
                 bold: index % 2 !== 0,
                 size: 24,
               })
             );
           }
         });
         // const newText = textRuns.replace("###", "").trim()
 
         paragraphs.push(
 
           new Paragraph({
             children: textRuns,
             spacing: { after: 200 },
           })
         );
       }
 
 
     });
 
 
     const doc = new Document({
       sections: [
         {
           children: paragraphs,
         },
       ],
     });
 
     // Generate the docx file and save it
     Packer.toBlob(doc).then((blob) => {
       saveAs(blob, `answer-${formatDateForId(new Date())}.docx`);
     });
   }
 
   const saveTheResult = () => {
 
     if (gptTextArray.length === 0) {
       alert("No answers available")
       return;
     }
     var ans = "";
     gptTextArray.forEach((item, index) => {
       if ((index + 1) === gptTextArray.length) {
         ans = item.answer;
       }
     })
 
     const doc = new jsPDF();
     const lines = ans.split('\n');
     let y = 22;
     const lineHeight = 7;
 
     lines.forEach(line => {
       if (line.trim().startsWith('###')) {
         doc.setFont('times', 'bold');
         doc.setFontSize(18);
         line = line.replace('###', '').trim();
       } else {
         doc.setFont('times', 'normal');
         doc.setFontSize(13);
       }
 
       if (line.includes('**')) {
         doc.setFont('times', 'bold');
         line = line.replace(/\*\*/g, '');
       }
 
       const textLines = doc.splitTextToSize(line, 180);
       textLines.forEach(txt => {
         doc.text(txt, 14, y);
         y += lineHeight;
 
         if (y > doc.internal.pageSize.height - 10) {
           doc.addPage();
           y = 22;
         }
       });
     });
 
     doc.save(`answer-${formatDateForId(new Date())}.pdf`);
 
   };
 
   function resetGtp() {
     setGptTextArray([])
     setGptText('')
   }
 
   const [messageId, setMessageId] = React.useState(1);
   function formatDateForId(date) {
     const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, "0");
     const day = String(date.getDate()).padStart(2, "0");
     return `${year}-${month}-${day}`;
   }
 
   const formatContent = (text) => {
     // Split the content by newlines
     const textStr = text.replace(/\n/g, '@H'); // 4 spaces for each "#"
     console.log(textStr)
     const allText = textStr.replace(/\#\#\#(.*?)\@\H\@\H/g, (match, p1) => {
       //return `<span style={{color: 'red'}}>${p1}</span>@H@H`;
       return `<strong style="color: teal;font-size: 20px;"><u>${p1}</u></strong>@H@H`;
     });
     console.log(allText)
     return allText.split('@H').map((line, index) => {
       // Replace "#" with tabs (indentation using non-breaking space &nbsp;)
       const tabbedLine1 = line.replace(/#/g, ''); // 4 spaces for each "#"
       const tabbedLine2 = tabbedLine1.replace(/\-\-\-/g, ''); // 4 spaces for each "#"
       //const tabbedLine = tabbedLine2.replace(/-/g, '\u00A0\u00A0\u00A0-'); // 4 spaces for each "#"
       // Replace **bold** and remove the surrounding ** marks
       const formattedLine = tabbedLine2.replace(/\*\*(.*?)\*\*/g, (match, p1) => {
         return `<strong>${p1}</strong>`;
       });
 
       // Return as HTML content, dangerouslySetInnerHTML is used to allow HTML like <strong>
       return (
         <div key={index} dangerouslySetInnerHTML={{ __html: formattedLine }}></div>
       );
     });
   };
 
 
   function sentToChatGtp() {
     var obj = {}
     obj["userId"] = globalCentreId;
     obj["createdBy"] = globalUserId;
     console.log(globalCentreId + "-" + globalUserId)
 
     var objArr = [];
 
     var obj1 = {}
     obj1["messageId"] = formatDateForId(new Date()) + "-" + messageId;
     setMessageId(messageId + 1);
     obj1["message"] = gptText;
     objArr.push(obj1);
     obj["chats"] = objArr
     var sendJson = JSON.stringify(obj)
     setLoading1(true)
 
     axios(CONFIG.MAIN_URL + '/openai/advancechat', {
       method: 'post',
       headers: {
         'Content-Type': 'application/json',
       },
       data: sendJson,
     })
       .then(function (response) {
         console.log(JSON.stringify(response.data));
         var obj = {};
         obj["question"] = gptText;
         var ans = response.data.answer.replaceAll('\n', '<br>')
         obj["answer"] = (response.data.answer);
         setGptTextArray([...gptTextArray, obj]);
         setGptText('')
         setLoading1(false)
         document.getElementById('btnSend').style.color = 'black'
         document.getElementById('btnSend').style.backgroundColor = 'aliceblue'
 
       })
       .catch(function (error) {
         console.log(error);
         setLoading1(false)
         alert("Error saving Question -:" + error);
       });
 
 
   }
 


  return (
    <>
      <RightBarDataForOtherPages PageName={PageName} />

      <div className={classes.pageTop}>
        <Grid container spacing={2}>
          <Grid container spacing={2} className={classes.pageBodyStyle}>

            <Grid item xs={12}>
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" to="/login">
                    <span className='breadcrumbsStyle'>Home</span>
                  </Link>
                  <Typography color="text.primary"><span className='breadcrumbsStyle'>Main menu - {PageName}</span></Typography>
                </Breadcrumbs>
              </div>
            </Grid>
            <Grid item xs={12}>
              <a style={{ float: 'right', marginTop: '-36px', color: '#0056b3', cursor: 'pointer' }} onClick={() => navigate(-1)}><ArrowBack /> <span className='breadcrumbsStyle'>Go Back</span></a>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '-30px' }}>
              <Divider>
                <Chip
                  className={wordstyle}
                  label="Risk Registers created"
                />
              </Divider>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '-12px' }}>
              <Card style={{ "width": "100% !important", border: "1px solid black", height: `${tableDivHeight}px`, overflowY: 'auto' }}>
                <CardContent>
                  <Grid item xs={12} class='visibleDiv' >
                    {allRegister.filter(reg => reg.canEdit).map((row, index) => {
                      return (
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Card style={{ "width": "98% !important", border: "1px solid black" }}>
                              <CardContent>
                                <Grid container spacing={0}>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Session Id :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <span class='valuesText'>{row.gptSessionId}</span>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Register :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <span class='valuesText'>{row.name}</span>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Created :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <span class='valuesText'>{formatDate(row.createdDate)}</span>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Created User Id :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <span class='valuesText'>{row.createdUserId}</span>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Finalise Register :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    {row.status.search("Finalise") > -1 ?
                                      <>
                                        &nbsp;
                                      </>
                                      :
                                      <>
                                        {row.canFinalise ?
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className='buttonStyle'
                                            onClick={() => {
                                              finaliseRegisterFunction(row, row.id)
                                            }}
                                          >
                                            Finalise
                                          </Button>
                                          :
                                          <>
                                            &nbsp;
                                          </>
                                        }
                                      </>
                                    }
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Create Collection :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    {row.status.search("Finalise") > -1 ?
                                      <>
                                        {row.canCreateCollections ?
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className='buttonStyle'
                                            onClick={() => {
                                              handleConfirmationDialogOpen(row)
                                            }}
                                          >
                                            Create
                                          </Button>
                                          :
                                          <>
                                            &nbsp;
                                          </>
                                        }
                                      </>
                                      :
                                      <>
                                        &nbsp;
                                      </>

                                    }
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Edit/Show :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    {row.status.search("Finalise") > -1 ?
                                      <DetailsSharp
                                        className={'mousePointer'}
                                        onClick={() => { showRegisterArrary(row) }}
                                      />
                                      :
                                      <>
                                        {row.canEdit ?
                                          <EditIcon
                                            className={'mousePointer'}
                                            onClick={() => { editRegisterArrary(row.id, row) }}
                                          />
                                          :
                                          ''
                                        }

                                      </>
                                    }
                                  </Grid>
                                  <Grid item xs={4}>
                                    <span class='headingsText'>Delete :</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                    {row.status.search("Finalise") > -1 ?
                                      <>
                                        {row.canDelete ?
                                          <Delete
                                            className={'mousePointer'}
                                            onClick={() => { deleteRegister(row.id, row.registerUniqueName, row.name) }}
                                          />
                                          :
                                          ''
                                        }
                                      </>
                                      :
                                      ''
                                    }
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Grid item xs={12} class='hideDiv'>
                    <div style={{ marginTop: '-6px' }}>
                      <TableContainer component={Paper} sx={{ maxHeight: tableHeight }}>
                        <Table stickyHeader aria-label="sticky table" style={{ border: '1px solid #ddd' }}>
                          <TableHead className='commonSecondaryTableHead'>
                            <TableRow>
                              <StyledTableCell className={'commonTableThStikyStyle'} style={{ width: '10%' }}>Session Id</StyledTableCell>
                              <StyledTableCell className={'commonTableThStikyStyle'} style={{ width: '19%' }}>Register</StyledTableCell>
                              <StyledTableCell className={'commonTableThStikyStyle'} style={{ width: '9%' }}>Description</StyledTableCell>
                              <StyledTableCell className={'commonTableThStikyStyle'} style={{ width: '7%' }}>Risk?</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '10%', textAlign: 'center' }}>Created</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '10%', textAlign: 'center' }}>Created User Id</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '10%', textAlign: 'center' }}>Finalise Register</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '10%', textAlign: 'center' }}>Create Collection</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '8%' }}>Edit/Show</StyledTableCell>
                              <StyledTableCell align="right" className={'commonTableThStikyStyle'} style={{ width: '7%' }}>Delete</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          {registerTableRowData}
                        </Table>
                      </TableContainer>
                    </div>
                  </Grid>
                </CardContent>
              </Card>

            </Grid>


            <Grid item xs={12}>
              {!fromPreviousRegister && !hideSeletion ?
                <Grid container spacing={2}>
                  {qaArray.length === 0 ?
                    <>
                      <Grid item xs={12}>
                        <div style={{ marginTop: '-6px' }}>
                          <TableContainer component={Paper} sx={{ maxHeight: 100 }}>
                            <Table stickyHeader aria-label="sticky table" style={{ border: '1px solid #ddd' }}>
                              <TableBody>
                                <StyledTableRow key={0} className={classes.tableTrStyle}>
                                  <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%' }}>
                                    <div style={{ whiteSpace: 'normal' }}>
                                      <BootstrapTooltip title='Risk GPT'>
                                        <Avatar
                                          sx={{
                                            bgcolor: red[500],
                                            height: '25px',
                                            width: '25px',
                                            fontSize: '1.0rem !important'
                                          }} variant="square">
                                          <span className={wordstyle}>RG</span>
                                        </Avatar>
                                      </BootstrapTooltip>
                                    </div>
                                  </StyledTableCell>
                                  <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                                    <p className={`${secondStyle} ${wordstyle}`} style={{ lineHeight: '1.0rem', fontFamily: 'Signifer-Light, Sohne-Bold, Sohne-Regular, SohneMono-Bold, SohneMono-Regular' }}>Create {'1) A risk Register'} {'2) A risk Hierarchy'}. Answer 1 or 2 ?.</p>
                                  </StyledTableCell>
                                  <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '5%' }}>
                                    <div style={{ whiteSpace: 'normal' }}>
                                      <BootstrapTooltip title={createUser}>
                                        <Avatar
                                          sx={{
                                            bgcolor: green[500],
                                            height: '25px',
                                            width: '25px',
                                            fontSize: '1.0rem !important'
                                          }} variant="square">
                                          <span className={wordstyle}>{createUser.substr(0, 2)}</span>
                                        </Avatar>
                                      </BootstrapTooltip>
                                    </div>
                                  </StyledTableCell>
                                  <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} style={{ width: '45%' }}>
                                    &nbsp;
                                  </StyledTableCell>
                                </StyledTableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Grid>

                      <Grid item className='textfieldGrid1'>
                        <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                          <TextField
                            variant="outlined"
                            placeholder='Answer 1 or 2'
                            value={sendMessageField}
                            onChange={handleSendMessage}
                            //focused={true}
                            id='txtSendMessageField'
                            onClick={textFieldClickBlinkStop}
                          />
                        </Box>

                      </Grid>
                      <Grid item className='textfieldGrid2'>
                        <Button variant="contained" onClick={handleButtonStep1Click} style={{ height: '50px', }}>Next</Button>
                      </Grid>

                    </>
                    :
                    <>
                      <Grid item xs={12} id='messageHtml'>
                        <p className='tableStyle'>{registerArrayQa}</p>
                      </Grid>
                      {startAgain && !displayStartAgainTextBox ?
                        <>
                          <Grid item className='textfieldGrid1'>
                            <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                              <TextField
                                variant="outlined"
                                value={sendMessageField}
                                onChange={handleSendMessage}
                                focused={true}
                                id='txtSendMessageField'
                                onClick={textFieldClickBlinkStop}
                              />
                            </Box>

                          </Grid>
                          <Grid item className='textfieldGrid2'>
                            <Button variant="contained" onClick={handleButtonStep1Click} style={{ height: '50px', }}>Next</Button>
                          </Grid>
                        </>

                        :
                        ''
                      }




                    </>
                  }
                </Grid>
                :
                ''
              }


              {sendMessageField === '1' ?
                <>
                  {!createdRegister ?
                    <>
                      <Grid container spacing={2}>
                        {step1 && !step2 ?
                          <>

                            <Grid item xs={10} className='textfieldGrid1X'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                {startAgain ?
                                  <TextField
                                    variant="outlined"
                                    value={registerName}
                                    onChange={handleChangeRegisterName}
                                    focused={true}
                                    //id='txtRegisterName'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                  :
                                  <TextField
                                    variant="outlined"
                                    value={registerName}
                                    onChange={handleChangeRegisterName}
                                    //focused={true}
                                    id='txtRegisterName'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                }
                              </Box>

                            </Grid>
                            <Grid item xs={2} className='textfieldGrid2X'>
                              <Button variant="contained" onClick={handleButtonStep2Click} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={handleButtonStep2ClickPre} style={{ height: '50px', }}>Previous</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && !step3 ?
                          <>
                            <Grid item xs={10} className='textfieldGrid1X'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                {startAgain ?
                                  <TextField
                                    variant="outlined"
                                    value={registerDescription}
                                    onChange={handleChangeRegisterDescription}
                                    focused={true}
                                    //id='txtRegisterDescription'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                  :
                                  <TextField
                                    variant="outlined"
                                    value={registerDescription}
                                    onChange={handleChangeRegisterDescription}
                                    //focused={true}
                                    id='txtRegisterDescription'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                }
                              </Box>
                            </Grid>
                            <Grid item xs={2}  className='textfieldGrid2X'>
                              <Button variant="contained" onClick={handleButtonStep3Click} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={handleButtonStep3ClickPre} style={{ height: '50px', }}>Previous</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && !step4 ?
                          <>


                            <Grid item xs={10} className='textfieldGrid1X'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                {startAgain ?
                                  <TextField
                                    variant="outlined"
                                    value={sectionHeadingName}
                                    onChange={onChangeSectionHeadingName}
                                    focused={true}
                                    //id='txtSectionHeadingName'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                  :
                                  <TextField
                                    variant="outlined"
                                    value={sectionHeadingName}
                                    onChange={onChangeSectionHeadingName}
                                    //focused={true}
                                    id='txtSectionHeadingName'
                                    onClick={textFieldClickBlinkStop}
                                  />
                                }
                              </Box>

                            </Grid>

                            {/** 
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => clickSectionMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                            */}

                            <Grid item xs={2} className='textfieldGrid2X'>
                              <Button variant="contained" onClick={() => addingSectionFinishButton()} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => addingSectionFinishButtonPre()} style={{ height: '50px', }}>Previous</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && !step5 ?
                          <>

                            <Grid item xs={9} className='textfieldGrid3X'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={riskDescription}
                                  onChange={onChangeRiskDescription}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>


                            {/** 
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => riskMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                            */}


                            <Grid item xs={3} className='textfieldGrid4X'>
                            <Button variant="contained" onClick={() => riskFinish()} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => finalizeReg()} style={{ height: '50px', }}>Finish</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => riskFinishPre()} style={{ height: '50px', }}>Previous</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }
                        {step51 ?
                          <>
                            <Grid item className='textfieldGrid1'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  id='txtNoOfRiskHierarchies'
                                  //label="Question Id"
                                  variant="outlined"
                                  //value={questionId}
                                  //onChange={handlequestionId}
                                  //focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item className='textfieldGrid2'>
                              <Button variant="contained" onClick={() => onClickNoOfRiskHierarchies()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                          </>
                          :
                          ''
                        }





                        {step1 && step2 && step3 && step4 && step5 && !step51 && !step6 ?
                          <>
                            <Grid item className='textfieldGrid6'>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  //label="Question Id"
                                  variant="outlined"
                                  value={questionId}
                                  onChange={handlequestionId}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item className='textfieldGrid5'>
                              <Button variant="contained" onClick={() => sendToDataBase()} style={{ height: '50px', }}>Create Register</Button>
                            </Grid>
                          </>
                          :
                          ''
                        }


                      </Grid>

                      <br></br>
                    </>
                    :
                    <>
                      <Grid container spacing={2}>
                        <Grid item xs={12} style={{ textAlign: 'center' }}>

                          {!fromPreviousRegister ?
                            <>
                              <span style={{ fontWeight: 600 }} className={wordstyle}>
                                {selectedRegisteredName} </span><span className={wordstyle}>has been created - </span><span className={wordstyle}>Risk GPT session Id: {selectedRiskGPTSessionId}.
                              </span>
                            </>
                            :
                            <>
                              <span style={{ fontWeight: 600 }} className={wordstyle}>{selectedRegisteredName}</span><span className={wordstyle}>{selectedRiskGPTSessionId != '' ? " - Risk GPT session Id: " + selectedRiskGPTSessionId : ''}</span>
                            </>
                          }
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <Button
                            variant="contained"
                            className='buttonStyle'
                            onClick={() => clearButton()}
                          >
                            clear
                          </Button>

                        </Grid>
                        <Grid item xs={12}>
                          <div style={{ display: 'flex', gap: '5px', textAlign: 'center', justifyContent: 'center' }}>
                            <div class="arrow-1"></div>



                            {!fromPreviousRegister ?
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={handleClickOpen}
                              >Show Response</Button>
                              :
                              ''
                            }
                            <Button
                              variant="contained"
                              className='buttonStyle'
                              onClick={() => evaluateRiskFuction()}
                            >
                              Evaluate
                            </Button>
                            {isTrialCentre ?
                              <>
                                {trialEditRegisters ?
                                  <Button
                                    variant="contained"
                                    className='buttonStyle'
                                    onClick={() => editRiskFuction()}
                                  >
                                    Edit Register
                                  </Button>
                                  :
                                  ''
                                }
                              </>
                              :
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={() => editRiskFuction()}
                              >
                                Edit Register
                              </Button>
                            }
                            <Button
                              variant="contained"
                              className='buttonStyle'
                              onClick={() => addRiskFuction()}
                            >
                              Add Risk Hierarchy
                            </Button>
                            {isTrialCentre ?
                              <>
                                {trialRedoRegisters ?

                                  <Button
                                    variant="contained"
                                    className='buttonStyle'
                                    onClick={() => startAgainFuction1()}
                                  >
                                    Re-do
                                  </Button>
                                  :
                                  ''
                                }
                              </>
                              :
                              <Button
                                variant="contained"
                                className='buttonStyle'
                                onClick={() => startAgainFuction1()}
                              >
                                Re-do
                              </Button>
                            }

                          </div>
                        </Grid>
                      </Grid>
                    </>
                  }
                </>
                :
                ''
              }
              {sendMessageField === '2' ?
                <>
                  {!createdHierachy ?
                    <>
                      <Grid container spacing={2}>
                        {step1 && !step2 ?
                          <>

                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={hierarchyKey}
                                  onChange={handleChangeHierarchyKey}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>
                            <Grid item xs={2}>
                              <Button variant="contained" onClick={handleButtonStep2HClick} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={handleButtonStep2HClickPre} style={{ height: '50px', }}>Previous</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && !step3 ?
                          <>
                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={hierarchyName}
                                  onChange={handleChangeHierarchyName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={2}>
                              <Button variant="contained" onClick={handleButtonStep3HClick} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={handleButtonStep3HClickPre} style={{ height: '50px', }}>Previous</Button>
                            </Grid>

                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && !step4 ?
                          <>
                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={mainRiskName}
                                  onChange={onChangeMainRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>

                            {/** 
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => clickMainRiskMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                            */}
                            <Grid item xs={2}>

                              <Button variant="contained" onClick={() => clickMainRiskDoneButton()} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => clickMainRiskDoneButtonPre()} style={{ height: '50px', }}>Previous</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && !step5 ?
                          <>

                            <Grid item xs={9}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={subRiskName}
                                  onChange={onChangeSubRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            {/** 
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => subRiskMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                            */}

                            <Grid item xs={3}>
                            <Button variant="contained" onClick={() => subRiskDone()} style={{ height: '50px', }}>Next</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => finishSubRisk()} style={{ height: '50px', }}>Finish</Button>
                              &nbsp;&nbsp;
                              <Button variant="contained" onClick={() => finishSubRiskPre()} style={{ height: '50px', }}>Previous</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }

                        {step1 && step2 && step3 && step4 && step5 && !step6 ?
                          <>

                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  variant="outlined"
                                  value={subSubRiskName}
                                  onChange={onChangeSubSubRiskName}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>
                            </Grid>
                            {/** 
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => subSubRiskMore()} style={{ height: '50px', }}>Next</Button>
                            </Grid>
                            */}
                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => subSubRiskDone()} style={{ height: '50px', }}>Next</Button>
                            </Grid>

                            <Grid item xs={1}>
                              <Button variant="contained" onClick={() => finishSubSubRisk()} style={{ height: '50px', }}>Finish</Button>
                            </Grid>


                          </>
                          :
                          ''
                        }



                        {step1 && step2 && step3 && step4 && step5 && step6 && !step7 ?
                          <>
                            <Grid item xs={10}>
                              <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                <TextField
                                  //label="Question Id"
                                  variant="outlined"
                                  value={questionId}
                                  onChange={handlequestionId}
                                  focused={true}
                                  onClick={textFieldClickBlinkStop}
                                />
                              </Box>

                            </Grid>



                            <Grid item xs={2}>
                              <Button variant="contained" onClick={() => addRiskFuctionStandard()} style={{ height: '50px', }}>Create Risk Hierarchy</Button>
                            </Grid>
                            {/* onClick={() => sendToDataBaseH()} */}
                          </>
                          :
                          ''
                        }


                      </Grid>

                      <br></br>
                    </>
                    :
                    <>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <b><span style={{ fontSize: '1.4rem' }}>{selectedRiskEvaluateTitle} </span></b><span style={{ fontSize: '1.4rem' }}>has been created.</span>
                        </Grid>
                        <Grid item xs={12}>
                          <div style={{ display: 'flex', gap: '5px', textAlign: 'center' }}>
                            <div class="arrow-1"></div>
                            <Button
                              variant="contained"
                              onClick={handleClickOpen}
                            >Show Response</Button>
                            <Button
                              variant="contained"
                              onClick={() => evaluateRiskHFuction()}
                            >
                              Evaluate
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => editRiskHFuction()}
                            >
                              Edit Risk Hierarchy
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => showQuestionFuction()}
                            >
                              Show Questions
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => clearButton()}
                            >clear</Button>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  }
                </>
                :
                ''
              }



            </Grid>


          </Grid>
        </Grid>
      </div>

      <Dialog
        open={loading}
        onClose={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          <span style={{ textAlign: 'center' }}>Processing !.<br></br>
            Please Wait .......</span>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <CircularWithValueLabel
              />

              {/*
              <ClockLoader
                size={100}
                color={'red'}
                className={classes.loaderStyle}
                loading={loading}
              />
            */}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={loading1}
        onClose={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          <span style={{ textAlign: 'center' }}>Please Wait ...</span>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>


              <ClockLoader
                size={100}
                color={'red'}
                className={classes.loaderStyle}
                loading={loading1}
              />

            </Grid>
          </Grid>


        </DialogContent>
      </Dialog>



      {/** For Register Eval */}

      <Dialog
        open={openRegisterDataForEval}
        onClose={false}
        scroll={openRegisterDataForEvalScroll}
        aria-labelledby="register-data-dialog-title"
        aria-describedby="register-data-dialog-description"
        fullWidth={true}
        maxWidth={maxWidthState}
        fullScreen={fullScreenState}
        //PaperComponent={PaperComponentCollectionDataRegister}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Evaluate "{selectedRegisterEvaluateTitle}" - <SavePageAs /></Typography>
          <Typography variant="h6" style={{lineHeight: '1', marginTop: '-8px'}}><span style={{fontSize: '1rem', fontWeight: 'bold'}}>Description :</span> <span style={{fontSize: '1rem'}}>{registerTypeDataForEval.description}</span></Typography>
          <Typography variant="h6" style={{ marginRight: '-22px', padding: '7px', marginTop: '-75px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={RegisterDataForEvalfunctionClose} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>

        <DialogContent dividers={openRegisterDataForEvalScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {multipleRoles ?
                  <EvaluateComponent1
                    colorPatterns={colorPatterns}
                    registerTypeDataForEval={registerTypeDataForEval}
                    openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                    registerEvaluate={true}
                  />
                  :
                  <EvaluateComponent
                    colorPatterns={colorPatterns}
                    registerTypeDataForEval={registerTypeDataForEval}
                    openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                    registerEvaluate={registerEvaluate}
                  />
                }
              </Grid>
            </Grid>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={RegisterDataForEvalfunctionClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/** Edit Register */}
      <Dialog
        open={openRegisterEdit}
        onClose={false}
        scroll={openRegisterEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit Register - "{selectedRegisteredName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRegisterEdit(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskRegisterComponent
                  selectedRegisteredId={selectedRegisteredId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRegisterEdit(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openDisplayChoice}
        onClose={handleCloseDisplayChoice}>
        <DialogTitle>
        {rHName} <br></br>Select the Display Method

        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            How do you want to display the Register
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>&nbsp;</Grid>
            <Grid item xs={5}>
              <Button
                variant="contained"
                component="label"
                onClick={() => byRoleFuction()}
                className='btnFonts'
                style={{ float: 'right' }}
              >
                By Role
              </Button>
            </Grid>
            <Grid item xs={7}>
              <Button
                variant="contained"
                component="label"
                onClick={() => byRiskNameFuction()}
                className='btnFonts'
              >
                By Risk Name
              </Button>
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisplayChoice}>Close</Button>
        </DialogActions>
      </Dialog>


      <div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Questions and answers"}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <textarea
                  name="postContent"
                  rows={20}
                  cols={50}
                  value={questiomRes}
                />
                { }
              </Grid>
            </Grid>


          </DialogContent>
          <DialogActions>

            <Button onClick={handleClose} autoFocus>
              cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/** Edit Risk */}
      <Dialog
        open={openRiskDataEdit}
        onClose={false}
        scroll={openRiskDataEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit "{selectedRiskEvaluateTitle}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={setOpenRiskDataEditfunction} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRiskDataEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskHierarchyNew
                  riskHierarchyId={createdRiskId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={setOpenRiskDataEditfunction}>Cancel</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openShowQuestions}
        onClose={false}
        scroll={openShowQuestionsScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
        //PaperComponent={PaperComponentAllQuestionData}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Questions related to "{selectedRiskEvaluateTitle}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ textAlign: 'right', marginTop: '', marginRight: '-25px', padding: '7px', marginTop: '-50px' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenShowQuestions(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openShowQuestionsScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>

                  <Box
                    sx={{
                      height: 400,
                      width: '100%',
                      '& .super-app-theme--cell': {
                        whiteSpace: 'normal !important',
                        lineHeight: '1',
                      },
                      '& .super-app-theme--Open': {
                        fontSize: '10px !important',
                      },

                    }}
                  >





                    <div style={{ height: 400, width: '100%', backgroundColor: '#ffffff', fontSize: '9px !important' }}>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        getRowClassName={`super-app-theme--Open`}
                        disableSelectionOnClick
                      />
                    </div>

                  </Box>
                </Grid>
              </Grid>


            </Grid>





          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenShowQuestions(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/** Question Details Show Dialog */}
      <Dialog
        maxWidth='xs'
        open={questionDetailOpen}
        onClose={questionDetailHandleClickClose}
        scroll={questionDetailScroll}
        //PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Typography variant="h6" gutterBottom component="div">
            Question No - {quesDataCount}
          </Typography>
          <Typography component="th" scope="row" style={{ width: '100%', fontSize: '10px !important' }}>
            <span style={{ fontWeight: '550' }}>Question - </span>{selectedQuestion}
          </Typography>
        </DialogTitle>
        <DialogContent dividers={questionDetailScroll === 'paper'}>
          <DialogContentText
            id="risk-eval-type-scroll-dialog-description"
            tabIndex={-1}
          >
            <Grid container spacing={2}>
              {selectedQuesData.map((data) => {
                return (
                  <Grid item xs={12}>
                    <Box >
                      <Table size="small" aria-label="purchases">
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row" style={{ width: '80%' }}>
                              <Typography variant="h6" gutterBottom component="div">
                                Detail Weightings
                              </Typography>
                            </TableCell>
                            <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                              <Typography variant="h6" component="div">
                                Score
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      <Table size="small" aria-label="purchases">
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row" style={{ width: '80%' }}>
                              Questionnaire weighting
                            </TableCell>
                            <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                              <span >{data.questionScore}</span>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      {data.questionType === "Closeended" && (
                        <>
                          <Table size="small" aria-label="purchases">
                            <TableBody>
                              <TableRow>
                                <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                  <Typography variant="h6" gutterBottom component="div">
                                    Answers
                                  </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                  &nbsp;
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <Table size="small" aria-label="purchases">
                            <TableBody>
                              {data.answers.answerMethod.name != "" && data.answers.answerList.length > 0 && data.answers.answerList.map((item) => {
                                //var riskLvlColor = getRiskLvlColor(item.riskLevel)
                                return (
                                  <>
                                    <TableRow>
                                      <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                        <span >{item.answerName}</span>
                                      </TableCell>
                                      <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                        <span>{item.riskLevel}</span>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </>
                      )}
                      {data.questionType === "Closeended" && (
                        <Table size="small" aria-label="purchases">
                          <TableBody>
                            {data.answers.answerMethod.name != "" && data.answers.answerList.length > 0 && data.answers.answerList.map((item) => {
                              //var riskLvlColor = getRiskLvlColor(item.riskLevel)
                              if (item.expectedAnswerName != "") {
                                return (
                                  <>
                                    <TableRow>
                                      <TableCell component="th" scope="row" style={{ width: '80%' }}>
                                        <span>
                                          {item.answerName}
                                        </span>
                                      </TableCell>
                                      <TableCell component="th" scope="row" style={{ width: '20%', paddingLeft: '0px !important', paddingRight: '0px !important' }} align="right">
                                        <span>{item.expectedAnswerName === "Yes" || item.expectedAnswerName === "checked" ? item.riskLevel : item.expectedAnswerName}</span>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                )
                              }
                            })}
                          </TableBody>
                        </Table>
                      )}
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={questionDetailHandleClickClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      {/** End of Question Details Show Dialog*/}



      {/** Edit Question */}
      <Dialog
        open={openQuestionEdit}
        onClose={false}
        scroll={openQuestionEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit Question - "{selectedQuestionName}"
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenQuestionEdit(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openQuestionEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AddQuestionComponent
                  fromUploadPage={'OK'}
                  questionIdFromUploadPage={selectedQuestionId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQuestionEdit(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>




      {/** Add  Risk Hirarchies to Register */}
      <Dialog
        open={openRiskHierarchyComponent}
        onClose={false}
        scroll={openRiskHierarchyComponentScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Add Risk Hierarchy to - "{selectedRegisteredName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRiskHierarchyComponent(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRiskHierarchyComponentScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <DMGRiskGptComponent3
                  createdRegisterName={selectedRegisteredName}
                  createdRegisterId={selectedRegisteredId}
                  createdRegisterDescription={selectedRegisteredDescription}
                  createdRiskHierarchyId={createdRiskHierarchyIdFromComp}
                  setCreatedRiskHierarchyId={setCreatedRiskHierarchyIdFromComp}
                  selectedRegisterDataObj={selectedRegisterDataObj}
                  selectedRiskGPTSessionId={selectedRiskGPTSessionId}

                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleOpenRiskHierarchyComponentClose()}>Close</Button>
          {/*<Button onClick={() => addRiskHierarchyFunction()}>Add Hierarchy</Button>*/}
        </DialogActions>
      </Dialog>



      {/** Finalise Register */}
      <Dialog
        open={openRegisterFinalise}
        onClose={false}
        scroll={openRegisterFinaliseScroll}
        aria-labelledby="register-data-dialog-title"
        aria-describedby="register-data-dialog-description"
        fullWidth={true}
        maxWidth={maxWidthState}
        fullScreen={fullScreenState}
      //PaperComponent={PaperComponentCollectionDataRegister}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Finalise "{selectedRegisterFinaliseTitle}" - <SavePageAs /></Typography>
          <Typography variant="h6" style={{ marginRight: '-22px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={registerFinaliseClose} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterFinaliseScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FinaliseRegisterComponent
                  colorPatterns={colorPatterns}
                  registerTypeData={selectedRegisterFinaliseObj}
                  registerTypeDataOrg={selectedRegisterFinaliseObj}
                  openRegisterDataForEvalScroll={openRegisterFinaliseScroll}
                  registerEvaluate={true}
                  registerTypeDataForEvalOrg={selectedRegisterFinaliseObjOrg}
                  createdUserId={globalUserId}
                  createdUserIpAddress={ipAddress}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={registerFinaliseClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHaDetails}
        //TransitionComponent={Transition}
        keepMounted
        onClose={haDetailshandleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogTitle>{rHName}</DialogTitle>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Button variant="contained"
                  onClick={evaluateRiskFuction}
                  style={{ height: '50px', float: 'right' }}>Evaluate</Button>
              </Grid>

              <Grid item xs={4}>
                <Button variant="contained"
                  onClick={handleButtonShowQuestion}
                  style={{ height: '50px' }}>Show Questions</Button>
              </Grid>
              <Grid item xs={4}>
                <Button variant="contained"
                  onClick={() => setShowEditMoreInfo(true)}
                  style={{ height: '50px', width:'95%' }}>show / edit more info</Button>
              </Grid>

            </Grid>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={haDetailshandleClose}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* create collection dialog */}

      <Dialog open={openConfirmationDialog} onClose={handleConfirmationDialogClose}>
        <DialogContent>
          <DialogContentText>
            Do you want to create a risk collection using {registerNameForCreateCollection}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationDialogClose} color="primary">
            No
          </Button>
          <Button onClick={handleYesClick} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openTextFieldDialog} onClose={handleTextFieldDialogClose}>
        <DialogTitle>Create Risk Collection using {registerNameForCreateCollection}</DialogTitle>
        <DialogContent>

          <Grid item xs={12}>
            <Box component="form"
              sx={{
                '& > :not(style)': { m: 1, width: '70ch' },
              }}
              noValidate
              autoComplete="off">
              <TextField
                label="Collection Title"
                variant="outlined"
                value={collectionTitle}
                onChange={handleCollectionTitle}

              />
              <TextField
                label="Collection Description"
                variant="outlined"
                value={collectionDescription}
                onChange={handleCollectionDescription}
              />
            </Box>

          </Grid>

          {/* <Grid item xs={6}>
                        <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">

                        </Box>

                      </Grid> */}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleTextFieldDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={() => saveCollection()} color="primary">
            create
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={riskStandardOpen}
        onClose={handleCloseStandardDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Which standard do you want to use"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>

              <Box sx={{ minWidth: 120, marginTop: '10px' }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for Objectives</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForObjective}
                    onChange={handleChangeGlobalStandardDataForObjective}

                  >
                    {globalStandardData.filter(com => com.objectives.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>


            </Grid>

            <Grid item xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for Component</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForComponent}
                    onChange={handleChangeGlobalStandardDataForComponent}

                  >
                    {globalStandardData.filter(com => com.components.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>


            </Grid>

            <Grid item xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Global Standard for principle</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select From Global Standaed"
                    value={globalStandardDataForPrinciple}
                    onChange={handleChangeGlobalStandardDataForPrinciple}

                  >
                    {globalStandardData.filter(com => com.principles.length > 0).map((item) => (
                      <MenuItem
                        value={item.standardName}
                      >
                        {item.standardName}
                      </MenuItem>
                    ))}

                  </Select>

                </FormControl>
              </Box>


            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={sendToDataBaseH}>Confirm</Button>
          <Button onClick={handleStandardDialogClear}>Clear</Button>
          <Button onClick={handleCloseStandardDialog}>close</Button>
        </DialogActions>
      </Dialog>


      {/** Schema dialy to  */}
         <Dialog
       open={openAllSchemadiaplay}
       onClose={handleCloseAllSchemadiaplay}
       maxWidth="md"
       fullWidth
     >
       <DialogTitle sx={{ textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
         <Typography variant="h5" component="div">
           Risk Register Schema Selection
         </Typography>
         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
           Choose how you want to create your risk register
         </Typography>
       </DialogTitle>
       
       <DialogContent sx={{ mt: 2 }}>
         <Grid container spacing={3}>
           {/* Left Section - Standard Schema Selection */}
           <Grid item xs={12} md={6}>
             <Paper 
               elevation={3} 
               sx={{ 
                 p: 3, 
                 height: '100%',
                 display: 'flex',
                 flexDirection: 'column',
                 border: '1px solid #e0e0e0'
               }}
             >
               <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                 <AssignmentIcon sx={{ mr: 1, color: 'primary.main' }} />
                 <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                   Standard Schema
                 </Typography>
               </Box>
               
               <Typography variant="body2" color="text.secondary" paragraph>
                 Which Schema do you want to use?
               </Typography>
               
               <FormControl fullWidth variant="outlined" size="small" sx={{ mb: 2 }}>
                 <InputLabel id="schema-select-label">Select a Schema</InputLabel>
                 <Select
                   labelId="schema-select-label"
                   id="schema-select"
                   label="Select a Schema"
                   value={schemaName}
                   onChange={handleChangeSchemaName}
                 >
                   {allAvailableRiskSchemas.map((item) => (
                     <MenuItem key={item.id} value={item.id}>
                       {item.name}
                     </MenuItem>
                   ))}
                 </Select>
               </FormControl>
               
               <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                 <Button 
                   variant="contained" 
                   onClick={() => validateSchemaAndCreateRegister(1, "", "")}
                   disabled={!schemaName}
                 >
                   Create with Standard Schema
                 </Button>
               </Box>
             </Paper>
           </Grid>
           
           {/* Right Section - Strict Schema Validation */}
           <Grid item xs={12} md={6}>
             <Paper 
               elevation={3} 
               sx={{ 
                 p: 3, 
                 height: '100%',
                 display: 'flex',
                 flexDirection: 'column',
                 bgcolor: '#e3f2fd',
                 border: '2px solid #1976d2'
               }}
             >
               <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                 <VerifiedIcon sx={{ mr: 1, color: 'secondary.main' }} />
                 <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'secondary.main' }}>
                   Strict Schema Validation
                 </Typography>
               </Box>
               
               <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                 Please use the Strict Schema validation to Create Register
               </Typography>
               
               <Typography variant="body2" color="text.secondary" paragraph>
                 This option ensures:
               </Typography>
               
               <Box component="ul" sx={{ mt: 0, pl: 2, color: 'text.secondary', fontSize: '0.875rem' }}>
                 <li>✓ Complete data validation</li>
                 <li>✓ Type-safe risk assessment</li>
                 <li>✓ Automatic risk level calculation</li>
                 <li>✓ Schema compliance guarantee</li>
               </Box>
               
               <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                 <Button 
                   variant="contained" 
                   color="secondary"
                   onClick={() => validateSchemaAndCreateRegister(3, "", "")}
                   sx={{ mt: 2 }}
                 >
                   Create with Strict Schema
                 </Button>
               </Box>
             </Paper>
           </Grid>
         </Grid>
       </DialogContent>
       
       <DialogActions sx={{ justifyContent: 'center', p: 2, borderTop: '1px solid #e0e0e0' }}>
         <Button onClick={handleCloseAllSchemadiaplay} variant="outlined">
           Cancel
         </Button>
       </DialogActions>
     </Dialog>

      {/** Redo register with sections and number of risk Hirerchies */}
      <Dialog
        open={openRegisterForRedo}
        onClose={false}
        scroll={openRegisterForRedoScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Re-Enter Sections and number of Risk Hierarchies per a section
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRegisterForRedo(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterForRedoScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div>Register Sections (Separate With ;) *</div>
                <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                                  {/** 
                                  <TextField
                                    variant="outlined"
                                    value={redoSectionHeadingName}
                                    onChange={handleChangeSectionHeadingName}
                                    focused={true}
                                  />
                                  */}

<textarea
                name="redoSectionHeadingName"
                value={redoSectionHeadingName}
                onChange={handleChangeSectionHeadingName}
                rows={3}
                style={{ width: "100%" }}
                focused={true}
              />
                  
                  
                </Box>
              </Grid>
              <Grid item xs={6}>
                <div>Risk hierarchies per a section *</div>
                <Box
                  component="form"
                  sx={{ "& .MuiTextField-root": { width: "60%" } }}
                  validate
                  autoComplete="off"
                >
                  <div>
                    <TextField
                      id="riskHierarchyCount"
                      size="small"
                      required
                      name="riskHierarchyCount"
                      value={redoRiskHierarchies}
                      onChange={handleChangeRiskHierarchies}
                    />
                  </div>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Button variant="contained" onClick={() => validateSchemaAndCreateRegisterRedo()} style={{ height: '35px', float: 'right', marginTop: '16px' }}>Create Register Again</Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRegisterForRedo(false)}>Close</Button>
        </DialogActions>
      </Dialog>


{/** Risk Gpt register create Methods */}
<Dialog
        open={openDisplayResearchChoice}
        onClose={handleCloseDisplayResearchChoice}>
        <DialogTitle>
          Select the Options to Re-do
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            How do you want to re-do the Register
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>&nbsp;</Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                component="label"
                onClick={() => openRiskGptFunction()}
                className='btnFonts'
                style={{ float: 'right' }}
              >
                Research & Re-do
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                component="label"
                onClick={() => startAgainFuction2()}
                className='btnFonts'
                style={{ minWidth: '160px' }}
              >
                Re-do
              </Button>
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisplayResearchChoice}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openRiskGpt}
        onClose={false}
        scroll={openRiskGptScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Re-do Register Using RiskGpt
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRiskGpt(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRiskGptScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>

              <Grid item xs={12} style={{ height: '400px', overflowY: 'scroll' }}>
                <Grid container spacing={1}>
                  {/**{gptTextArray.slice().reverse().map((item) => ( */}
                  {gptTextArray.map((item) => (
                    <>
                      <Grid item xs={1}>
                        <BootstrapTooltip title='Risk GPT'>
                          <Avatar sx={{ bgcolor: green[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                            <span className={wordstyle}>Q</span>
                          </Avatar>
                        </BootstrapTooltip>
                      </Grid>
                      <Grid item xs={11} style={{ backgroundColor: 'rgba(244,244,244)', borderRadius: '14px' }}>
                        {item.question}

                      </Grid>
                      <Grid item xs={1}>
                        <BootstrapTooltip title='Risk GPT'>
                          <Avatar sx={{ bgcolor: red[500], height: '25px', width: '25px', fontSize: '1.0rem !important' }} variant="square">
                            <span className={wordstyle}>A</span>
                          </Avatar>
                        </BootstrapTooltip>
                      </Grid>
                      <Grid item xs={11}>

                        {/**<span style={{fontSize: '1rem', fontFamily: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Helvetica,Apple Color Emoji,Arial,Segoe UI Emoji,Segoe UI Symbol'}}>{parseHtml(item.answer.replaceAll('\n', '<br>'))}</span>**/}
                        <span style={{ fontSize: '1rem', fontFamily: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Helvetica,Apple Color Emoji,Arial,Segoe UI Emoji,Segoe UI Symbol' }}>{formatContent(item.answer)}</span>

                      </Grid>
                    </>
                  ))}



                </Grid>


              </Grid>
              <Grid item xs={11}>
                <Box component="form" sx={{ '& .MuiTextField-root': { width: '100%' }, }} noValidate autoComplete="off">
                  <textarea
                    placeholder="Type Your Message here..."
                    variant="outlined"
                    value={gptText}
                    id='gptText'
                    rows={3}
                    style={{ width: "100%" }}
                    onChange={handleChangeGptText}
                  />
                </Box>
              </Grid>
              <Grid item xs={1}>

                <Button
                  id={'btnSend'}
                  variant="contained"
                  onClick={() => {
                    sentToChatGtp()
                  }}
                  //style={{ height: '55px', width: '40px', borderRadius: '50%', color: 'black', backgroundColor: 'aliceblue'  }}
                  sx={{
                    height: "55px",
                    width: "40px",
                    borderRadius: "50%",
                    color: "black",
                    backgroundColor: "aliceblue",
                    "&:hover": {
                      backgroundColor: "#8a8181",
                      color: "white",
                    },
                  }}
                >
                  <ArrowUpward />
                </Button>
              </Grid>


            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {gptTextArray.length > 0 ?
            <>
              <Button
                onClick={saveTheResult}
              >
                Save the Latest Result in PDF format
              </Button>
              &nbsp;&nbsp;
              <Button
                onClick={saveTheResult1}
              >
                Save the Latest Result in WORD(DOC) format
              </Button>
            </>
            :
            ''
          }
          <Button
            onClick={() => startAgainFuction3()}
          >
            Re-do Register Using the Above Information
          </Button>
          <Button onClick={() => setOpenRiskGpt(false)}>Close</Button>


        </DialogActions>
      </Dialog>

      <Dialog
        open={showEditMoreInfo}
        onClose={false}
        scroll={showEditMoreInfoScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Show / Edit more Information For "{rHName}"
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setShowEditMoreInfo(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={showEditMoreInfoScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>

              <Grid item xs={12} style={{ overflowY: 'scroll' }}>
                <RiskRegisterForMoreInfo selectedRegisteredId={selectedRegisteredId}/>


              </Grid>



            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

  
          <Button onClick={() => showEditMoreInfoClose(false)}>Close</Button>


        </DialogActions>
      </Dialog>


    </>
  )
}

export default DmgRiskGpt3
